webpackJsonp([1],{

/***/ 700:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Email_AccountEmailUpdate_AccountEmailUpdate__ = __webpack_require__(839);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "AccountEmailUpdate", function() { return __WEBPACK_IMPORTED_MODULE_0__Email_AccountEmailUpdate_AccountEmailUpdate__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Email_AccountEmailUnverified_AccountEmailUnverified__ = __webpack_require__(843);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "AccountEmailUnverified", function() { return __WEBPACK_IMPORTED_MODULE_1__Email_AccountEmailUnverified_AccountEmailUnverified__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ForgotPassword_AccountForgotPassword_AccountForgotPassword__ = __webpack_require__(846);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "AccountForgotPassword", function() { return __WEBPACK_IMPORTED_MODULE_2__ForgotPassword_AccountForgotPassword_AccountForgotPassword__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ForgotPassword_AccountForgotPasswordOtp_AccountForgotPasswordOtp__ = __webpack_require__(850);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "AccountForgotPasswordOtp", function() { return __WEBPACK_IMPORTED_MODULE_3__ForgotPassword_AccountForgotPasswordOtp_AccountForgotPasswordOtp__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Kyc_AccountKycOverview_AccountKycOverview__ = __webpack_require__(854);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "AccountKycOverview", function() { return __WEBPACK_IMPORTED_MODULE_4__Kyc_AccountKycOverview_AccountKycOverview__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Kyc_AccountKycRegister_AccountKycRegister__ = __webpack_require__(857);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "AccountKycRegister", function() { return __WEBPACK_IMPORTED_MODULE_5__Kyc_AccountKycRegister_AccountKycRegister__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Kyc_AccountKycUploadDocument_AccountKycUploadDocument__ = __webpack_require__(861);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "AccountKycUploadDocument", function() { return __WEBPACK_IMPORTED_MODULE_6__Kyc_AccountKycUploadDocument_AccountKycUploadDocument__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Login_AccountLogin_AccountLogin__ = __webpack_require__(865);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "AccountLogin", function() { return __WEBPACK_IMPORTED_MODULE_7__Login_AccountLogin_AccountLogin__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Password_AccountPasswordUpdate_AccountPasswordUpdate__ = __webpack_require__(869);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "AccountPasswordUpdate", function() { return __WEBPACK_IMPORTED_MODULE_8__Password_AccountPasswordUpdate_AccountPasswordUpdate__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Phone_AccountPhoneDetail_AccountPhoneDetail__ = __webpack_require__(873);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "AccountPhoneDetail", function() { return __WEBPACK_IMPORTED_MODULE_9__Phone_AccountPhoneDetail_AccountPhoneDetail__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Phone_AccountPhoneSet_AccountPhoneSet__ = __webpack_require__(876);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "AccountPhoneSet", function() { return __WEBPACK_IMPORTED_MODULE_10__Phone_AccountPhoneSet_AccountPhoneSet__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Phone_AccountPhoneSetOtp_AccountPhoneSetOtp__ = __webpack_require__(880);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "AccountPhoneSetOtp", function() { return __WEBPACK_IMPORTED_MODULE_11__Phone_AccountPhoneSetOtp_AccountPhoneSetOtp__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Profile_AccountProfile_AccountProfile__ = __webpack_require__(883);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "AccountProfile", function() { return __WEBPACK_IMPORTED_MODULE_12__Profile_AccountProfile_AccountProfile__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Register_AccountRegister_AccountRegister__ = __webpack_require__(886);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "AccountRegister", function() { return __WEBPACK_IMPORTED_MODULE_13__Register_AccountRegister_AccountRegister__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Register_AccountRegisterOtp_AccountRegisterOtp__ = __webpack_require__(890);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "AccountRegisterOtp", function() { return __WEBPACK_IMPORTED_MODULE_14__Register_AccountRegisterOtp_AccountRegisterOtp__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__Store_AccountStoreRegister_AccountStoreRegister__ = __webpack_require__(893);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "AccountStoreRegister", function() { return __WEBPACK_IMPORTED_MODULE_15__Store_AccountStoreRegister_AccountStoreRegister__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__Store_AccountStoreUpdate_AccountStoreUpdate__ = __webpack_require__(900);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "AccountStoreUpdate", function() { return __WEBPACK_IMPORTED_MODULE_16__Store_AccountStoreUpdate_AccountStoreUpdate__["a"]; });



















/***/ }),

/***/ 708:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FieldFile; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return FieldFileCard; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return FieldSelect; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return FieldText; });
/* unused harmony export FieldTextarea */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_form__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__InputFile_InputFile__ = __webpack_require__(722);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_1__InputFile_InputFile__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__InputFileCard_InputFileCard__ = __webpack_require__(728);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_2__InputFileCard_InputFileCard__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__InputOtp_InputOtp__ = __webpack_require__(731);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_3__InputOtp_InputOtp__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__InputSelect_InputSelect__ = __webpack_require__(734);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_4__InputSelect_InputSelect__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__InputText_InputText__ = __webpack_require__(745);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_5__InputText_InputText__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__InputTextarea_InputTextarea__ = __webpack_require__(749);
/* unused harmony reexport InputTextarea */







var FieldFile = __WEBPACK_IMPORTED_MODULE_0_redux_form__["a" /* Field */];
var FieldFileCard = __WEBPACK_IMPORTED_MODULE_0_redux_form__["a" /* Field */];
var FieldSelect = __WEBPACK_IMPORTED_MODULE_0_redux_form__["a" /* Field */];
var FieldText = __WEBPACK_IMPORTED_MODULE_0_redux_form__["a" /* Field */];
var FieldTextarea = __WEBPACK_IMPORTED_MODULE_0_redux_form__["a" /* Field */];


/***/ }),

/***/ 709:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Form__ = __webpack_require__(719);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Form__["a"]; });



/***/ }),

/***/ 710:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = __webpack_require__(122);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactInputAutosize = __webpack_require__(736);

var _reactInputAutosize2 = _interopRequireDefault(_reactInputAutosize);

var _classnames = __webpack_require__(9);

var _classnames2 = _interopRequireDefault(_classnames);

var _defaultArrowRenderer = __webpack_require__(737);

var _defaultArrowRenderer2 = _interopRequireDefault(_defaultArrowRenderer);

var _defaultFilterOptions = __webpack_require__(712);

var _defaultFilterOptions2 = _interopRequireDefault(_defaultFilterOptions);

var _defaultMenuRenderer = __webpack_require__(714);

var _defaultMenuRenderer2 = _interopRequireDefault(_defaultMenuRenderer);

var _defaultClearRenderer = __webpack_require__(738);

var _defaultClearRenderer2 = _interopRequireDefault(_defaultClearRenderer);

var _Option = __webpack_require__(739);

var _Option2 = _interopRequireDefault(_Option);

var _Value = __webpack_require__(715);

var _Value2 = _interopRequireDefault(_Value);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*!
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                 Copyright (c) 2017 Jed Watson.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                 Licensed under the MIT License (MIT), see
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                 http://jedwatson.github.io/react-select
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               */


var stringifyValue = function stringifyValue(value) {
	return typeof value === 'string' ? value : value !== null && JSON.stringify(value) || '';
};

var stringOrNode = _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.node]);

var instanceId = 1;

var Select = function (_React$Component) {
	_inherits(Select, _React$Component);

	function Select(props) {
		_classCallCheck(this, Select);

		var _this = _possibleConstructorReturn(this, (Select.__proto__ || Object.getPrototypeOf(Select)).call(this, props));

		['clearValue', 'focusOption', 'handleInputBlur', 'handleInputChange', 'handleInputFocus', 'handleInputValueChange', 'handleKeyDown', 'handleMenuScroll', 'handleMouseDown', 'handleMouseDownOnArrow', 'handleMouseDownOnMenu', 'handleRequired', 'handleTouchOutside', 'handleTouchMove', 'handleTouchStart', 'handleTouchEnd', 'handleTouchEndClearValue', 'handleValueClick', 'getOptionLabel', 'onOptionRef', 'removeValue', 'selectValue'].forEach(function (fn) {
			return _this[fn] = _this[fn].bind(_this);
		});

		_this.state = {
			inputValue: '',
			isFocused: false,
			isOpen: false,
			isPseudoFocused: false,
			required: false
		};
		return _this;
	}

	_createClass(Select, [{
		key: 'componentWillMount',
		value: function componentWillMount() {
			this._instancePrefix = 'react-select-' + (this.props.instanceId || ++instanceId) + '-';
			var valueArray = this.getValueArray(this.props.value);

			if (this.props.required) {
				this.setState({
					required: this.handleRequired(valueArray[0], this.props.multi)
				});
			}
		}
	}, {
		key: 'componentDidMount',
		value: function componentDidMount() {
			if (this.props.autofocus) {
				this.focus();
			}
		}
	}, {
		key: 'componentWillReceiveProps',
		value: function componentWillReceiveProps(nextProps) {
			var valueArray = this.getValueArray(nextProps.value, nextProps);

			if (nextProps.required) {
				this.setState({
					required: this.handleRequired(valueArray[0], nextProps.multi)
				});
			} else if (this.props.required) {
				// Used to be required but it's not any more
				this.setState({ required: false });
			}
		}
	}, {
		key: 'componentWillUpdate',
		value: function componentWillUpdate(nextProps, nextState) {
			if (nextState.isOpen !== this.state.isOpen) {
				this.toggleTouchOutsideEvent(nextState.isOpen);
				var handler = nextState.isOpen ? nextProps.onOpen : nextProps.onClose;
				handler && handler();
			}
		}
	}, {
		key: 'componentDidUpdate',
		value: function componentDidUpdate(prevProps, prevState) {
			// focus to the selected option
			if (this.menu && this.focused && this.state.isOpen && !this.hasScrolledToOption) {
				var focusedOptionNode = _reactDom2.default.findDOMNode(this.focused);
				var menuNode = _reactDom2.default.findDOMNode(this.menu);
				menuNode.scrollTop = focusedOptionNode.offsetTop;
				this.hasScrolledToOption = true;
			} else if (!this.state.isOpen) {
				this.hasScrolledToOption = false;
			}

			if (this._scrollToFocusedOptionOnUpdate && this.focused && this.menu) {
				this._scrollToFocusedOptionOnUpdate = false;
				var focusedDOM = _reactDom2.default.findDOMNode(this.focused);
				var menuDOM = _reactDom2.default.findDOMNode(this.menu);
				var focusedRect = focusedDOM.getBoundingClientRect();
				var menuRect = menuDOM.getBoundingClientRect();
				if (focusedRect.bottom > menuRect.bottom) {
					menuDOM.scrollTop = focusedDOM.offsetTop + focusedDOM.clientHeight - menuDOM.offsetHeight;
				} else if (focusedRect.top < menuRect.top) {
					menuDOM.scrollTop = focusedDOM.offsetTop;
				}
			}
			if (this.props.scrollMenuIntoView && this.menuContainer) {
				var menuContainerRect = this.menuContainer.getBoundingClientRect();
				if (window.innerHeight < menuContainerRect.bottom + this.props.menuBuffer) {
					window.scrollBy(0, menuContainerRect.bottom + this.props.menuBuffer - window.innerHeight);
				}
			}
			if (prevProps.disabled !== this.props.disabled) {
				this.setState({ isFocused: false }); // eslint-disable-line react/no-did-update-set-state
				this.closeMenu();
			}
		}
	}, {
		key: 'componentWillUnmount',
		value: function componentWillUnmount() {
			if (!document.removeEventListener && document.detachEvent) {
				document.detachEvent('ontouchstart', this.handleTouchOutside);
			} else {
				document.removeEventListener('touchstart', this.handleTouchOutside);
			}
		}
	}, {
		key: 'toggleTouchOutsideEvent',
		value: function toggleTouchOutsideEvent(enabled) {
			if (enabled) {
				if (!document.addEventListener && document.attachEvent) {
					document.attachEvent('ontouchstart', this.handleTouchOutside);
				} else {
					document.addEventListener('touchstart', this.handleTouchOutside);
				}
			} else {
				if (!document.removeEventListener && document.detachEvent) {
					document.detachEvent('ontouchstart', this.handleTouchOutside);
				} else {
					document.removeEventListener('touchstart', this.handleTouchOutside);
				}
			}
		}
	}, {
		key: 'handleTouchOutside',
		value: function handleTouchOutside(event) {
			// handle touch outside on ios to dismiss menu
			if (this.wrapper && !this.wrapper.contains(event.target)) {
				this.closeMenu();
			}
		}
	}, {
		key: 'focus',
		value: function focus() {
			if (!this.input) return;
			this.input.focus();
		}
	}, {
		key: 'blurInput',
		value: function blurInput() {
			if (!this.input) return;
			this.input.blur();
		}
	}, {
		key: 'handleTouchMove',
		value: function handleTouchMove(event) {
			// Set a flag that the view is being dragged
			this.dragging = true;
		}
	}, {
		key: 'handleTouchStart',
		value: function handleTouchStart(event) {
			// Set a flag that the view is not being dragged
			this.dragging = false;
		}
	}, {
		key: 'handleTouchEnd',
		value: function handleTouchEnd(event) {
			// Check if the view is being dragged, In this case
			// we don't want to fire the click event (because the user only wants to scroll)
			if (this.dragging) return;

			// Fire the mouse events
			this.handleMouseDown(event);
		}
	}, {
		key: 'handleTouchEndClearValue',
		value: function handleTouchEndClearValue(event) {
			// Check if the view is being dragged, In this case
			// we don't want to fire the click event (because the user only wants to scroll)
			if (this.dragging) return;

			// Clear the value
			this.clearValue(event);
		}
	}, {
		key: 'handleMouseDown',
		value: function handleMouseDown(event) {
			// if the event was triggered by a mousedown and not the primary
			// button, or if the component is disabled, ignore it.
			if (this.props.disabled || event.type === 'mousedown' && event.button !== 0) {
				return;
			}

			if (event.target.tagName === 'INPUT') {
				return;
			}

			// prevent default event handlers
			event.stopPropagation();
			event.preventDefault();

			// for the non-searchable select, toggle the menu
			if (!this.props.searchable) {
				// TODO: This code means that if a select is searchable, onClick the options menu will not appear, only on subsequent click will it open.
				this.focus();
				return this.setState({
					isOpen: !this.state.isOpen
				});
			}

			if (this.state.isFocused) {
				// On iOS, we can get into a state where we think the input is focused but it isn't really,
				// since iOS ignores programmatic calls to input.focus() that weren't triggered by a click event.
				// Call focus() again here to be safe.
				this.focus();

				var input = this.input;
				if (typeof input.getInput === 'function') {
					// Get the actual DOM input if the ref is an <AutosizeInput /> component
					input = input.getInput();
				}

				// clears the value so that the cursor will be at the end of input when the component re-renders
				input.value = '';

				// if the input is focused, ensure the menu is open
				this.setState({
					isOpen: true,
					isPseudoFocused: false
				});
			} else {
				// otherwise, focus the input and open the menu
				this._openAfterFocus = this.props.openOnClick;
				this.focus();
			}
		}
	}, {
		key: 'handleMouseDownOnArrow',
		value: function handleMouseDownOnArrow(event) {
			// if the event was triggered by a mousedown and not the primary
			// button, or if the component is disabled, ignore it.
			if (this.props.disabled || event.type === 'mousedown' && event.button !== 0) {
				return;
			}
			// If the menu isn't open, let the event bubble to the main handleMouseDown
			if (!this.state.isOpen) {
				return;
			}
			// prevent default event handlers
			event.stopPropagation();
			event.preventDefault();
			// close the menu
			this.closeMenu();
		}
	}, {
		key: 'handleMouseDownOnMenu',
		value: function handleMouseDownOnMenu(event) {
			// if the event was triggered by a mousedown and not the primary
			// button, or if the component is disabled, ignore it.
			if (this.props.disabled || event.type === 'mousedown' && event.button !== 0) {
				return;
			}
			event.stopPropagation();
			event.preventDefault();

			this._openAfterFocus = true;
			this.focus();
		}
	}, {
		key: 'closeMenu',
		value: function closeMenu() {
			if (this.props.onCloseResetsInput) {
				this.setState({
					isOpen: false,
					isPseudoFocused: this.state.isFocused && !this.props.multi,
					inputValue: this.handleInputValueChange('')
				});
			} else {
				this.setState({
					isOpen: false,
					isPseudoFocused: this.state.isFocused && !this.props.multi
				});
			}
			this.hasScrolledToOption = false;
		}
	}, {
		key: 'handleInputFocus',
		value: function handleInputFocus(event) {
			if (this.props.disabled) return;
			var isOpen = this.state.isOpen || this._openAfterFocus || this.props.openOnFocus;
			if (this.props.onFocus) {
				this.props.onFocus(event);
			}
			this.setState({
				isFocused: true,
				isOpen: isOpen
			});
			this._openAfterFocus = false;
		}
	}, {
		key: 'handleInputBlur',
		value: function handleInputBlur(event) {
			// The check for menu.contains(activeElement) is necessary to prevent IE11's scrollbar from closing the menu in certain contexts.
			if (this.menu && (this.menu === document.activeElement || this.menu.contains(document.activeElement))) {
				this.focus();
				return;
			}

			if (this.props.onBlur) {
				this.props.onBlur(event);
			}
			var onBlurredState = {
				isFocused: false,
				isOpen: false,
				isPseudoFocused: false
			};
			if (this.props.onBlurResetsInput) {
				onBlurredState.inputValue = this.handleInputValueChange('');
			}
			this.setState(onBlurredState);
		}
	}, {
		key: 'handleInputChange',
		value: function handleInputChange(event) {
			var newInputValue = event.target.value;

			if (this.state.inputValue !== event.target.value) {
				newInputValue = this.handleInputValueChange(newInputValue);
			}

			this.setState({
				isOpen: true,
				isPseudoFocused: false,
				inputValue: newInputValue
			});
		}
	}, {
		key: 'handleInputValueChange',
		value: function handleInputValueChange(newValue) {
			if (this.props.onInputChange) {
				var nextState = this.props.onInputChange(newValue);
				// Note: != used deliberately here to catch undefined and null
				if (nextState != null && (typeof nextState === 'undefined' ? 'undefined' : _typeof(nextState)) !== 'object') {
					newValue = '' + nextState;
				}
			}
			return newValue;
		}
	}, {
		key: 'handleKeyDown',
		value: function handleKeyDown(event) {
			if (this.props.disabled) return;

			if (typeof this.props.onInputKeyDown === 'function') {
				this.props.onInputKeyDown(event);
				if (event.defaultPrevented) {
					return;
				}
			}

			switch (event.keyCode) {
				case 8:
					// backspace
					if (!this.state.inputValue && this.props.backspaceRemoves) {
						event.preventDefault();
						this.popValue();
					}
					return;
				case 9:
					// tab
					if (event.shiftKey || !this.state.isOpen || !this.props.tabSelectsValue) {
						return;
					}
					this.selectFocusedOption();
					return;
				case 13:
					// enter
					if (!this.state.isOpen) return;
					event.stopPropagation();
					this.selectFocusedOption();
					break;
				case 27:
					// escape
					if (this.state.isOpen) {
						this.closeMenu();
						event.stopPropagation();
					} else if (this.props.clearable && this.props.escapeClearsValue) {
						this.clearValue(event);
						event.stopPropagation();
					}
					break;
				case 38:
					// up
					this.focusPreviousOption();
					break;
				case 40:
					// down
					this.focusNextOption();
					break;
				case 33:
					// page up
					this.focusPageUpOption();
					break;
				case 34:
					// page down
					this.focusPageDownOption();
					break;
				case 35:
					// end key
					if (event.shiftKey) {
						return;
					}
					this.focusEndOption();
					break;
				case 36:
					// home key
					if (event.shiftKey) {
						return;
					}
					this.focusStartOption();
					break;
				case 46:
					// backspace
					if (!this.state.inputValue && this.props.deleteRemoves) {
						event.preventDefault();
						this.popValue();
					}
					return;
				default:
					return;
			}
			event.preventDefault();
		}
	}, {
		key: 'handleValueClick',
		value: function handleValueClick(option, event) {
			if (!this.props.onValueClick) return;
			this.props.onValueClick(option, event);
		}
	}, {
		key: 'handleMenuScroll',
		value: function handleMenuScroll(event) {
			if (!this.props.onMenuScrollToBottom) return;
			var target = event.target;

			if (target.scrollHeight > target.offsetHeight && target.scrollHeight - target.offsetHeight - target.scrollTop <= 0) {
				this.props.onMenuScrollToBottom();
			}
		}
	}, {
		key: 'handleRequired',
		value: function handleRequired(value, multi) {
			if (!value) return true;
			return multi ? value.length === 0 : Object.keys(value).length === 0;
		}
	}, {
		key: 'getOptionLabel',
		value: function getOptionLabel(op) {
			return op[this.props.labelKey];
		}

		/**
   * Turns a value into an array from the given options
   * @param	{String|Number|Array}	value		- the value of the select input
   * @param	{Object}		nextProps	- optionally specify the nextProps so the returned array uses the latest configuration
   * @returns	{Array}	the value of the select represented in an array
   */

	}, {
		key: 'getValueArray',
		value: function getValueArray(value, nextProps) {
			var _this2 = this;

			/** support optionally passing in the `nextProps` so `componentWillReceiveProps` updates will function as expected */
			var props = (typeof nextProps === 'undefined' ? 'undefined' : _typeof(nextProps)) === 'object' ? nextProps : this.props;
			if (props.multi) {
				if (typeof value === 'string') value = value.split(props.delimiter);
				if (!Array.isArray(value)) {
					if (value === null || value === undefined) return [];
					value = [value];
				}
				return value.map(function (value) {
					return _this2.expandValue(value, props);
				}).filter(function (i) {
					return i;
				});
			}
			var expandedValue = this.expandValue(value, props);
			return expandedValue ? [expandedValue] : [];
		}

		/**
   * Retrieve a value from the given options and valueKey
   * @param	{String|Number|Array}	value	- the selected value(s)
   * @param	{Object}		props	- the Select component's props (or nextProps)
   */

	}, {
		key: 'expandValue',
		value: function expandValue(value, props) {
			var valueType = typeof value === 'undefined' ? 'undefined' : _typeof(value);
			if (valueType !== 'string' && valueType !== 'number' && valueType !== 'boolean') return value;
			var options = props.options,
			    valueKey = props.valueKey;

			if (!options) return;
			for (var i = 0; i < options.length; i++) {
				if (options[i][valueKey] === value) return options[i];
			}
		}
	}, {
		key: 'setValue',
		value: function setValue(value) {
			var _this3 = this;

			if (this.props.autoBlur) {
				this.blurInput();
			}
			if (this.props.required) {
				var required = this.handleRequired(value, this.props.multi);
				this.setState({ required: required });
			}
			if (this.props.onChange) {
				if (this.props.simpleValue && value) {
					value = this.props.multi ? value.map(function (i) {
						return i[_this3.props.valueKey];
					}).join(this.props.delimiter) : value[this.props.valueKey];
				}
				this.props.onChange(value);
			}
		}
	}, {
		key: 'selectValue',
		value: function selectValue(value) {
			var _this4 = this;

			// NOTE: we actually add/set the value in a callback to make sure the
			// input value is empty to avoid styling issues in Chrome
			if (this.props.closeOnSelect) {
				this.hasScrolledToOption = false;
			}
			if (this.props.multi) {
				var updatedValue = this.props.onSelectResetsInput ? '' : this.state.inputValue;
				this.setState({
					focusedIndex: null,
					inputValue: this.handleInputValueChange(updatedValue),
					isOpen: !this.props.closeOnSelect
				}, function () {
					_this4.addValue(value);
				});
			} else {
				this.setState({
					inputValue: this.handleInputValueChange(''),
					isOpen: !this.props.closeOnSelect,
					isPseudoFocused: this.state.isFocused
				}, function () {
					_this4.setValue(value);
				});
			}
		}
	}, {
		key: 'addValue',
		value: function addValue(value) {
			var valueArray = this.getValueArray(this.props.value);
			var visibleOptions = this._visibleOptions.filter(function (val) {
				return !val.disabled;
			});
			var lastValueIndex = visibleOptions.indexOf(value);
			this.setValue(valueArray.concat(value));
			if (visibleOptions.length - 1 === lastValueIndex) {
				// the last option was selected; focus the second-last one
				this.focusOption(visibleOptions[lastValueIndex - 1]);
			} else if (visibleOptions.length > lastValueIndex) {
				// focus the option below the selected one
				this.focusOption(visibleOptions[lastValueIndex + 1]);
			}
		}
	}, {
		key: 'popValue',
		value: function popValue() {
			var valueArray = this.getValueArray(this.props.value);
			if (!valueArray.length) return;
			if (valueArray[valueArray.length - 1].clearableValue === false) return;
			this.setValue(this.props.multi ? valueArray.slice(0, valueArray.length - 1) : null);
		}
	}, {
		key: 'removeValue',
		value: function removeValue(value) {
			var valueArray = this.getValueArray(this.props.value);
			this.setValue(valueArray.filter(function (i) {
				return i !== value;
			}));
			this.focus();
		}
	}, {
		key: 'clearValue',
		value: function clearValue(event) {
			// if the event was triggered by a mousedown and not the primary
			// button, ignore it.
			if (event && event.type === 'mousedown' && event.button !== 0) {
				return;
			}
			event.stopPropagation();
			event.preventDefault();
			this.setValue(this.getResetValue());
			this.setState({
				isOpen: false,
				inputValue: this.handleInputValueChange('')
			}, this.focus);
		}
	}, {
		key: 'getResetValue',
		value: function getResetValue() {
			if (this.props.resetValue !== undefined) {
				return this.props.resetValue;
			} else if (this.props.multi) {
				return [];
			} else {
				return null;
			}
		}
	}, {
		key: 'focusOption',
		value: function focusOption(option) {
			this.setState({
				focusedOption: option
			});
		}
	}, {
		key: 'focusNextOption',
		value: function focusNextOption() {
			this.focusAdjacentOption('next');
		}
	}, {
		key: 'focusPreviousOption',
		value: function focusPreviousOption() {
			this.focusAdjacentOption('previous');
		}
	}, {
		key: 'focusPageUpOption',
		value: function focusPageUpOption() {
			this.focusAdjacentOption('page_up');
		}
	}, {
		key: 'focusPageDownOption',
		value: function focusPageDownOption() {
			this.focusAdjacentOption('page_down');
		}
	}, {
		key: 'focusStartOption',
		value: function focusStartOption() {
			this.focusAdjacentOption('start');
		}
	}, {
		key: 'focusEndOption',
		value: function focusEndOption() {
			this.focusAdjacentOption('end');
		}
	}, {
		key: 'focusAdjacentOption',
		value: function focusAdjacentOption(dir) {
			var options = this._visibleOptions.map(function (option, index) {
				return { option: option, index: index };
			}).filter(function (option) {
				return !option.option.disabled;
			});
			this._scrollToFocusedOptionOnUpdate = true;
			if (!this.state.isOpen) {
				this.setState({
					isOpen: true,
					inputValue: '',
					focusedOption: this._focusedOption || (options.length ? options[dir === 'next' ? 0 : options.length - 1].option : null)
				});
				return;
			}
			if (!options.length) return;
			var focusedIndex = -1;
			for (var i = 0; i < options.length; i++) {
				if (this._focusedOption === options[i].option) {
					focusedIndex = i;
					break;
				}
			}
			if (dir === 'next' && focusedIndex !== -1) {
				focusedIndex = (focusedIndex + 1) % options.length;
			} else if (dir === 'previous') {
				if (focusedIndex > 0) {
					focusedIndex = focusedIndex - 1;
				} else {
					focusedIndex = options.length - 1;
				}
			} else if (dir === 'start') {
				focusedIndex = 0;
			} else if (dir === 'end') {
				focusedIndex = options.length - 1;
			} else if (dir === 'page_up') {
				var potentialIndex = focusedIndex - this.props.pageSize;
				if (potentialIndex < 0) {
					focusedIndex = 0;
				} else {
					focusedIndex = potentialIndex;
				}
			} else if (dir === 'page_down') {
				var potentialIndex = focusedIndex + this.props.pageSize;
				if (potentialIndex > options.length - 1) {
					focusedIndex = options.length - 1;
				} else {
					focusedIndex = potentialIndex;
				}
			}

			if (focusedIndex === -1) {
				focusedIndex = 0;
			}

			this.setState({
				focusedIndex: options[focusedIndex].index,
				focusedOption: options[focusedIndex].option
			});
		}
	}, {
		key: 'getFocusedOption',
		value: function getFocusedOption() {
			return this._focusedOption;
		}
	}, {
		key: 'getInputValue',
		value: function getInputValue() {
			return this.state.inputValue;
		}
	}, {
		key: 'selectFocusedOption',
		value: function selectFocusedOption() {
			if (this._focusedOption) {
				return this.selectValue(this._focusedOption);
			}
		}
	}, {
		key: 'renderLoading',
		value: function renderLoading() {
			if (!this.props.isLoading) return;
			return _react2.default.createElement(
				'span',
				{ className: 'Select-loading-zone', 'aria-hidden': 'true' },
				_react2.default.createElement('span', { className: 'Select-loading' })
			);
		}
	}, {
		key: 'renderValue',
		value: function renderValue(valueArray, isOpen) {
			var _this5 = this;

			var renderLabel = this.props.valueRenderer || this.getOptionLabel;
			var ValueComponent = this.props.valueComponent;
			if (!valueArray.length) {
				return !this.state.inputValue ? _react2.default.createElement(
					'div',
					{ className: 'Select-placeholder' },
					this.props.placeholder
				) : null;
			}
			var onClick = this.props.onValueClick ? this.handleValueClick : null;
			if (this.props.multi) {
				return valueArray.map(function (value, i) {
					return _react2.default.createElement(
						ValueComponent,
						{
							id: _this5._instancePrefix + '-value-' + i,
							instancePrefix: _this5._instancePrefix,
							disabled: _this5.props.disabled || value.clearableValue === false,
							key: 'value-' + i + '-' + value[_this5.props.valueKey],
							onClick: onClick,
							onRemove: _this5.removeValue,
							value: value
						},
						renderLabel(value, i),
						_react2.default.createElement(
							'span',
							{ className: 'Select-aria-only' },
							'\xA0'
						)
					);
				});
			} else if (!this.state.inputValue) {
				if (isOpen) onClick = null;
				return _react2.default.createElement(
					ValueComponent,
					{
						id: this._instancePrefix + '-value-item',
						disabled: this.props.disabled,
						instancePrefix: this._instancePrefix,
						onClick: onClick,
						value: valueArray[0]
					},
					renderLabel(valueArray[0])
				);
			}
		}
	}, {
		key: 'renderInput',
		value: function renderInput(valueArray, focusedOptionIndex) {
			var _classNames,
			    _this6 = this;

			var className = (0, _classnames2.default)('Select-input', this.props.inputProps.className);
			var isOpen = !!this.state.isOpen;

			var ariaOwns = (0, _classnames2.default)((_classNames = {}, _defineProperty(_classNames, this._instancePrefix + '-list', isOpen), _defineProperty(_classNames, this._instancePrefix + '-backspace-remove-message', this.props.multi && !this.props.disabled && this.state.isFocused && !this.state.inputValue), _classNames));

			var inputProps = _extends({}, this.props.inputProps, {
				role: 'combobox',
				'aria-expanded': '' + isOpen,
				'aria-owns': ariaOwns,
				'aria-haspopup': '' + isOpen,
				'aria-activedescendant': isOpen ? this._instancePrefix + '-option-' + focusedOptionIndex : this._instancePrefix + '-value',
				'aria-describedby': this.props['aria-describedby'],
				'aria-labelledby': this.props['aria-labelledby'],
				'aria-label': this.props['aria-label'],
				className: className,
				tabIndex: this.props.tabIndex,
				onBlur: this.handleInputBlur,
				onChange: this.handleInputChange,
				onFocus: this.handleInputFocus,
				ref: function ref(_ref) {
					return _this6.input = _ref;
				},
				required: this.state.required,
				value: this.state.inputValue
			});

			if (this.props.inputRenderer) {
				return this.props.inputRenderer(inputProps);
			}

			if (this.props.disabled || !this.props.searchable) {
				var _props$inputProps = this.props.inputProps,
				    inputClassName = _props$inputProps.inputClassName,
				    divProps = _objectWithoutProperties(_props$inputProps, ['inputClassName']);

				var _ariaOwns = (0, _classnames2.default)(_defineProperty({}, this._instancePrefix + '-list', isOpen));

				return _react2.default.createElement('div', _extends({}, divProps, {
					role: 'combobox',
					'aria-expanded': isOpen,
					'aria-owns': _ariaOwns,
					'aria-activedescendant': isOpen ? this._instancePrefix + '-option-' + focusedOptionIndex : this._instancePrefix + '-value',
					className: className,
					tabIndex: this.props.tabIndex || 0,
					onBlur: this.handleInputBlur,
					onFocus: this.handleInputFocus,
					ref: function ref(_ref2) {
						return _this6.input = _ref2;
					},
					'aria-readonly': '' + !!this.props.disabled,
					style: { border: 0, width: 1, display: 'inline-block' } }));
			}

			if (this.props.autosize) {
				return _react2.default.createElement(_reactInputAutosize2.default, _extends({}, inputProps, { minWidth: '5' }));
			}
			return _react2.default.createElement(
				'div',
				{ className: className },
				_react2.default.createElement('input', inputProps)
			);
		}
	}, {
		key: 'renderClear',
		value: function renderClear() {
			if (!this.props.clearable || this.props.value === undefined || this.props.value === null || this.props.multi && !this.props.value.length || this.props.disabled || this.props.isLoading) return;
			var clear = this.props.clearRenderer();

			return _react2.default.createElement(
				'span',
				{ className: 'Select-clear-zone', title: this.props.multi ? this.props.clearAllText : this.props.clearValueText,
					'aria-label': this.props.multi ? this.props.clearAllText : this.props.clearValueText,
					onMouseDown: this.clearValue,
					onTouchStart: this.handleTouchStart,
					onTouchMove: this.handleTouchMove,
					onTouchEnd: this.handleTouchEndClearValue
				},
				clear
			);
		}
	}, {
		key: 'renderArrow',
		value: function renderArrow() {
			var onMouseDown = this.handleMouseDownOnArrow;
			var isOpen = this.state.isOpen;
			var arrow = this.props.arrowRenderer({ onMouseDown: onMouseDown, isOpen: isOpen });

			return _react2.default.createElement(
				'span',
				{
					className: 'Select-arrow-zone',
					onMouseDown: onMouseDown
				},
				arrow
			);
		}
	}, {
		key: 'filterOptions',
		value: function filterOptions(excludeOptions) {
			var filterValue = this.state.inputValue;
			var options = this.props.options || [];
			if (this.props.filterOptions) {
				// Maintain backwards compatibility with boolean attribute
				var filterOptions = typeof this.props.filterOptions === 'function' ? this.props.filterOptions : _defaultFilterOptions2.default;

				return filterOptions(options, filterValue, excludeOptions, {
					filterOption: this.props.filterOption,
					ignoreAccents: this.props.ignoreAccents,
					ignoreCase: this.props.ignoreCase,
					labelKey: this.props.labelKey,
					matchPos: this.props.matchPos,
					matchProp: this.props.matchProp,
					valueKey: this.props.valueKey
				});
			} else {
				return options;
			}
		}
	}, {
		key: 'onOptionRef',
		value: function onOptionRef(ref, isFocused) {
			if (isFocused) {
				this.focused = ref;
			}
		}
	}, {
		key: 'renderMenu',
		value: function renderMenu(options, valueArray, focusedOption) {
			if (options && options.length) {
				return this.props.menuRenderer({
					focusedOption: focusedOption,
					focusOption: this.focusOption,
					instancePrefix: this._instancePrefix,
					labelKey: this.props.labelKey,
					onFocus: this.focusOption,
					onSelect: this.selectValue,
					optionClassName: this.props.optionClassName,
					optionComponent: this.props.optionComponent,
					optionRenderer: this.props.optionRenderer || this.getOptionLabel,
					options: options,
					selectValue: this.selectValue,
					valueArray: valueArray,
					valueKey: this.props.valueKey,
					onOptionRef: this.onOptionRef
				});
			} else if (this.props.noResultsText) {
				return _react2.default.createElement(
					'div',
					{ className: 'Select-noresults' },
					this.props.noResultsText
				);
			} else {
				return null;
			}
		}
	}, {
		key: 'renderHiddenField',
		value: function renderHiddenField(valueArray) {
			var _this7 = this;

			if (!this.props.name) return;
			if (this.props.joinValues) {
				var value = valueArray.map(function (i) {
					return stringifyValue(i[_this7.props.valueKey]);
				}).join(this.props.delimiter);
				return _react2.default.createElement('input', {
					type: 'hidden',
					ref: function ref(_ref3) {
						return _this7.value = _ref3;
					},
					name: this.props.name,
					value: value,
					disabled: this.props.disabled });
			}
			return valueArray.map(function (item, index) {
				return _react2.default.createElement('input', { key: 'hidden.' + index,
					type: 'hidden',
					ref: 'value' + index,
					name: _this7.props.name,
					value: stringifyValue(item[_this7.props.valueKey]),
					disabled: _this7.props.disabled });
			});
		}
	}, {
		key: 'getFocusableOptionIndex',
		value: function getFocusableOptionIndex(selectedOption) {
			var options = this._visibleOptions;
			if (!options.length) return null;

			var valueKey = this.props.valueKey;
			var focusedOption = this.state.focusedOption || selectedOption;
			if (focusedOption && !focusedOption.disabled) {
				var focusedOptionIndex = -1;
				options.some(function (option, index) {
					var isOptionEqual = option[valueKey] === focusedOption[valueKey];
					if (isOptionEqual) {
						focusedOptionIndex = index;
					}
					return isOptionEqual;
				});
				if (focusedOptionIndex !== -1) {
					return focusedOptionIndex;
				}
			}

			for (var i = 0; i < options.length; i++) {
				if (!options[i].disabled) return i;
			}
			return null;
		}
	}, {
		key: 'renderOuter',
		value: function renderOuter(options, valueArray, focusedOption) {
			var _this8 = this;

			var menu = this.renderMenu(options, valueArray, focusedOption);
			if (!menu) {
				return null;
			}

			return _react2.default.createElement(
				'div',
				{ ref: function ref(_ref5) {
						return _this8.menuContainer = _ref5;
					}, className: 'Select-menu-outer', style: this.props.menuContainerStyle },
				_react2.default.createElement(
					'div',
					{ ref: function ref(_ref4) {
							return _this8.menu = _ref4;
						}, role: 'listbox', tabIndex: -1, className: 'Select-menu', id: this._instancePrefix + '-list',
						style: this.props.menuStyle,
						onScroll: this.handleMenuScroll,
						onMouseDown: this.handleMouseDownOnMenu },
					menu
				)
			);
		}
	}, {
		key: 'render',
		value: function render() {
			var _this9 = this;

			var valueArray = this.getValueArray(this.props.value);
			var options = this._visibleOptions = this.filterOptions(this.props.multi ? this.getValueArray(this.props.value) : null);
			var isOpen = this.state.isOpen;
			if (this.props.multi && !options.length && valueArray.length && !this.state.inputValue) isOpen = false;
			var focusedOptionIndex = this.getFocusableOptionIndex(valueArray[0]);

			var focusedOption = null;
			if (focusedOptionIndex !== null) {
				focusedOption = this._focusedOption = options[focusedOptionIndex];
			} else {
				focusedOption = this._focusedOption = null;
			}
			var className = (0, _classnames2.default)('Select', this.props.className, {
				'Select--multi': this.props.multi,
				'Select--single': !this.props.multi,
				'is-clearable': this.props.clearable,
				'is-disabled': this.props.disabled,
				'is-focused': this.state.isFocused,
				'is-loading': this.props.isLoading,
				'is-open': isOpen,
				'is-pseudo-focused': this.state.isPseudoFocused,
				'is-searchable': this.props.searchable,
				'has-value': valueArray.length
			});

			var removeMessage = null;
			if (this.props.multi && !this.props.disabled && valueArray.length && !this.state.inputValue && this.state.isFocused && this.props.backspaceRemoves) {
				removeMessage = _react2.default.createElement(
					'span',
					{ id: this._instancePrefix + '-backspace-remove-message', className: 'Select-aria-only', 'aria-live': 'assertive' },
					this.props.backspaceToRemoveMessage.replace('{label}', valueArray[valueArray.length - 1][this.props.labelKey])
				);
			}

			return _react2.default.createElement(
				'div',
				{ ref: function ref(_ref7) {
						return _this9.wrapper = _ref7;
					},
					className: className,
					style: this.props.wrapperStyle },
				this.renderHiddenField(valueArray),
				_react2.default.createElement(
					'div',
					{ ref: function ref(_ref6) {
							return _this9.control = _ref6;
						},
						className: 'Select-control',
						style: this.props.style,
						onKeyDown: this.handleKeyDown,
						onMouseDown: this.handleMouseDown,
						onTouchEnd: this.handleTouchEnd,
						onTouchStart: this.handleTouchStart,
						onTouchMove: this.handleTouchMove
					},
					_react2.default.createElement(
						'span',
						{ className: 'Select-multi-value-wrapper', id: this._instancePrefix + '-value' },
						this.renderValue(valueArray, isOpen),
						this.renderInput(valueArray, focusedOptionIndex)
					),
					removeMessage,
					this.renderLoading(),
					this.renderClear(),
					this.renderArrow()
				),
				isOpen ? this.renderOuter(options, !this.props.multi ? valueArray : null, focusedOption) : null
			);
		}
	}]);

	return Select;
}(_react2.default.Component);

;

Select.propTypes = {
	'aria-describedby': _propTypes2.default.string, // HTML ID(s) of element(s) that should be used to describe this input (for assistive tech)
	'aria-label': _propTypes2.default.string, // Aria label (for assistive tech)
	'aria-labelledby': _propTypes2.default.string, // HTML ID of an element that should be used as the label (for assistive tech)
	addLabelText: _propTypes2.default.string, // placeholder displayed when you want to add a label on a multi-value input
	arrowRenderer: _propTypes2.default.func, // Create drop-down caret element
	autoBlur: _propTypes2.default.bool, // automatically blur the component when an option is selected
	autofocus: _propTypes2.default.bool, // autofocus the component on mount
	autosize: _propTypes2.default.bool, // whether to enable autosizing or not
	backspaceRemoves: _propTypes2.default.bool, // whether backspace removes an item if there is no text input
	backspaceToRemoveMessage: _propTypes2.default.string, // Message to use for screenreaders to press backspace to remove the current item - {label} is replaced with the item label
	className: _propTypes2.default.string, // className for the outer element
	clearAllText: stringOrNode, // title for the "clear" control when multi: true
	clearRenderer: _propTypes2.default.func, // create clearable x element
	clearValueText: stringOrNode, // title for the "clear" control
	clearable: _propTypes2.default.bool, // should it be possible to reset value
	closeOnSelect: _propTypes2.default.bool, // whether to close the menu when a value is selected
	deleteRemoves: _propTypes2.default.bool, // whether backspace removes an item if there is no text input
	delimiter: _propTypes2.default.string, // delimiter to use to join multiple values for the hidden field value
	disabled: _propTypes2.default.bool, // whether the Select is disabled or not
	escapeClearsValue: _propTypes2.default.bool, // whether escape clears the value when the menu is closed
	filterOption: _propTypes2.default.func, // method to filter a single option (option, filterString)
	filterOptions: _propTypes2.default.any, // boolean to enable default filtering or function to filter the options array ([options], filterString, [values])
	ignoreAccents: _propTypes2.default.bool, // whether to strip diacritics when filtering
	ignoreCase: _propTypes2.default.bool, // whether to perform case-insensitive filtering
	inputProps: _propTypes2.default.object, // custom attributes for the Input
	inputRenderer: _propTypes2.default.func, // returns a custom input component
	instanceId: _propTypes2.default.string, // set the components instanceId
	isLoading: _propTypes2.default.bool, // whether the Select is loading externally or not (such as options being loaded)
	joinValues: _propTypes2.default.bool, // joins multiple values into a single form field with the delimiter (legacy mode)
	labelKey: _propTypes2.default.string, // path of the label value in option objects
	matchPos: _propTypes2.default.string, // (any|start) match the start or entire string when filtering
	matchProp: _propTypes2.default.string, // (any|label|value) which option property to filter on
	menuBuffer: _propTypes2.default.number, // optional buffer (in px) between the bottom of the viewport and the bottom of the menu
	menuContainerStyle: _propTypes2.default.object, // optional style to apply to the menu container
	menuRenderer: _propTypes2.default.func, // renders a custom menu with options
	menuStyle: _propTypes2.default.object, // optional style to apply to the menu
	multi: _propTypes2.default.bool, // multi-value input
	name: _propTypes2.default.string, // generates a hidden <input /> tag with this field name for html forms
	noResultsText: stringOrNode, // placeholder displayed when there are no matching search results
	onBlur: _propTypes2.default.func, // onBlur handler: function (event) {}
	onBlurResetsInput: _propTypes2.default.bool, // whether input is cleared on blur
	onChange: _propTypes2.default.func, // onChange handler: function (newValue) {}
	onClose: _propTypes2.default.func, // fires when the menu is closed
	onCloseResetsInput: _propTypes2.default.bool, // whether input is cleared when menu is closed through the arrow
	onFocus: _propTypes2.default.func, // onFocus handler: function (event) {}
	onInputChange: _propTypes2.default.func, // onInputChange handler: function (inputValue) {}
	onInputKeyDown: _propTypes2.default.func, // input keyDown handler: function (event) {}
	onMenuScrollToBottom: _propTypes2.default.func, // fires when the menu is scrolled to the bottom; can be used to paginate options
	onOpen: _propTypes2.default.func, // fires when the menu is opened
	onSelectResetsInput: _propTypes2.default.bool, // whether input is cleared on select (works only for multiselect)
	onValueClick: _propTypes2.default.func, // onClick handler for value labels: function (value, event) {}
	openOnClick: _propTypes2.default.bool, // boolean to control opening the menu when the control is clicked
	openOnFocus: _propTypes2.default.bool, // always open options menu on focus
	optionClassName: _propTypes2.default.string, // additional class(es) to apply to the <Option /> elements
	optionComponent: _propTypes2.default.func, // option component to render in dropdown
	optionRenderer: _propTypes2.default.func, // optionRenderer: function (option) {}
	options: _propTypes2.default.array, // array of options
	pageSize: _propTypes2.default.number, // number of entries to page when using page up/down keys
	placeholder: stringOrNode, // field placeholder, displayed when there's no value
	required: _propTypes2.default.bool, // applies HTML5 required attribute when needed
	resetValue: _propTypes2.default.any, // value to use when you clear the control
	scrollMenuIntoView: _propTypes2.default.bool, // boolean to enable the viewport to shift so that the full menu fully visible when engaged
	searchable: _propTypes2.default.bool, // whether to enable searching feature or not
	simpleValue: _propTypes2.default.bool, // pass the value to onChange as a simple value (legacy pre 1.0 mode), defaults to false
	style: _propTypes2.default.object, // optional style to apply to the control
	tabIndex: _propTypes2.default.string, // optional tab index of the control
	tabSelectsValue: _propTypes2.default.bool, // whether to treat tabbing out while focused to be value selection
	value: _propTypes2.default.any, // initial field value
	valueComponent: _propTypes2.default.func, // value component to render
	valueKey: _propTypes2.default.string, // path of the label value in option objects
	valueRenderer: _propTypes2.default.func, // valueRenderer: function (option) {}
	wrapperStyle: _propTypes2.default.object // optional style to apply to the component wrapper
};

Select.defaultProps = {
	addLabelText: 'Add "{label}"?',
	arrowRenderer: _defaultArrowRenderer2.default,
	autosize: true,
	backspaceRemoves: true,
	backspaceToRemoveMessage: 'Press backspace to remove {label}',
	clearable: true,
	clearAllText: 'Clear all',
	clearRenderer: _defaultClearRenderer2.default,
	clearValueText: 'Clear value',
	closeOnSelect: true,
	deleteRemoves: true,
	delimiter: ',',
	disabled: false,
	escapeClearsValue: true,
	filterOptions: _defaultFilterOptions2.default,
	ignoreAccents: true,
	ignoreCase: true,
	inputProps: {},
	isLoading: false,
	joinValues: false,
	labelKey: 'label',
	matchPos: 'any',
	matchProp: 'any',
	menuBuffer: 0,
	menuRenderer: _defaultMenuRenderer2.default,
	multi: false,
	noResultsText: 'No results found',
	onBlurResetsInput: true,
	onSelectResetsInput: true,
	onCloseResetsInput: true,
	openOnClick: true,
	optionComponent: _Option2.default,
	pageSize: 5,
	placeholder: 'Select...',
	required: false,
	scrollMenuIntoView: true,
	searchable: true,
	simpleValue: false,
	tabSelectsValue: true,
	valueComponent: _Value2.default,
	valueKey: 'value'
};

exports.default = Select;

/***/ }),

/***/ 711:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils__ = __webpack_require__(723);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_styles__ = __webpack_require__(725);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* eslint prefer-template: 0 */






var Dropzone = function (_React$Component) {
  _inherits(Dropzone, _React$Component);

  function Dropzone(props, context) {
    _classCallCheck(this, Dropzone);

    var _this = _possibleConstructorReturn(this, (Dropzone.__proto__ || Object.getPrototypeOf(Dropzone)).call(this, props, context));

    _this.renderChildren = function (children, isDragActive, isDragAccept, isDragReject) {
      if (typeof children === 'function') {
        return children(_extends({}, _this.state, {
          isDragActive: isDragActive,
          isDragAccept: isDragAccept,
          isDragReject: isDragReject
        }));
      }
      return children;
    };

    _this.composeHandlers = _this.composeHandlers.bind(_this);
    _this.onClick = _this.onClick.bind(_this);
    _this.onDocumentDrop = _this.onDocumentDrop.bind(_this);
    _this.onDragEnter = _this.onDragEnter.bind(_this);
    _this.onDragLeave = _this.onDragLeave.bind(_this);
    _this.onDragOver = _this.onDragOver.bind(_this);
    _this.onDragStart = _this.onDragStart.bind(_this);
    _this.onDrop = _this.onDrop.bind(_this);
    _this.onFileDialogCancel = _this.onFileDialogCancel.bind(_this);
    _this.onInputElementClick = _this.onInputElementClick.bind(_this);

    _this.setRef = _this.setRef.bind(_this);
    _this.setRefs = _this.setRefs.bind(_this);

    _this.isFileDialogActive = false;

    _this.state = {
      draggedFiles: [],
      acceptedFiles: [],
      rejectedFiles: []
    };
    return _this;
  }

  _createClass(Dropzone, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var preventDropOnDocument = this.props.preventDropOnDocument;

      this.dragTargets = [];

      if (preventDropOnDocument) {
        document.addEventListener('dragover', __WEBPACK_IMPORTED_MODULE_2__utils__["e" /* onDocumentDragOver */], false);
        document.addEventListener('drop', this.onDocumentDrop, false);
      }
      this.fileInputEl.addEventListener('click', this.onInputElementClick, false);
      // Tried implementing addEventListener, but didn't work out
      document.body.onfocus = this.onFileDialogCancel;
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      var preventDropOnDocument = this.props.preventDropOnDocument;

      if (preventDropOnDocument) {
        document.removeEventListener('dragover', __WEBPACK_IMPORTED_MODULE_2__utils__["e" /* onDocumentDragOver */]);
        document.removeEventListener('drop', this.onDocumentDrop);
      }
      if (this.fileInputEl != null) {
        this.fileInputEl.removeEventListener('click', this.onInputElementClick, false);
      }
      // Can be replaced with removeEventListener, if addEventListener works
      if (document != null) {
        document.body.onfocus = null;
      }
    }
  }, {
    key: 'composeHandlers',
    value: function composeHandlers(handler) {
      if (this.props.disabled) {
        return null;
      }

      return handler;
    }
  }, {
    key: 'onDocumentDrop',
    value: function onDocumentDrop(evt) {
      if (this.node && this.node.contains(evt.target)) {
        // if we intercepted an event for our instance, let it propagate down to the instance's onDrop handler
        return;
      }
      evt.preventDefault();
      this.dragTargets = [];
    }
  }, {
    key: 'onDragStart',
    value: function onDragStart(evt) {
      if (this.props.onDragStart) {
        this.props.onDragStart.call(this, evt);
      }
    }
  }, {
    key: 'onDragEnter',
    value: function onDragEnter(evt) {
      evt.preventDefault();

      // Count the dropzone and any children that are entered.
      if (this.dragTargets.indexOf(evt.target) === -1) {
        this.dragTargets.push(evt.target);
      }

      this.setState({
        isDragActive: true, // Do not rely on files for the drag state. It doesn't work in Safari.
        draggedFiles: Object(__WEBPACK_IMPORTED_MODULE_2__utils__["d" /* getDataTransferItems */])(evt)
      });

      if (this.props.onDragEnter) {
        this.props.onDragEnter.call(this, evt);
      }
    }
  }, {
    key: 'onDragOver',
    value: function onDragOver(evt) {
      // eslint-disable-line class-methods-use-this
      evt.preventDefault();
      evt.stopPropagation();
      try {
        evt.dataTransfer.dropEffect = 'copy'; // eslint-disable-line no-param-reassign
      } catch (err) {
        // continue regardless of error
      }

      if (this.props.onDragOver) {
        this.props.onDragOver.call(this, evt);
      }
      return false;
    }
  }, {
    key: 'onDragLeave',
    value: function onDragLeave(evt) {
      var _this2 = this;

      evt.preventDefault();

      // Only deactivate once the dropzone and all children have been left.
      this.dragTargets = this.dragTargets.filter(function (el) {
        return el !== evt.target && _this2.node.contains(el);
      });
      if (this.dragTargets.length > 0) {
        return;
      }

      // Clear dragging files state
      this.setState({
        isDragActive: false,
        draggedFiles: []
      });

      if (this.props.onDragLeave) {
        this.props.onDragLeave.call(this, evt);
      }
    }
  }, {
    key: 'onDrop',
    value: function onDrop(evt) {
      var _this3 = this;

      var _props = this.props,
          onDrop = _props.onDrop,
          onDropAccepted = _props.onDropAccepted,
          onDropRejected = _props.onDropRejected,
          multiple = _props.multiple,
          disablePreview = _props.disablePreview,
          accept = _props.accept;

      var fileList = Object(__WEBPACK_IMPORTED_MODULE_2__utils__["d" /* getDataTransferItems */])(evt);
      var acceptedFiles = [];
      var rejectedFiles = [];

      // Stop default browser behavior
      evt.preventDefault();

      // Reset the counter along with the drag on a drop.
      this.dragTargets = [];
      this.isFileDialogActive = false;

      fileList.forEach(function (file) {
        if (!disablePreview) {
          try {
            file.preview = window.URL.createObjectURL(file); // eslint-disable-line no-param-reassign
          } catch (err) {
            if (false) {
              console.error('Failed to generate preview for file', file, err); // eslint-disable-line no-console
            }
          }
        }

        if (Object(__WEBPACK_IMPORTED_MODULE_2__utils__["b" /* fileAccepted */])(file, accept) && Object(__WEBPACK_IMPORTED_MODULE_2__utils__["c" /* fileMatchSize */])(file, _this3.props.maxSize, _this3.props.minSize)) {
          acceptedFiles.push(file);
        } else {
          rejectedFiles.push(file);
        }
      });

      if (!multiple) {
        // if not in multi mode add any extra accepted files to rejected.
        // This will allow end users to easily ignore a multi file drop in "single" mode.
        rejectedFiles.push.apply(rejectedFiles, _toConsumableArray(acceptedFiles.splice(1)));
      }

      if (onDrop) {
        onDrop.call(this, acceptedFiles, rejectedFiles, evt);
      }

      if (rejectedFiles.length > 0 && onDropRejected) {
        onDropRejected.call(this, rejectedFiles, evt);
      }

      if (acceptedFiles.length > 0 && onDropAccepted) {
        onDropAccepted.call(this, acceptedFiles, evt);
      }

      // Clear files value
      this.draggedFiles = null;

      // Reset drag state
      this.setState({
        isDragActive: false,
        draggedFiles: [],
        acceptedFiles: acceptedFiles,
        rejectedFiles: rejectedFiles
      });
    }
  }, {
    key: 'onClick',
    value: function onClick(evt) {
      var _props2 = this.props,
          onClick = _props2.onClick,
          disableClick = _props2.disableClick;

      if (!disableClick) {
        evt.stopPropagation();

        if (onClick) {
          onClick.call(this, evt);
        }

        // in IE11/Edge the file-browser dialog is blocking, ensure this is behind setTimeout
        // this is so react can handle state changes in the onClick prop above above
        // see: https://github.com/react-dropzone/react-dropzone/issues/450
        setTimeout(this.open.bind(this), 0);
      }
    }
  }, {
    key: 'onInputElementClick',
    value: function onInputElementClick(evt) {
      evt.stopPropagation();
      if (this.props.inputProps && this.props.inputProps.onClick) {
        this.props.inputProps.onClick();
      }
    }
  }, {
    key: 'onFileDialogCancel',
    value: function onFileDialogCancel() {
      // timeout will not recognize context of this method
      var onFileDialogCancel = this.props.onFileDialogCancel;
      var fileInputEl = this.fileInputEl;
      var isFileDialogActive = this.isFileDialogActive;
      // execute the timeout only if the onFileDialogCancel is defined and FileDialog
      // is opened in the browser

      if (onFileDialogCancel && isFileDialogActive) {
        setTimeout(function () {
          // Returns an object as FileList
          var FileList = fileInputEl.files;
          if (!FileList.length) {
            isFileDialogActive = false;
            onFileDialogCancel();
          }
        }, 300);
      }
    }
  }, {
    key: 'setRef',
    value: function setRef(ref) {
      this.node = ref;
    }
  }, {
    key: 'setRefs',
    value: function setRefs(ref) {
      this.fileInputEl = ref;
    }
    /**
     * Open system file upload dialog.
     *
     * @public
     */

  }, {
    key: 'open',
    value: function open() {
      this.isFileDialogActive = true;
      this.fileInputEl.value = null;
      this.fileInputEl.click();
    }
  }, {
    key: 'render',
    value: function render() {
      var _props3 = this.props,
          accept = _props3.accept,
          acceptClassName = _props3.acceptClassName,
          activeClassName = _props3.activeClassName,
          children = _props3.children,
          disabled = _props3.disabled,
          disabledClassName = _props3.disabledClassName,
          inputProps = _props3.inputProps,
          multiple = _props3.multiple,
          name = _props3.name,
          rejectClassName = _props3.rejectClassName,
          rest = _objectWithoutProperties(_props3, ['accept', 'acceptClassName', 'activeClassName', 'children', 'disabled', 'disabledClassName', 'inputProps', 'multiple', 'name', 'rejectClassName']);

      var acceptStyle = rest.acceptStyle,
          activeStyle = rest.activeStyle,
          className = rest.className,
          disabledStyle = rest.disabledStyle,
          rejectStyle = rest.rejectStyle,
          style = rest.style,
          props = _objectWithoutProperties(rest, ['acceptStyle', 'activeStyle', 'className', 'disabledStyle', 'rejectStyle', 'style']);

      var _state = this.state,
          isDragActive = _state.isDragActive,
          draggedFiles = _state.draggedFiles;

      var filesCount = draggedFiles.length;
      var isMultipleAllowed = multiple || filesCount <= 1;
      var isDragAccept = filesCount > 0 && Object(__WEBPACK_IMPORTED_MODULE_2__utils__["a" /* allFilesAccepted */])(draggedFiles, this.props.accept);
      var isDragReject = filesCount > 0 && (!isDragAccept || !isMultipleAllowed);
      className = className || '';
      var noStyles = !className && !style && !activeStyle && !acceptStyle && !rejectStyle && !disabledStyle;

      if (isDragActive && activeClassName) {
        className += ' ' + activeClassName;
      }
      if (isDragAccept && acceptClassName) {
        className += ' ' + acceptClassName;
      }
      if (isDragReject && rejectClassName) {
        className += ' ' + rejectClassName;
      }
      if (disabled && disabledClassName) {
        className += ' ' + disabledClassName;
      }

      if (noStyles) {
        style = __WEBPACK_IMPORTED_MODULE_3__utils_styles__["a" /* default */].default;
        activeStyle = __WEBPACK_IMPORTED_MODULE_3__utils_styles__["a" /* default */].active;
        acceptStyle = style.active;
        rejectStyle = __WEBPACK_IMPORTED_MODULE_3__utils_styles__["a" /* default */].rejected;
        disabledStyle = __WEBPACK_IMPORTED_MODULE_3__utils_styles__["a" /* default */].disabled;
      }

      var appliedStyle = _extends({}, style);
      if (activeStyle && isDragActive) {
        appliedStyle = _extends({}, style, activeStyle);
      }
      if (acceptStyle && isDragAccept) {
        appliedStyle = _extends({}, appliedStyle, acceptStyle);
      }
      if (rejectStyle && isDragReject) {
        appliedStyle = _extends({}, appliedStyle, rejectStyle);
      }
      if (disabledStyle && disabled) {
        appliedStyle = _extends({}, style, disabledStyle);
      }

      var inputAttributes = {
        accept: accept,
        disabled: disabled,
        type: 'file',
        style: { display: 'none' },
        multiple: __WEBPACK_IMPORTED_MODULE_2__utils__["f" /* supportMultiple */] && multiple,
        ref: this.setRefs,
        onChange: this.onDrop,
        autoComplete: 'off'
      };

      if (name && name.length) {
        inputAttributes.name = name;
      }

      // Remove custom properties before passing them to the wrapper div element
      var customProps = ['acceptedFiles', 'preventDropOnDocument', 'disablePreview', 'disableClick', 'activeClassName', 'acceptClassName', 'rejectClassName', 'disabledClassName', 'onDropAccepted', 'onDropRejected', 'onFileDialogCancel', 'maxSize', 'minSize'];
      var divProps = _extends({}, props);
      customProps.forEach(function (prop) {
        return delete divProps[prop];
      });

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        _extends({
          className: className,
          style: appliedStyle
        }, divProps /* expand user provided props first so event handlers are never overridden */, {
          onClick: this.composeHandlers(this.onClick),
          onDragStart: this.composeHandlers(this.onDragStart),
          onDragEnter: this.composeHandlers(this.onDragEnter),
          onDragOver: this.composeHandlers(this.onDragOver),
          onDragLeave: this.composeHandlers(this.onDragLeave),
          onDrop: this.composeHandlers(this.onDrop),
          ref: this.setRef,
          'aria-disabled': disabled
        }),
        this.renderChildren(children, isDragActive, isDragAccept, isDragReject),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', _extends({}, inputProps /* expand user provided inputProps first so inputAttributes override them */, inputAttributes))
      );
    }
  }]);

  return Dropzone;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/* harmony default export */ __webpack_exports__["a"] = (Dropzone);

Dropzone.propTypes = {
  /**
   * Allow specific types of files. See https://github.com/okonet/attr-accept for more information.
   * Keep in mind that mime type determination is not reliable across platforms. CSV files,
   * for example, are reported as text/plain under macOS but as application/vnd.ms-excel under
   * Windows. In some cases there might not be a mime type set at all.
   * See: https://github.com/react-dropzone/react-dropzone/issues/276
   */
  accept: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,

  /**
   * Contents of the dropzone
   */
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func]),

  /**
   * Disallow clicking on the dropzone container to open file dialog
   */
  disableClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,

  /**
  * Enable/disable the dropzone entirely
  */
  disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,

  /**
   * Enable/disable preview generation
   */
  disablePreview: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,

  /**
   * If false, allow dropped items to take over the current browser window
   */
  preventDropOnDocument: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,

  /**
   * Pass additional attributes to the `<input type="file"/>` tag
   */
  inputProps: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,

  /**
   * Allow dropping multiple files
   */
  multiple: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,

  /**
   * `name` attribute for the input tag
   */
  name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,

  /**
   * Maximum file size
   */
  maxSize: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,

  /**
   * Minimum file size
   */
  minSize: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,

  /**
   * className
   */
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,

  /**
   * className for active state
   */
  activeClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,

  /**
   * className for accepted state
   */
  acceptClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,

  /**
   * className for rejected state
   */
  rejectClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,

  /**
   * className for disabled state
   */
  disabledClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,

  /**
   * CSS styles to apply
   */
  style: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,

  /**
   * CSS styles to apply when drag is active
   */
  activeStyle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,

  /**
   * CSS styles to apply when drop will be accepted
   */
  acceptStyle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,

  /**
   * CSS styles to apply when drop will be rejected
   */
  rejectStyle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,

  /**
   * CSS styles to apply when dropzone is disabled
   */
  disabledStyle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,

  /**
   * onClick callback
   * @param {Event} event
   */
  onClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

  /**
   * onDrop callback
   */
  onDrop: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

  /**
   * onDropAccepted callback
   */
  onDropAccepted: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

  /**
   * onDropRejected callback
   */
  onDropRejected: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

  /**
   * onDragStart callback
   */
  onDragStart: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

  /**
   * onDragEnter callback
   */
  onDragEnter: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

  /**
   * onDragOver callback
   */
  onDragOver: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

  /**
   * onDragLeave callback
   */
  onDragLeave: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

  /**
   * Provide a callback on clicking the cancel button of the file dialog
   */
  onFileDialogCancel: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
};

Dropzone.defaultProps = {
  preventDropOnDocument: true,
  disabled: false,
  disablePreview: false,
  disableClick: false,
  multiple: true,
  maxSize: Infinity,
  minSize: 0
};

/***/ }),

/***/ 712:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _stripDiacritics = __webpack_require__(713);

var _stripDiacritics2 = _interopRequireDefault(_stripDiacritics);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function filterOptions(options, filterValue, excludeOptions, props) {
	var _this = this;

	if (props.ignoreAccents) {
		filterValue = (0, _stripDiacritics2.default)(filterValue);
	}

	if (props.ignoreCase) {
		filterValue = filterValue.toLowerCase();
	}

	if (excludeOptions) excludeOptions = excludeOptions.map(function (i) {
		return i[props.valueKey];
	});

	return options.filter(function (option) {
		if (excludeOptions && excludeOptions.indexOf(option[props.valueKey]) > -1) return false;
		if (props.filterOption) return props.filterOption.call(_this, option, filterValue);
		if (!filterValue) return true;
		var valueTest = String(option[props.valueKey]);
		var labelTest = String(option[props.labelKey]);
		if (props.ignoreAccents) {
			if (props.matchProp !== 'label') valueTest = (0, _stripDiacritics2.default)(valueTest);
			if (props.matchProp !== 'value') labelTest = (0, _stripDiacritics2.default)(labelTest);
		}
		if (props.ignoreCase) {
			if (props.matchProp !== 'label') valueTest = valueTest.toLowerCase();
			if (props.matchProp !== 'value') labelTest = labelTest.toLowerCase();
		}
		return props.matchPos === 'start' ? props.matchProp !== 'label' && valueTest.substr(0, filterValue.length) === filterValue || props.matchProp !== 'value' && labelTest.substr(0, filterValue.length) === filterValue : props.matchProp !== 'label' && valueTest.indexOf(filterValue) >= 0 || props.matchProp !== 'value' && labelTest.indexOf(filterValue) >= 0;
	});
}

exports.default = filterOptions;

/***/ }),

/***/ 713:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = stripDiacritics;
var map = [{ 'base': 'A', 'letters': /[\u0041\u24B6\uFF21\u00C0\u00C1\u00C2\u1EA6\u1EA4\u1EAA\u1EA8\u00C3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\u00C4\u01DE\u1EA2\u00C5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F]/g }, { 'base': 'AA', 'letters': /[\uA732]/g }, { 'base': 'AE', 'letters': /[\u00C6\u01FC\u01E2]/g }, { 'base': 'AO', 'letters': /[\uA734]/g }, { 'base': 'AU', 'letters': /[\uA736]/g }, { 'base': 'AV', 'letters': /[\uA738\uA73A]/g }, { 'base': 'AY', 'letters': /[\uA73C]/g }, { 'base': 'B', 'letters': /[\u0042\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181]/g }, { 'base': 'C', 'letters': /[\u0043\u24B8\uFF23\u0106\u0108\u010A\u010C\u00C7\u1E08\u0187\u023B\uA73E]/g }, { 'base': 'D', 'letters': /[\u0044\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779]/g }, { 'base': 'DZ', 'letters': /[\u01F1\u01C4]/g }, { 'base': 'Dz', 'letters': /[\u01F2\u01C5]/g }, { 'base': 'E', 'letters': /[\u0045\u24BA\uFF25\u00C8\u00C9\u00CA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\u00CB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E]/g }, { 'base': 'F', 'letters': /[\u0046\u24BB\uFF26\u1E1E\u0191\uA77B]/g }, { 'base': 'G', 'letters': /[\u0047\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E]/g }, { 'base': 'H', 'letters': /[\u0048\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D]/g }, { 'base': 'I', 'letters': /[\u0049\u24BE\uFF29\u00CC\u00CD\u00CE\u0128\u012A\u012C\u0130\u00CF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197]/g }, { 'base': 'J', 'letters': /[\u004A\u24BF\uFF2A\u0134\u0248]/g }, { 'base': 'K', 'letters': /[\u004B\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2]/g }, { 'base': 'L', 'letters': /[\u004C\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780]/g }, { 'base': 'LJ', 'letters': /[\u01C7]/g }, { 'base': 'Lj', 'letters': /[\u01C8]/g }, { 'base': 'M', 'letters': /[\u004D\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C]/g }, { 'base': 'N', 'letters': /[\u004E\u24C3\uFF2E\u01F8\u0143\u00D1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4]/g }, { 'base': 'NJ', 'letters': /[\u01CA]/g }, { 'base': 'Nj', 'letters': /[\u01CB]/g }, { 'base': 'O', 'letters': /[\u004F\u24C4\uFF2F\u00D2\u00D3\u00D4\u1ED2\u1ED0\u1ED6\u1ED4\u00D5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\u00D6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\u00D8\u01FE\u0186\u019F\uA74A\uA74C]/g }, { 'base': 'OI', 'letters': /[\u01A2]/g }, { 'base': 'OO', 'letters': /[\uA74E]/g }, { 'base': 'OU', 'letters': /[\u0222]/g }, { 'base': 'P', 'letters': /[\u0050\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754]/g }, { 'base': 'Q', 'letters': /[\u0051\u24C6\uFF31\uA756\uA758\u024A]/g }, { 'base': 'R', 'letters': /[\u0052\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782]/g }, { 'base': 'S', 'letters': /[\u0053\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784]/g }, { 'base': 'T', 'letters': /[\u0054\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786]/g }, { 'base': 'TZ', 'letters': /[\uA728]/g }, { 'base': 'U', 'letters': /[\u0055\u24CA\uFF35\u00D9\u00DA\u00DB\u0168\u1E78\u016A\u1E7A\u016C\u00DC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244]/g }, { 'base': 'V', 'letters': /[\u0056\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245]/g }, { 'base': 'VY', 'letters': /[\uA760]/g }, { 'base': 'W', 'letters': /[\u0057\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72]/g }, { 'base': 'X', 'letters': /[\u0058\u24CD\uFF38\u1E8A\u1E8C]/g }, { 'base': 'Y', 'letters': /[\u0059\u24CE\uFF39\u1EF2\u00DD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE]/g }, { 'base': 'Z', 'letters': /[\u005A\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762]/g }, { 'base': 'a', 'letters': /[\u0061\u24D0\uFF41\u1E9A\u00E0\u00E1\u00E2\u1EA7\u1EA5\u1EAB\u1EA9\u00E3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\u00E4\u01DF\u1EA3\u00E5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250]/g }, { 'base': 'aa', 'letters': /[\uA733]/g }, { 'base': 'ae', 'letters': /[\u00E6\u01FD\u01E3]/g }, { 'base': 'ao', 'letters': /[\uA735]/g }, { 'base': 'au', 'letters': /[\uA737]/g }, { 'base': 'av', 'letters': /[\uA739\uA73B]/g }, { 'base': 'ay', 'letters': /[\uA73D]/g }, { 'base': 'b', 'letters': /[\u0062\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253]/g }, { 'base': 'c', 'letters': /[\u0063\u24D2\uFF43\u0107\u0109\u010B\u010D\u00E7\u1E09\u0188\u023C\uA73F\u2184]/g }, { 'base': 'd', 'letters': /[\u0064\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A]/g }, { 'base': 'dz', 'letters': /[\u01F3\u01C6]/g }, { 'base': 'e', 'letters': /[\u0065\u24D4\uFF45\u00E8\u00E9\u00EA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\u00EB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD]/g }, { 'base': 'f', 'letters': /[\u0066\u24D5\uFF46\u1E1F\u0192\uA77C]/g }, { 'base': 'g', 'letters': /[\u0067\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F]/g }, { 'base': 'h', 'letters': /[\u0068\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265]/g }, { 'base': 'hv', 'letters': /[\u0195]/g }, { 'base': 'i', 'letters': /[\u0069\u24D8\uFF49\u00EC\u00ED\u00EE\u0129\u012B\u012D\u00EF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131]/g }, { 'base': 'j', 'letters': /[\u006A\u24D9\uFF4A\u0135\u01F0\u0249]/g }, { 'base': 'k', 'letters': /[\u006B\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3]/g }, { 'base': 'l', 'letters': /[\u006C\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747]/g }, { 'base': 'lj', 'letters': /[\u01C9]/g }, { 'base': 'm', 'letters': /[\u006D\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F]/g }, { 'base': 'n', 'letters': /[\u006E\u24DD\uFF4E\u01F9\u0144\u00F1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5]/g }, { 'base': 'nj', 'letters': /[\u01CC]/g }, { 'base': 'o', 'letters': /[\u006F\u24DE\uFF4F\u00F2\u00F3\u00F4\u1ED3\u1ED1\u1ED7\u1ED5\u00F5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\u00F6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\u00F8\u01FF\u0254\uA74B\uA74D\u0275]/g }, { 'base': 'oi', 'letters': /[\u01A3]/g }, { 'base': 'ou', 'letters': /[\u0223]/g }, { 'base': 'oo', 'letters': /[\uA74F]/g }, { 'base': 'p', 'letters': /[\u0070\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755]/g }, { 'base': 'q', 'letters': /[\u0071\u24E0\uFF51\u024B\uA757\uA759]/g }, { 'base': 'r', 'letters': /[\u0072\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783]/g }, { 'base': 's', 'letters': /[\u0073\u24E2\uFF53\u00DF\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B]/g }, { 'base': 't', 'letters': /[\u0074\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787]/g }, { 'base': 'tz', 'letters': /[\uA729]/g }, { 'base': 'u', 'letters': /[\u0075\u24E4\uFF55\u00F9\u00FA\u00FB\u0169\u1E79\u016B\u1E7B\u016D\u00FC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289]/g }, { 'base': 'v', 'letters': /[\u0076\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C]/g }, { 'base': 'vy', 'letters': /[\uA761]/g }, { 'base': 'w', 'letters': /[\u0077\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73]/g }, { 'base': 'x', 'letters': /[\u0078\u24E7\uFF58\u1E8B\u1E8D]/g }, { 'base': 'y', 'letters': /[\u0079\u24E8\uFF59\u1EF3\u00FD\u0177\u1EF9\u0233\u1E8F\u00FF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF]/g }, { 'base': 'z', 'letters': /[\u007A\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763]/g }];

function stripDiacritics(str) {
	for (var i = 0; i < map.length; i++) {
		str = str.replace(map[i].letters, map[i].base);
	}
	return str;
};

/***/ }),

/***/ 714:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _classnames = __webpack_require__(9);

var _classnames2 = _interopRequireDefault(_classnames);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function menuRenderer(_ref) {
	var focusedOption = _ref.focusedOption,
	    instancePrefix = _ref.instancePrefix,
	    labelKey = _ref.labelKey,
	    onFocus = _ref.onFocus,
	    onSelect = _ref.onSelect,
	    optionClassName = _ref.optionClassName,
	    optionComponent = _ref.optionComponent,
	    optionRenderer = _ref.optionRenderer,
	    options = _ref.options,
	    valueArray = _ref.valueArray,
	    valueKey = _ref.valueKey,
	    onOptionRef = _ref.onOptionRef;

	var Option = optionComponent;

	return options.map(function (option, i) {
		var isSelected = valueArray && valueArray.indexOf(option) > -1;
		var isFocused = option === focusedOption;
		var optionClass = (0, _classnames2.default)(optionClassName, {
			'Select-option': true,
			'is-selected': isSelected,
			'is-focused': isFocused,
			'is-disabled': option.disabled
		});

		return _react2.default.createElement(
			Option,
			{
				className: optionClass,
				instancePrefix: instancePrefix,
				isDisabled: option.disabled,
				isFocused: isFocused,
				isSelected: isSelected,
				key: 'option-' + i + '-' + option[valueKey],
				onFocus: onFocus,
				onSelect: onSelect,
				option: option,
				optionIndex: i,
				ref: function ref(_ref2) {
					onOptionRef(_ref2, isFocused);
				}
			},
			optionRenderer(option, i)
		);
	});
}

exports.default = menuRenderer;

/***/ }),

/***/ 715:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(9);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Value = function (_React$Component) {
	_inherits(Value, _React$Component);

	function Value(props) {
		_classCallCheck(this, Value);

		var _this = _possibleConstructorReturn(this, (Value.__proto__ || Object.getPrototypeOf(Value)).call(this, props));

		_this.handleMouseDown = _this.handleMouseDown.bind(_this);
		_this.onRemove = _this.onRemove.bind(_this);
		_this.handleTouchEndRemove = _this.handleTouchEndRemove.bind(_this);
		_this.handleTouchMove = _this.handleTouchMove.bind(_this);
		_this.handleTouchStart = _this.handleTouchStart.bind(_this);
		return _this;
	}

	_createClass(Value, [{
		key: 'handleMouseDown',
		value: function handleMouseDown(event) {
			if (event.type === 'mousedown' && event.button !== 0) {
				return;
			}
			if (this.props.onClick) {
				event.stopPropagation();
				this.props.onClick(this.props.value, event);
				return;
			}
			if (this.props.value.href) {
				event.stopPropagation();
			}
		}
	}, {
		key: 'onRemove',
		value: function onRemove(event) {
			event.preventDefault();
			event.stopPropagation();
			this.props.onRemove(this.props.value);
		}
	}, {
		key: 'handleTouchEndRemove',
		value: function handleTouchEndRemove(event) {
			// Check if the view is being dragged, In this case
			// we don't want to fire the click event (because the user only wants to scroll)
			if (this.dragging) return;

			// Fire the mouse events
			this.onRemove(event);
		}
	}, {
		key: 'handleTouchMove',
		value: function handleTouchMove(event) {
			// Set a flag that the view is being dragged
			this.dragging = true;
		}
	}, {
		key: 'handleTouchStart',
		value: function handleTouchStart(event) {
			// Set a flag that the view is not being dragged
			this.dragging = false;
		}
	}, {
		key: 'renderRemoveIcon',
		value: function renderRemoveIcon() {
			if (this.props.disabled || !this.props.onRemove) return;
			return _react2.default.createElement(
				'span',
				{ className: 'Select-value-icon',
					'aria-hidden': 'true',
					onMouseDown: this.onRemove,
					onTouchEnd: this.handleTouchEndRemove,
					onTouchStart: this.handleTouchStart,
					onTouchMove: this.handleTouchMove },
				'\xD7'
			);
		}
	}, {
		key: 'renderLabel',
		value: function renderLabel() {
			var className = 'Select-value-label';
			return this.props.onClick || this.props.value.href ? _react2.default.createElement(
				'a',
				{ className: className, href: this.props.value.href, target: this.props.value.target, onMouseDown: this.handleMouseDown, onTouchEnd: this.handleMouseDown },
				this.props.children
			) : _react2.default.createElement(
				'span',
				{ className: className, role: 'option', 'aria-selected': 'true', id: this.props.id },
				this.props.children
			);
		}
	}, {
		key: 'render',
		value: function render() {
			return _react2.default.createElement(
				'div',
				{ className: (0, _classnames2.default)('Select-value', this.props.value.className),
					style: this.props.value.style,
					title: this.props.value.title
				},
				this.renderRemoveIcon(),
				this.renderLabel()
			);
		}
	}]);

	return Value;
}(_react2.default.Component);

;

Value.propTypes = {
	children: _propTypes2.default.node,
	disabled: _propTypes2.default.bool, // disabled prop passed to ReactSelect
	id: _propTypes2.default.string, // Unique id for the value - used for aria
	onClick: _propTypes2.default.func, // method to handle click on value label
	onRemove: _propTypes2.default.func, // method to handle removal of the value
	value: _propTypes2.default.object.isRequired // the option object for this value
};

exports.default = Value;

/***/ }),

/***/ 716:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Select = __webpack_require__(710);

var _Select2 = _interopRequireDefault(_Select);

var _stripDiacritics = __webpack_require__(713);

var _stripDiacritics2 = _interopRequireDefault(_stripDiacritics);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var propTypes = {
	autoload: _propTypes2.default.bool.isRequired, // automatically call the `loadOptions` prop on-mount; defaults to true
	cache: _propTypes2.default.any, // object to use to cache results; set to null/false to disable caching
	children: _propTypes2.default.func.isRequired, // Child function responsible for creating the inner Select component; (props: Object): PropTypes.element
	ignoreAccents: _propTypes2.default.bool, // strip diacritics when filtering; defaults to true
	ignoreCase: _propTypes2.default.bool, // perform case-insensitive filtering; defaults to true
	loadOptions: _propTypes2.default.func.isRequired, // callback to load options asynchronously; (inputValue: string, callback: Function): ?Promise
	loadingPlaceholder: _propTypes2.default.oneOfType([// replaces the placeholder while options are loading
	_propTypes2.default.string, _propTypes2.default.node]),
	multi: _propTypes2.default.bool, // multi-value input
	noResultsText: _propTypes2.default.oneOfType([// field noResultsText, displayed when no options come back from the server
	_propTypes2.default.string, _propTypes2.default.node]),
	onChange: _propTypes2.default.func, // onChange handler: function (newValue) {}
	onInputChange: _propTypes2.default.func, // optional for keeping track of what is being typed
	options: _propTypes2.default.array.isRequired, // array of options
	placeholder: _propTypes2.default.oneOfType([// field placeholder, displayed when there's no value (shared with Select)
	_propTypes2.default.string, _propTypes2.default.node]),
	searchPromptText: _propTypes2.default.oneOfType([// label to prompt for search input
	_propTypes2.default.string, _propTypes2.default.node]),
	value: _propTypes2.default.any // initial field value
};

var defaultCache = {};

var defaultProps = {
	autoload: true,
	cache: defaultCache,
	children: defaultChildren,
	ignoreAccents: true,
	ignoreCase: true,
	loadingPlaceholder: 'Loading...',
	options: [],
	searchPromptText: 'Type to search'
};

var Async = function (_Component) {
	_inherits(Async, _Component);

	function Async(props, context) {
		_classCallCheck(this, Async);

		var _this = _possibleConstructorReturn(this, (Async.__proto__ || Object.getPrototypeOf(Async)).call(this, props, context));

		_this._cache = props.cache === defaultCache ? {} : props.cache;

		_this.state = {
			inputValue: '',
			isLoading: false,
			options: props.options
		};

		_this.onInputChange = _this.onInputChange.bind(_this);
		return _this;
	}

	_createClass(Async, [{
		key: 'componentDidMount',
		value: function componentDidMount() {
			var autoload = this.props.autoload;


			if (autoload) {
				this.loadOptions('');
			}
		}
	}, {
		key: 'componentWillReceiveProps',
		value: function componentWillReceiveProps(nextProps) {
			if (nextProps.options !== this.props.options) {
				this.setState({
					options: nextProps.options
				});
			}
		}
	}, {
		key: 'componentWillUnmount',
		value: function componentWillUnmount() {
			this._callback = null;
		}
	}, {
		key: 'loadOptions',
		value: function loadOptions(inputValue) {
			var _this2 = this;

			var loadOptions = this.props.loadOptions;

			var cache = this._cache;

			if (cache && Object.prototype.hasOwnProperty.call(cache, inputValue)) {
				this.setState({
					options: cache[inputValue]
				});

				return;
			}

			var callback = function callback(error, data) {
				if (callback === _this2._callback) {
					_this2._callback = null;

					var options = data && data.options || [];

					if (cache) {
						cache[inputValue] = options;
					}

					_this2.setState({
						isLoading: false,
						options: options
					});
				}
			};

			// Ignore all but the most recent request
			this._callback = callback;

			var promise = loadOptions(inputValue, callback);
			if (promise) {
				promise.then(function (data) {
					return callback(null, data);
				}, function (error) {
					return callback(error);
				});
			}

			if (this._callback && !this.state.isLoading) {
				this.setState({
					isLoading: true
				});
			}
		}
	}, {
		key: 'onInputChange',
		value: function onInputChange(inputValue) {
			var _props = this.props,
			    ignoreAccents = _props.ignoreAccents,
			    ignoreCase = _props.ignoreCase,
			    onInputChange = _props.onInputChange;

			var transformedInputValue = inputValue;

			if (ignoreAccents) {
				transformedInputValue = (0, _stripDiacritics2.default)(transformedInputValue);
			}

			if (ignoreCase) {
				transformedInputValue = transformedInputValue.toLowerCase();
			}

			if (onInputChange) {
				onInputChange(transformedInputValue);
			}

			this.setState({ inputValue: inputValue });
			this.loadOptions(transformedInputValue);

			// Return the original input value to avoid modifying the user's view of the input while typing.
			return inputValue;
		}
	}, {
		key: 'noResultsText',
		value: function noResultsText() {
			var _props2 = this.props,
			    loadingPlaceholder = _props2.loadingPlaceholder,
			    noResultsText = _props2.noResultsText,
			    searchPromptText = _props2.searchPromptText;
			var _state = this.state,
			    inputValue = _state.inputValue,
			    isLoading = _state.isLoading;


			if (isLoading) {
				return loadingPlaceholder;
			}
			if (inputValue && noResultsText) {
				return noResultsText;
			}
			return searchPromptText;
		}
	}, {
		key: 'focus',
		value: function focus() {
			this.select.focus();
		}
	}, {
		key: 'render',
		value: function render() {
			var _this3 = this;

			var _props3 = this.props,
			    children = _props3.children,
			    loadingPlaceholder = _props3.loadingPlaceholder,
			    multi = _props3.multi,
			    onChange = _props3.onChange,
			    placeholder = _props3.placeholder,
			    value = _props3.value;
			var _state2 = this.state,
			    isLoading = _state2.isLoading,
			    options = _state2.options;


			var props = {
				noResultsText: this.noResultsText(),
				placeholder: isLoading ? loadingPlaceholder : placeholder,
				options: isLoading && loadingPlaceholder ? [] : options,
				ref: function ref(_ref) {
					return _this3.select = _ref;
				}
			};

			return children(_extends({}, this.props, props, {
				isLoading: isLoading,
				onInputChange: this.onInputChange
			}));
		}
	}]);

	return Async;
}(_react.Component);

exports.default = Async;


Async.propTypes = propTypes;
Async.defaultProps = defaultProps;

function defaultChildren(props) {
	return _react2.default.createElement(_Select2.default, props);
}

/***/ }),

/***/ 717:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Select = __webpack_require__(710);

var _Select2 = _interopRequireDefault(_Select);

var _defaultFilterOptions = __webpack_require__(712);

var _defaultFilterOptions2 = _interopRequireDefault(_defaultFilterOptions);

var _defaultMenuRenderer = __webpack_require__(714);

var _defaultMenuRenderer2 = _interopRequireDefault(_defaultMenuRenderer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CreatableSelect = function (_React$Component) {
	_inherits(CreatableSelect, _React$Component);

	function CreatableSelect(props, context) {
		_classCallCheck(this, CreatableSelect);

		var _this = _possibleConstructorReturn(this, (CreatableSelect.__proto__ || Object.getPrototypeOf(CreatableSelect)).call(this, props, context));

		_this.filterOptions = _this.filterOptions.bind(_this);
		_this.menuRenderer = _this.menuRenderer.bind(_this);
		_this.onInputKeyDown = _this.onInputKeyDown.bind(_this);
		_this.onInputChange = _this.onInputChange.bind(_this);
		_this.onOptionSelect = _this.onOptionSelect.bind(_this);
		return _this;
	}

	_createClass(CreatableSelect, [{
		key: 'createNewOption',
		value: function createNewOption() {
			var _props = this.props,
			    isValidNewOption = _props.isValidNewOption,
			    newOptionCreator = _props.newOptionCreator,
			    onNewOptionClick = _props.onNewOptionClick,
			    _props$options = _props.options,
			    options = _props$options === undefined ? [] : _props$options,
			    shouldKeyDownEventCreateNewOption = _props.shouldKeyDownEventCreateNewOption;


			if (isValidNewOption({ label: this.inputValue })) {
				var option = newOptionCreator({ label: this.inputValue, labelKey: this.labelKey, valueKey: this.valueKey });
				var _isOptionUnique = this.isOptionUnique({ option: option });

				// Don't add the same option twice.
				if (_isOptionUnique) {
					if (onNewOptionClick) {
						onNewOptionClick(option);
					} else {
						options.unshift(option);

						this.select.selectValue(option);
					}
				}
			}
		}
	}, {
		key: 'filterOptions',
		value: function filterOptions() {
			var _props2 = this.props,
			    filterOptions = _props2.filterOptions,
			    isValidNewOption = _props2.isValidNewOption,
			    options = _props2.options,
			    promptTextCreator = _props2.promptTextCreator;

			// TRICKY Check currently selected options as well.
			// Don't display a create-prompt for a value that's selected.
			// This covers async edge-cases where a newly-created Option isn't yet in the async-loaded array.

			var excludeOptions = (arguments.length <= 2 ? undefined : arguments[2]) || [];

			var filteredOptions = filterOptions.apply(undefined, arguments) || [];

			if (isValidNewOption({ label: this.inputValue })) {
				var _newOptionCreator = this.props.newOptionCreator;


				var option = _newOptionCreator({
					label: this.inputValue,
					labelKey: this.labelKey,
					valueKey: this.valueKey
				});

				// TRICKY Compare to all options (not just filtered options) in case option has already been selected).
				// For multi-selects, this would remove it from the filtered list.
				var _isOptionUnique2 = this.isOptionUnique({
					option: option,
					options: excludeOptions.concat(filteredOptions)
				});

				if (_isOptionUnique2) {
					var prompt = promptTextCreator(this.inputValue);

					this._createPlaceholderOption = _newOptionCreator({
						label: prompt,
						labelKey: this.labelKey,
						valueKey: this.valueKey
					});

					filteredOptions.unshift(this._createPlaceholderOption);
				}
			}

			return filteredOptions;
		}
	}, {
		key: 'isOptionUnique',
		value: function isOptionUnique(_ref) {
			var option = _ref.option,
			    options = _ref.options;
			var isOptionUnique = this.props.isOptionUnique;


			options = options || this.select.filterOptions();

			return isOptionUnique({
				labelKey: this.labelKey,
				option: option,
				options: options,
				valueKey: this.valueKey
			});
		}
	}, {
		key: 'menuRenderer',
		value: function menuRenderer(params) {
			var menuRenderer = this.props.menuRenderer;


			return menuRenderer(_extends({}, params, {
				onSelect: this.onOptionSelect,
				selectValue: this.onOptionSelect
			}));
		}
	}, {
		key: 'onInputChange',
		value: function onInputChange(input) {
			var onInputChange = this.props.onInputChange;


			if (onInputChange) {
				onInputChange(input);
			}

			// This value may be needed in between Select mounts (when this.select is null)
			this.inputValue = input;
		}
	}, {
		key: 'onInputKeyDown',
		value: function onInputKeyDown(event) {
			var _props3 = this.props,
			    shouldKeyDownEventCreateNewOption = _props3.shouldKeyDownEventCreateNewOption,
			    onInputKeyDown = _props3.onInputKeyDown;

			var focusedOption = this.select.getFocusedOption();

			if (focusedOption && focusedOption === this._createPlaceholderOption && shouldKeyDownEventCreateNewOption({ keyCode: event.keyCode })) {
				this.createNewOption();

				// Prevent decorated Select from doing anything additional with this keyDown event
				event.preventDefault();
			} else if (onInputKeyDown) {
				onInputKeyDown(event);
			}
		}
	}, {
		key: 'onOptionSelect',
		value: function onOptionSelect(option, event) {
			if (option === this._createPlaceholderOption) {
				this.createNewOption();
			} else {
				this.select.selectValue(option);
			}
		}
	}, {
		key: 'focus',
		value: function focus() {
			this.select.focus();
		}
	}, {
		key: 'render',
		value: function render() {
			var _this2 = this;

			var _props4 = this.props,
			    newOptionCreator = _props4.newOptionCreator,
			    shouldKeyDownEventCreateNewOption = _props4.shouldKeyDownEventCreateNewOption,
			    restProps = _objectWithoutProperties(_props4, ['newOptionCreator', 'shouldKeyDownEventCreateNewOption']);

			var children = this.props.children;

			// We can't use destructuring default values to set the children,
			// because it won't apply work if `children` is null. A falsy check is
			// more reliable in real world use-cases.

			if (!children) {
				children = defaultChildren;
			}

			var props = _extends({}, restProps, {
				allowCreate: true,
				filterOptions: this.filterOptions,
				menuRenderer: this.menuRenderer,
				onInputChange: this.onInputChange,
				onInputKeyDown: this.onInputKeyDown,
				ref: function ref(_ref2) {
					_this2.select = _ref2;

					// These values may be needed in between Select mounts (when this.select is null)
					if (_ref2) {
						_this2.labelKey = _ref2.props.labelKey;
						_this2.valueKey = _ref2.props.valueKey;
					}
				}
			});

			return children(props);
		}
	}]);

	return CreatableSelect;
}(_react2.default.Component);

;

function defaultChildren(props) {
	return _react2.default.createElement(_Select2.default, props);
};

function isOptionUnique(_ref3) {
	var option = _ref3.option,
	    options = _ref3.options,
	    labelKey = _ref3.labelKey,
	    valueKey = _ref3.valueKey;

	return options.filter(function (existingOption) {
		return existingOption[labelKey] === option[labelKey] || existingOption[valueKey] === option[valueKey];
	}).length === 0;
};

function isValidNewOption(_ref4) {
	var label = _ref4.label;

	return !!label;
};

function newOptionCreator(_ref5) {
	var label = _ref5.label,
	    labelKey = _ref5.labelKey,
	    valueKey = _ref5.valueKey;

	var option = {};
	option[valueKey] = label;
	option[labelKey] = label;
	option.className = 'Select-create-option-placeholder';
	return option;
};

function promptTextCreator(label) {
	return 'Create option "' + label + '"';
}

function shouldKeyDownEventCreateNewOption(_ref6) {
	var keyCode = _ref6.keyCode;

	switch (keyCode) {
		case 9: // TAB
		case 13: // ENTER
		case 188:
			// COMMA
			return true;
	}

	return false;
};

// Default prop methods
CreatableSelect.isOptionUnique = isOptionUnique;
CreatableSelect.isValidNewOption = isValidNewOption;
CreatableSelect.newOptionCreator = newOptionCreator;
CreatableSelect.promptTextCreator = promptTextCreator;
CreatableSelect.shouldKeyDownEventCreateNewOption = shouldKeyDownEventCreateNewOption;

CreatableSelect.defaultProps = {
	filterOptions: _defaultFilterOptions2.default,
	isOptionUnique: isOptionUnique,
	isValidNewOption: isValidNewOption,
	menuRenderer: _defaultMenuRenderer2.default,
	newOptionCreator: newOptionCreator,
	promptTextCreator: promptTextCreator,
	shouldKeyDownEventCreateNewOption: shouldKeyDownEventCreateNewOption
};

CreatableSelect.propTypes = {
	// Child function responsible for creating the inner Select component
	// This component can be used to compose HOCs (eg Creatable and Async)
	// (props: Object): PropTypes.element
	children: _propTypes2.default.func,

	// See Select.propTypes.filterOptions
	filterOptions: _propTypes2.default.any,

	// Searches for any matching option within the set of options.
	// This function prevents duplicate options from being created.
	// ({ option: Object, options: Array, labelKey: string, valueKey: string }): boolean
	isOptionUnique: _propTypes2.default.func,

	// Determines if the current input text represents a valid option.
	// ({ label: string }): boolean
	isValidNewOption: _propTypes2.default.func,

	// See Select.propTypes.menuRenderer
	menuRenderer: _propTypes2.default.any,

	// Factory to create new option.
	// ({ label: string, labelKey: string, valueKey: string }): Object
	newOptionCreator: _propTypes2.default.func,

	// input change handler: function (inputValue) {}
	onInputChange: _propTypes2.default.func,

	// input keyDown handler: function (event) {}
	onInputKeyDown: _propTypes2.default.func,

	// new option click handler: function (option) {}
	onNewOptionClick: _propTypes2.default.func,

	// See Select.propTypes.options
	options: _propTypes2.default.array,

	// Creates prompt/placeholder option text.
	// (filterText: string): string
	promptTextCreator: _propTypes2.default.func,

	// Decides if a keyDown event (eg its `keyCode`) should result in the creation of a new option.
	shouldKeyDownEventCreateNewOption: _propTypes2.default.func
};

exports.default = CreatableSelect;

/***/ }),

/***/ 719:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Form; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_form__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Form_scss__ = __webpack_require__(720);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Form_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Form_scss__);



var FormComponent = function (_a) {
    var children = _a.children, className = _a.className, handleSubmit = _a.handleSubmit, onSubmit = _a.onSubmit;
    var onSubmitForm = handleSubmit && handleSubmit(onSubmit);
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("form", { className: className, onSubmit: onSubmitForm }, children));
};
var Form = Object(__WEBPACK_IMPORTED_MODULE_1_redux_form__["e" /* reduxForm */])({
    enableReinitialize: true
})(FormComponent);


/***/ }),

/***/ 720:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(721);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(699)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--5-2!../../../node_modules/sass-loader/lib/loader.js!../../../node_modules/postcss-loader/lib/index.js??postcss!./Form.scss", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js??ref--5-2!../../../node_modules/sass-loader/lib/loader.js!../../../node_modules/postcss-loader/lib/index.js??postcss!./Form.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 721:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(698)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),

/***/ 722:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return InputFile; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dropzone__ = __webpack_require__(711);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_intl__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_redux_form__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__InputFile_scss__ = __webpack_require__(726);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__InputFile_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__InputFile_scss__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();






var InputFile = /** @class */ (function (_super) {
    __extends(InputFile, _super);
    function InputFile(props) {
        var _this = _super.call(this, props) || this;
        _this.state = { selectedImageFile: undefined };
        _this.onFileSelected = _this.onFileSelected.bind(_this);
        return _this;
    }
    InputFile.prototype.componentWillMount = function () {
        var input = this.props.input;
        if (input.value) {
            this.setState({ selectedImageFile: input.value });
        }
    };
    InputFile.prototype.componentWillReceiveProps = function (nextProps) {
        if (nextProps.input.value && this.props.input.value !== nextProps.input.value) {
            this.setState({ selectedImageFile: nextProps.input.value });
        }
    };
    InputFile.prototype.render = function () {
        var _a = this.props, className = _a.className, icon = _a.icon, input = _a.input, label = _a.label, meta = _a.meta;
        var labelClassNameModifier = this.state.selectedImageFile && 'input-file__label--preview-visible';
        var iconClassNameModifier = this.state.selectedImageFile && 'input-file__icon--preview-visible';
        var footnoteErorrClassNameModifier = meta.error && 'input-file__footnote--is-error';
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_dropzone__["a" /* default */], { className: __WEBPACK_IMPORTED_MODULE_0_classnames__('input-file__container', className), name: input.name, accept: "image/*", multiple: false, onDrop: this.onFileSelected },
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "input-file__select" },
                this.selectedImagePreview,
                icon && __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("i", { className: __WEBPACK_IMPORTED_MODULE_0_classnames__('input-file__icon', iconClassNameModifier, icon) }),
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("p", { className: __WEBPACK_IMPORTED_MODULE_0_classnames__('input-file__label', labelClassNameModifier) }, label)),
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("p", { className: "input-file__footnote" }, meta.error && __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("span", { className: __WEBPACK_IMPORTED_MODULE_0_classnames__(footnoteErorrClassNameModifier) },
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_react_intl__["c" /* FormattedMessage */], { id: meta.error })))));
    };
    Object.defineProperty(InputFile.prototype, "selectedImagePreview", {
        get: function () {
            var selectedImageFile = this.state.selectedImageFile;
            if (selectedImageFile && selectedImageFile.preview) {
                return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("img", { src: selectedImageFile.preview, className: "input-file__preview" }));
            }
            return null;
        },
        enumerable: true,
        configurable: true
    });
    InputFile.prototype.onFileSelected = function (selectedFiles) {
        var _a = this.props, input = _a.input, meta = _a.meta;
        meta.dispatch(Object(__WEBPACK_IMPORTED_MODULE_4_redux_form__["b" /* change */])(meta.form, input.name, selectedFiles[0]));
    };
    return InputFile;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));



/***/ }),

/***/ 723:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return supportMultiple; });
/* harmony export (immutable) */ __webpack_exports__["d"] = getDataTransferItems;
/* harmony export (immutable) */ __webpack_exports__["b"] = fileAccepted;
/* harmony export (immutable) */ __webpack_exports__["c"] = fileMatchSize;
/* harmony export (immutable) */ __webpack_exports__["a"] = allFilesAccepted;
/* harmony export (immutable) */ __webpack_exports__["e"] = onDocumentDragOver;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_attr_accept__ = __webpack_require__(724);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_attr_accept___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_attr_accept__);


var supportMultiple = typeof document !== 'undefined' && document && document.createElement ? 'multiple' in document.createElement('input') : true;

function getDataTransferItems(event) {
  var dataTransferItemsList = [];
  if (event.dataTransfer) {
    var dt = event.dataTransfer;
    if (dt.files && dt.files.length) {
      dataTransferItemsList = dt.files;
    } else if (dt.items && dt.items.length) {
      // During the drag even the dataTransfer.files is null
      // but Chrome implements some drag store, which is accesible via dataTransfer.items
      dataTransferItemsList = dt.items;
    }
  } else if (event.target && event.target.files) {
    dataTransferItemsList = event.target.files;
  }
  // Convert from DataTransferItemsList to the native Array
  return Array.prototype.slice.call(dataTransferItemsList);
}

// Firefox versions prior to 53 return a bogus MIME type for every file drag, so dragovers with
// that MIME type will always be accepted
function fileAccepted(file, accept) {
  return file.type === 'application/x-moz-file' || __WEBPACK_IMPORTED_MODULE_0_attr_accept___default()(file, accept);
}

function fileMatchSize(file, maxSize, minSize) {
  return file.size <= maxSize && file.size >= minSize;
}

function allFilesAccepted(files, accept) {
  return files.every(function (file) {
    return fileAccepted(file, accept);
  });
}

// allow the entire document to be a drag target
function onDocumentDragOver(evt) {
  evt.preventDefault();
}

/***/ }),

/***/ 724:
/***/ (function(module, exports) {

module.exports=function(t){function n(e){if(r[e])return r[e].exports;var o=r[e]={exports:{},id:e,loaded:!1};return t[e].call(o.exports,o,o.exports,n),o.loaded=!0,o.exports}var r={};return n.m=t,n.c=r,n.p="",n(0)}([function(t,n,r){"use strict";n.__esModule=!0,r(8),r(9),n["default"]=function(t,n){if(t&&n){var r=function(){var r=Array.isArray(n)?n:n.split(","),e=t.name||"",o=t.type||"",i=o.replace(/\/.*$/,"");return{v:r.some(function(t){var n=t.trim();return"."===n.charAt(0)?e.toLowerCase().endsWith(n.toLowerCase()):/\/\*$/.test(n)?i===n.replace(/\/.*$/,""):o===n})}}();if("object"==typeof r)return r.v}return!0},t.exports=n["default"]},function(t,n){var r=t.exports={version:"1.2.2"};"number"==typeof __e&&(__e=r)},function(t,n){var r=t.exports="undefined"!=typeof window&&window.Math==Math?window:"undefined"!=typeof self&&self.Math==Math?self:Function("return this")();"number"==typeof __g&&(__g=r)},function(t,n,r){var e=r(2),o=r(1),i=r(4),u=r(19),c="prototype",f=function(t,n){return function(){return t.apply(n,arguments)}},s=function(t,n,r){var a,p,l,y,d=t&s.G,h=t&s.P,v=d?e:t&s.S?e[n]||(e[n]={}):(e[n]||{})[c],x=d?o:o[n]||(o[n]={});d&&(r=n);for(a in r)p=!(t&s.F)&&v&&a in v,l=(p?v:r)[a],y=t&s.B&&p?f(l,e):h&&"function"==typeof l?f(Function.call,l):l,v&&!p&&u(v,a,l),x[a]!=l&&i(x,a,y),h&&((x[c]||(x[c]={}))[a]=l)};e.core=o,s.F=1,s.G=2,s.S=4,s.P=8,s.B=16,s.W=32,t.exports=s},function(t,n,r){var e=r(5),o=r(18);t.exports=r(22)?function(t,n,r){return e.setDesc(t,n,o(1,r))}:function(t,n,r){return t[n]=r,t}},function(t,n){var r=Object;t.exports={create:r.create,getProto:r.getPrototypeOf,isEnum:{}.propertyIsEnumerable,getDesc:r.getOwnPropertyDescriptor,setDesc:r.defineProperty,setDescs:r.defineProperties,getKeys:r.keys,getNames:r.getOwnPropertyNames,getSymbols:r.getOwnPropertySymbols,each:[].forEach}},function(t,n){var r=0,e=Math.random();t.exports=function(t){return"Symbol(".concat(void 0===t?"":t,")_",(++r+e).toString(36))}},function(t,n,r){var e=r(20)("wks"),o=r(2).Symbol;t.exports=function(t){return e[t]||(e[t]=o&&o[t]||(o||r(6))("Symbol."+t))}},function(t,n,r){r(26),t.exports=r(1).Array.some},function(t,n,r){r(25),t.exports=r(1).String.endsWith},function(t,n){t.exports=function(t){if("function"!=typeof t)throw TypeError(t+" is not a function!");return t}},function(t,n){var r={}.toString;t.exports=function(t){return r.call(t).slice(8,-1)}},function(t,n,r){var e=r(10);t.exports=function(t,n,r){if(e(t),void 0===n)return t;switch(r){case 1:return function(r){return t.call(n,r)};case 2:return function(r,e){return t.call(n,r,e)};case 3:return function(r,e,o){return t.call(n,r,e,o)}}return function(){return t.apply(n,arguments)}}},function(t,n){t.exports=function(t){if(void 0==t)throw TypeError("Can't call method on  "+t);return t}},function(t,n,r){t.exports=function(t){var n=/./;try{"/./"[t](n)}catch(e){try{return n[r(7)("match")]=!1,!"/./"[t](n)}catch(o){}}return!0}},function(t,n){t.exports=function(t){try{return!!t()}catch(n){return!0}}},function(t,n){t.exports=function(t){return"object"==typeof t?null!==t:"function"==typeof t}},function(t,n,r){var e=r(16),o=r(11),i=r(7)("match");t.exports=function(t){var n;return e(t)&&(void 0!==(n=t[i])?!!n:"RegExp"==o(t))}},function(t,n){t.exports=function(t,n){return{enumerable:!(1&t),configurable:!(2&t),writable:!(4&t),value:n}}},function(t,n,r){var e=r(2),o=r(4),i=r(6)("src"),u="toString",c=Function[u],f=(""+c).split(u);r(1).inspectSource=function(t){return c.call(t)},(t.exports=function(t,n,r,u){"function"==typeof r&&(o(r,i,t[n]?""+t[n]:f.join(String(n))),"name"in r||(r.name=n)),t===e?t[n]=r:(u||delete t[n],o(t,n,r))})(Function.prototype,u,function(){return"function"==typeof this&&this[i]||c.call(this)})},function(t,n,r){var e=r(2),o="__core-js_shared__",i=e[o]||(e[o]={});t.exports=function(t){return i[t]||(i[t]={})}},function(t,n,r){var e=r(17),o=r(13);t.exports=function(t,n,r){if(e(n))throw TypeError("String#"+r+" doesn't accept regex!");return String(o(t))}},function(t,n,r){t.exports=!r(15)(function(){return 7!=Object.defineProperty({},"a",{get:function(){return 7}}).a})},function(t,n){var r=Math.ceil,e=Math.floor;t.exports=function(t){return isNaN(t=+t)?0:(t>0?e:r)(t)}},function(t,n,r){var e=r(23),o=Math.min;t.exports=function(t){return t>0?o(e(t),9007199254740991):0}},function(t,n,r){"use strict";var e=r(3),o=r(24),i=r(21),u="endsWith",c=""[u];e(e.P+e.F*r(14)(u),"String",{endsWith:function(t){var n=i(this,t,u),r=arguments,e=r.length>1?r[1]:void 0,f=o(n.length),s=void 0===e?f:Math.min(o(e),f),a=String(t);return c?c.call(n,a,s):n.slice(s-a.length,s)===a}})},function(t,n,r){var e=r(5),o=r(3),i=r(1).Array||Array,u={},c=function(t,n){e.each.call(t.split(","),function(t){void 0==n&&t in i?u[t]=i[t]:t in[]&&(u[t]=r(12)(Function.call,[][t],n))})};c("pop,reverse,shift,keys,values,entries",1),c("indexOf,every,some,forEach,map,filter,find,findIndex,includes",3),c("join,slice,concat,push,splice,unshift,sort,lastIndexOf,reduce,reduceRight,copyWithin,fill"),o(o.S,"Array",u)}]);

/***/ }),

/***/ 725:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  rejected: {
    borderStyle: 'solid',
    borderColor: '#c66',
    backgroundColor: '#eee'
  },
  disabled: {
    opacity: 0.5
  },
  active: {
    borderStyle: 'solid',
    borderColor: '#6c6',
    backgroundColor: '#eee'
  },
  default: {
    width: 200,
    height: 200,
    borderWidth: 2,
    borderColor: '#666',
    borderStyle: 'dashed',
    borderRadius: 5
  }
});

/***/ }),

/***/ 726:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(727);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(699)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--5-2!../../../../node_modules/sass-loader/lib/loader.js!../../../../node_modules/postcss-loader/lib/index.js??postcss!./InputFile.scss", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js??ref--5-2!../../../../node_modules/sass-loader/lib/loader.js!../../../../node_modules/postcss-loader/lib/index.js??postcss!./InputFile.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 727:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(698)(false);
// imports


// module
exports.push([module.i, ".input-file__container{cursor:pointer}.input-file__select{display:-ms-flexbox;display:flex;color:#008ddf}.input-file__footnote{font-weight:400;font-size:13px;line-height:1.4;letter-spacing:-.6px;color:#adadad}.input-file__footnote--is-error{color:#ff2e1e}.input-file__icon{font-size:24px}.input-file__icon--preview-visible{padding-top:12px}.input-file__label{font-size:13px;margin-left:4px;padding-top:4px}.input-file__label--preview-visible{padding-top:16px}.input-file__preview{height:48px;width:48px;border-radius:100px;margin-right:16px}", ""]);

// exports


/***/ }),

/***/ 728:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return InputFileCard; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dropzone__ = __webpack_require__(711);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_intl__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_redux_form__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_Button__ = __webpack_require__(230);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_constants_image__ = __webpack_require__(231);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__InputFileCard_scss__ = __webpack_require__(729);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__InputFileCard_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__InputFileCard_scss__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();








var InputFileCard = /** @class */ (function (_super) {
    __extends(InputFileCard, _super);
    function InputFileCard(props) {
        var _this = _super.call(this, props) || this;
        _this.state = { selectedImageFile: undefined };
        _this.onFileSelected = _this.onFileSelected.bind(_this);
        return _this;
    }
    InputFileCard.prototype.componentWillMount = function () {
        var input = this.props.input;
        if (input.value) {
            this.setState({ selectedImageFile: input.value });
        }
    };
    InputFileCard.prototype.componentWillReceiveProps = function (nextProps) {
        if (nextProps.input.value && this.props.input.value !== nextProps.input.value) {
            this.setState({ selectedImageFile: nextProps.input.value });
        }
    };
    InputFileCard.prototype.render = function () {
        var _a = this.props, className = _a.className, input = _a.input;
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_dropzone__["a" /* default */], { className: __WEBPACK_IMPORTED_MODULE_0_classnames__('input-file-card__container', className), name: input.name, accept: "image/*", multiple: false, onDrop: this.onFileSelected }, this.preview));
    };
    Object.defineProperty(InputFileCard.prototype, "preview", {
        get: function () {
            var _a = this.props, imageSrc = _a.imageSrc, label = _a.label, meta = _a.meta;
            var selectedImageFile = this.state.selectedImageFile;
            if (!meta.error && selectedImageFile && selectedImageFile.preview) {
                return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "o-container__flex-column o-container__flex--center" },
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("span", { className: "input-file-card__image-preview-container" },
                        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("img", { src: selectedImageFile.preview, className: "input-file-card__image-preview" }))));
            }
            return [(__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { key: "inputFileCardTopPreview", className: "input-file-card__top-preview o-container__flex-row o-container__flex-vertical--space-between" },
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("span", null, label),
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("span", { className: "input-file-card__icon-container" },
                        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("img", { className: "input-file-card__image-icon", src: imageSrc })))), (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { key: "inputFileCardBottomPreview", className: "input-file-card__bottom-preview o-container__flex-row o-container__flex-vertical--space-between" },
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5_components_Button__["a" /* Button */], { type: "button", className: "input-file-card__button button--outline-blue o-container__flex--full" },
                        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_react_intl__["c" /* FormattedMessage */], { id: "form.upload.button" })),
                    this.footnote))];
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputFileCard.prototype, "footnote", {
        get: function () {
            var meta = this.props.meta;
            if (meta.error) {
                return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("span", { className: "input-file-card__footnote input-file-card__footnote--is-error" },
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_react_intl__["c" /* FormattedMessage */], { id: meta.error })));
            }
            return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("span", { className: "input-file-card__footnote" },
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_react_intl__["c" /* FormattedMessage */], { id: "form.footnote.upload.limit.info", values: { sizeInMb: __WEBPACK_IMPORTED_MODULE_6_constants_image__["d" /* MAX_IMAGE_FILE_SIZE_IN_MB */] } })));
        },
        enumerable: true,
        configurable: true
    });
    InputFileCard.prototype.onFileSelected = function (selectedFiles) {
        var _a = this.props, input = _a.input, meta = _a.meta;
        meta.dispatch(Object(__WEBPACK_IMPORTED_MODULE_4_redux_form__["b" /* change */])(meta.form, input.name, selectedFiles[0]));
    };
    return InputFileCard;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));



/***/ }),

/***/ 729:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(730);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(699)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--5-2!../../../../node_modules/sass-loader/lib/loader.js!../../../../node_modules/postcss-loader/lib/index.js??postcss!./InputFileCard.scss", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js??ref--5-2!../../../../node_modules/sass-loader/lib/loader.js!../../../../node_modules/postcss-loader/lib/index.js??postcss!./InputFileCard.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 730:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(698)(false);
// imports


// module
exports.push([module.i, ".input-file-card__container{background-color:#fff;border-radius:4px;overflow:hidden;min-height:186px}.input-file-card__image-icon{width:105px}.input-file-card__image-preview-container{max-height:186px}.input-file-card__image-preview{border-radius:4px;height:100%;max-width:100%;max-height:inherit}.input-file-card__top-preview{padding:20px}.input-file-card__bottom-preview{padding:0 20px 20px}.input-file-card__button{text-transform:uppercase}.input-file-card__footnote{display:-ms-flexbox;display:flex;-ms-flex-line-pack:center;align-content:center;-ms-flex-align:center;align-items:center;-ms-flex-pack:center;justify-content:center;text-align:center;color:#adadad;width:105px}.input-file-card__footnote--is-error{color:#ff2e1e}.input-file-card__footnote,.input-file-card__icon-container{margin-left:16px}", ""]);

// exports


/***/ }),

/***/ 731:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return InputOtp; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_intl__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux_form__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__InputOtp_scss__ = __webpack_require__(732);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__InputOtp_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__InputOtp_scss__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();





var InputOtp = /** @class */ (function (_super) {
    __extends(InputOtp, _super);
    function InputOtp() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.input = [];
        _this.inputTotal = 6;
        return _this;
    }
    InputOtp.prototype.focus = function () {
        var firstIndex = 0;
        return this.input[firstIndex].focus();
    };
    InputOtp.prototype.render = function () {
        var _a = this.props, className = _a.className, meta = _a.meta;
        var classNameError = meta.touched && meta.error && 'input-otp__footnote--is-error';
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: __WEBPACK_IMPORTED_MODULE_0_classnames__('input-otp__container', className) },
            this.inputHtml,
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("p", { className: __WEBPACK_IMPORTED_MODULE_0_classnames__('input-otp__footnote', classNameError) }, meta.touched && meta.error && __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("span", null,
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_intl__["c" /* FormattedMessage */], { id: meta.error })))));
    };
    Object.defineProperty(InputOtp.prototype, "value", {
        get: function () {
            return this.input.map(function (htmlInputElement) { return htmlInputElement.value; }).join('').toUpperCase();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputOtp.prototype, "inputHtml", {
        get: function () {
            var _a = this.props, disabled = _a.disabled, meta = _a.meta;
            var inputs = [];
            var classNameError = meta.touched && meta.error && 'input-otp__element--is-error';
            for (var index = 0; index < this.inputTotal; index++) {
                inputs.push(__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("input", { className: __WEBPACK_IMPORTED_MODULE_0_classnames__('input-otp__element', classNameError), type: "number", min: "0", max: "9", autoComplete: "off", disabled: disabled, key: index, onChange: this.onChange.bind(this, index), onFocus: this.onFocus.bind(this, index), onKeyDown: this.onKeyDown.bind(this, index), ref: this.setReference.bind(this, index) }));
            }
            return inputs;
        },
        enumerable: true,
        configurable: true
    });
    InputOtp.prototype.isAllInputValid = function () {
        return this.input.every(function (htmlInputElement) { return !!htmlInputElement.value; });
    };
    InputOtp.prototype.onChange = function (index, event) {
        if (!this.isValidValue(this.input[index].value)) {
            this.input[index].value = '';
        }
        if (this.input[index].value.length > 1) {
            this.input[index].value = this.input[index].value.slice(0, 1);
        }
        var _a = this.props, input = _a.input, meta = _a.meta, onComplete = _a.onComplete;
        if (this.isAllInputValid()) {
            meta.dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_redux_form__["b" /* change */])(meta.form, input.name, this.value));
            if (onComplete) {
                setTimeout(function () { return onComplete(); }, 0);
            }
        }
        else {
            meta.dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_redux_form__["b" /* change */])(meta.form, input.name, ''));
        }
        if (this.isValidValue(this.input[index].value)) {
            this.setNextInputFocus(index);
        }
    };
    InputOtp.prototype.onFocus = function (indexOfInput) {
        for (var index = 0; index < indexOfInput; index++) {
            if (!this.input[index].value) {
                this.input[index].focus();
                break;
            }
        }
    };
    InputOtp.prototype.onKeyDown = function (index, event) {
        var key = event.keyCode || event.charCode;
        var previousIndex = index - 1;
        var backspaceKey = 8;
        if (key === backspaceKey && !this.input[index].value && this.input[previousIndex]) {
            this.input[previousIndex].value = '';
            this.input[previousIndex].focus();
        }
    };
    InputOtp.prototype.isValidValue = function (value) {
        var regExp = /[0-9]/;
        return regExp.test(value);
    };
    InputOtp.prototype.setNextInputFocus = function (currentIndex) {
        var index = currentIndex + 1;
        if (this.input[index]) {
            this.input[index].focus();
        }
    };
    InputOtp.prototype.setReference = function (index, htmlInputElement) {
        if (htmlInputElement && !this.input[index]) {
            this.input.push(htmlInputElement);
        }
    };
    return InputOtp;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));



/***/ }),

/***/ 732:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(733);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(699)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--5-2!../../../../node_modules/sass-loader/lib/loader.js!../../../../node_modules/postcss-loader/lib/index.js??postcss!./InputOtp.scss", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js??ref--5-2!../../../../node_modules/sass-loader/lib/loader.js!../../../../node_modules/postcss-loader/lib/index.js??postcss!./InputOtp.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 733:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(698)(false);
// imports


// module
exports.push([module.i, ".input-otp__container{text-align:center}.input-otp__footnote{font-weight:400;font-size:13px;line-height:1.4;letter-spacing:-.6px;margin-top:4px;margin-bottom:0;min-height:20px;line-height:20px;color:#adadad}.input-otp__footnote--is-error{color:#ff2e1e}.input-otp__element{display:inline-block;border:none;-webkit-box-sizing:border-box;box-sizing:border-box;-webkit-box-shadow:none;box-shadow:none;outline:none;text-align:center;border-bottom:1px solid #bdbdbd;border-radius:0;height:44px;width:44px;margin:4px;padding:0;-moz-appearance:textfield;background-image:none;background-color:transparent;color:#292929}.input-otp__element:focus{height:45px;margin-bottom:-1px;border-color:#008ddf;border-width:2px}.input-otp__element:-moz-read-only,.input-otp__element:disabled{cursor:not-allowed;background-color:transparent;opacity:1}.input-otp__element:disabled,.input-otp__element:read-only{cursor:not-allowed;background-color:transparent;opacity:1}.input-otp__element::-webkit-inner-spin-button,.input-otp__element::-webkit-outer-spin-button{-webkit-appearance:none;margin:0}.input-otp__element--is-error,.input-otp__element--is-error:focus{border-bottom-color:#ff2e1e}@media (max-width:543px){.input-otp__element{width:37px;height:37px}.input-otp__element:focus{height:38px}}", ""]);

// exports


/***/ }),

/***/ 734:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return InputSelect; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_select__ = __webpack_require__(735);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_intl__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_redux_form__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_select_scss_default_scss__ = __webpack_require__(741);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_select_scss_default_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_select_scss_default_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__InputSelect_scss__ = __webpack_require__(743);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__InputSelect_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__InputSelect_scss__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();







var InputSelect = /** @class */ (function (_super) {
    __extends(InputSelect, _super);
    function InputSelect(props) {
        var _this = _super.call(this, props) || this;
        _this.onBlur = _this.onBlur.bind(_this);
        _this.onChange = _this.onChange.bind(_this);
        _this.setReference = _this.setReference.bind(_this);
        return _this;
    }
    InputSelect.prototype.focus = function () {
        return this.input.focus();
    };
    InputSelect.prototype.render = function () {
        var _a = this.props, className = _a.className, disabled = _a.disabled, footnote = _a.footnote, input = _a.input, isLoading = _a.isLoading, label = _a.label, meta = _a.meta, noResultsText = _a.noResultsText, options = _a.options;
        var classNameError = meta.touched && meta.error && 'input-select--is-error';
        var classNameFootnoteError = meta.touched && meta.error && 'input-select__footnote--is-error';
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: __WEBPACK_IMPORTED_MODULE_0_classnames__('input-select__container', className, classNameError) },
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_select___default.a, { clearable: false, disabled: disabled || isLoading, isLoading: isLoading, noResultsText: noResultsText, options: options, onBlur: this.onBlur, onChange: this.onChange, placeholder: "", ref: this.setReference, value: input.value }),
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("label", { className: "input-select__label" }, label),
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("p", { className: "input-select__footnote" },
                meta.touched && meta.error && __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("span", { className: __WEBPACK_IMPORTED_MODULE_0_classnames__(classNameFootnoteError) },
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_react_intl__["c" /* FormattedMessage */], { id: meta.error })),
                !classNameFootnoteError && footnote && __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("span", null, footnote))));
    };
    InputSelect.prototype.onBlur = function (event) {
        var _a = this.props, input = _a.input, meta = _a.meta;
        if (!input.value) {
            meta.dispatch(__WEBPACK_IMPORTED_MODULE_4_redux_form__["g" /* touch */].apply(void 0, [meta.form].concat([input.name])));
        }
    };
    InputSelect.prototype.onChange = function (option) {
        var _a = this.props, input = _a.input, meta = _a.meta;
        meta.dispatch(Object(__WEBPACK_IMPORTED_MODULE_4_redux_form__["b" /* change */])(meta.form, input.name, option ? option.value : ''));
    };
    InputSelect.prototype.setReference = function (reactSelect) {
        this.input = reactSelect;
    };
    return InputSelect;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));



/***/ }),

/***/ 735:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.Value = exports.Creatable = exports.AsyncCreatable = exports.Async = undefined;

var _Select = __webpack_require__(710);

var _Select2 = _interopRequireDefault(_Select);

var _Async = __webpack_require__(716);

var _Async2 = _interopRequireDefault(_Async);

var _AsyncCreatable = __webpack_require__(740);

var _AsyncCreatable2 = _interopRequireDefault(_AsyncCreatable);

var _Creatable = __webpack_require__(717);

var _Creatable2 = _interopRequireDefault(_Creatable);

var _Value = __webpack_require__(715);

var _Value2 = _interopRequireDefault(_Value);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_Select2.default.Async = _Async2.default;
_Select2.default.AsyncCreatable = _AsyncCreatable2.default;
_Select2.default.Creatable = _Creatable2.default;
_Select2.default.Value = _Value2.default;

exports.default = _Select2.default;
exports.Async = _Async2.default;
exports.AsyncCreatable = _AsyncCreatable2.default;
exports.Creatable = _Creatable2.default;
exports.Value = _Value2.default;

/***/ }),

/***/ 736:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var sizerStyle = {
	position: 'absolute',
	top: 0,
	left: 0,
	visibility: 'hidden',
	height: 0,
	overflow: 'scroll',
	whiteSpace: 'pre'
};

var AutosizeInput = function (_Component) {
	_inherits(AutosizeInput, _Component);

	function AutosizeInput(props) {
		_classCallCheck(this, AutosizeInput);

		var _this = _possibleConstructorReturn(this, (AutosizeInput.__proto__ || Object.getPrototypeOf(AutosizeInput)).call(this, props));

		_this.inputRef = function (el) {
			_this.input = el;
			if (typeof _this.props.inputRef === 'function') {
				_this.props.inputRef(el);
			}
		};

		_this.placeHolderSizerRef = function (el) {
			_this.placeHolderSizer = el;
		};

		_this.sizerRef = function (el) {
			_this.sizer = el;
		};

		_this.state = {
			inputWidth: props.minWidth,
			inputId: '_' + Math.random().toString(36).substr(2, 12)
		};
		return _this;
	}

	_createClass(AutosizeInput, [{
		key: 'componentDidMount',
		value: function componentDidMount() {
			this.mounted = true;
			this.copyInputStyles();
			this.updateInputWidth();
		}
	}, {
		key: 'componentDidUpdate',
		value: function componentDidUpdate(prevProps, prevState) {
			if (prevState.inputWidth !== this.state.inputWidth) {
				if (typeof this.props.onAutosize === 'function') {
					this.props.onAutosize(this.state.inputWidth);
				}
			}
			this.updateInputWidth();
		}
	}, {
		key: 'componentWillUnmount',
		value: function componentWillUnmount() {
			this.mounted = false;
		}
	}, {
		key: 'copyInputStyles',
		value: function copyInputStyles() {
			if (!this.mounted || !window.getComputedStyle) {
				return;
			}
			var inputStyle = this.input && window.getComputedStyle(this.input);
			if (!inputStyle) {
				return;
			}
			var widthNode = this.sizer;
			widthNode.style.fontSize = inputStyle.fontSize;
			widthNode.style.fontFamily = inputStyle.fontFamily;
			widthNode.style.fontWeight = inputStyle.fontWeight;
			widthNode.style.fontStyle = inputStyle.fontStyle;
			widthNode.style.letterSpacing = inputStyle.letterSpacing;
			widthNode.style.textTransform = inputStyle.textTransform;
			if (this.props.placeholder) {
				var placeholderNode = this.placeHolderSizer;
				placeholderNode.style.fontSize = inputStyle.fontSize;
				placeholderNode.style.fontFamily = inputStyle.fontFamily;
				placeholderNode.style.fontWeight = inputStyle.fontWeight;
				placeholderNode.style.fontStyle = inputStyle.fontStyle;
				placeholderNode.style.letterSpacing = inputStyle.letterSpacing;
				placeholderNode.style.textTransform = inputStyle.textTransform;
			}
		}
	}, {
		key: 'updateInputWidth',
		value: function updateInputWidth() {
			if (!this.mounted || !this.sizer || typeof this.sizer.scrollWidth === 'undefined') {
				return;
			}
			var newInputWidth = void 0;
			if (this.props.placeholder && (!this.props.value || this.props.value && this.props.placeholderIsMinWidth)) {
				newInputWidth = Math.max(this.sizer.scrollWidth, this.placeHolderSizer.scrollWidth) + 2;
			} else {
				newInputWidth = this.sizer.scrollWidth + 2;
			}
			if (newInputWidth < this.props.minWidth) {
				newInputWidth = this.props.minWidth;
			}
			if (newInputWidth !== this.state.inputWidth) {
				this.setState({
					inputWidth: newInputWidth
				});
			}
		}
	}, {
		key: 'getInput',
		value: function getInput() {
			return this.input;
		}
	}, {
		key: 'focus',
		value: function focus() {
			this.input.focus();
		}
	}, {
		key: 'blur',
		value: function blur() {
			this.input.blur();
		}
	}, {
		key: 'select',
		value: function select() {
			this.input.select();
		}
	}, {
		key: 'render',
		value: function render() {
			var sizerValue = [this.props.defaultValue, this.props.value, ''].reduce(function (previousValue, currentValue) {
				if (previousValue !== null && previousValue !== undefined) {
					return previousValue;
				}
				return currentValue;
			});

			var wrapperStyle = _extends({}, this.props.style);
			if (!wrapperStyle.display) wrapperStyle.display = 'inline-block';
			var inputStyle = _extends({}, this.props.inputStyle);
			inputStyle.width = this.state.inputWidth + 'px';
			inputStyle.boxSizing = 'content-box';

			var inputProps = _objectWithoutProperties(this.props, []);

			inputProps.className = this.props.inputClassName;
			inputProps.style = inputStyle;
			// ensure props meant for `AutosizeInput` don't end up on the `input`
			delete inputProps.inputClassName;
			delete inputProps.inputStyle;
			delete inputProps.minWidth;
			delete inputProps.onAutosize;
			delete inputProps.placeholderIsMinWidth;
			delete inputProps.inputRef;
			return _react2.default.createElement(
				'div',
				{ className: this.props.className, style: wrapperStyle },
				_react2.default.createElement('style', { dangerouslySetInnerHTML: {
						__html: ['input#' + this.state.id + '::-ms-clear {display: none;}'].join('\n')
					} }),
				_react2.default.createElement('input', _extends({ id: this.state.id }, inputProps, { ref: this.inputRef })),
				_react2.default.createElement(
					'div',
					{ ref: this.sizerRef, style: sizerStyle },
					sizerValue
				),
				this.props.placeholder ? _react2.default.createElement(
					'div',
					{ ref: this.placeHolderSizerRef, style: sizerStyle },
					this.props.placeholder
				) : null
			);
		}
	}]);

	return AutosizeInput;
}(_react.Component);

;

AutosizeInput.propTypes = {
	className: _propTypes2.default.string, // className for the outer element
	defaultValue: _propTypes2.default.any, // default field value
	inputClassName: _propTypes2.default.string, // className for the input element
	inputRef: _propTypes2.default.func, // ref callback for the input element
	inputStyle: _propTypes2.default.object, // css styles for the input element
	minWidth: _propTypes2.default.oneOfType([// minimum width for input element
	_propTypes2.default.number, _propTypes2.default.string]),
	onAutosize: _propTypes2.default.func, // onAutosize handler: function(newWidth) {}
	onChange: _propTypes2.default.func, // onChange handler: function(newValue) {}
	placeholder: _propTypes2.default.string, // placeholder text
	placeholderIsMinWidth: _propTypes2.default.bool, // don't collapse size to less than the placeholder
	style: _propTypes2.default.object, // css styles for the outer element
	value: _propTypes2.default.any // field value
};
AutosizeInput.defaultProps = {
	minWidth: 1
};

exports.default = AutosizeInput;

/***/ }),

/***/ 737:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = arrowRenderer;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function arrowRenderer(_ref) {
	var onMouseDown = _ref.onMouseDown;

	return _react2.default.createElement('span', {
		className: 'Select-arrow',
		onMouseDown: onMouseDown
	});
};

arrowRenderer.propTypes = {
	onMouseDown: _propTypes2.default.func
};

/***/ }),

/***/ 738:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = clearRenderer;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function clearRenderer() {
	return _react2.default.createElement('span', {
		className: 'Select-clear',
		dangerouslySetInnerHTML: { __html: '&times;' }
	});
};

/***/ }),

/***/ 739:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(9);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Option = function (_React$Component) {
	_inherits(Option, _React$Component);

	function Option(props) {
		_classCallCheck(this, Option);

		var _this = _possibleConstructorReturn(this, (Option.__proto__ || Object.getPrototypeOf(Option)).call(this, props));

		_this.handleMouseDown = _this.handleMouseDown.bind(_this);
		_this.handleMouseEnter = _this.handleMouseEnter.bind(_this);
		_this.handleMouseMove = _this.handleMouseMove.bind(_this);
		_this.handleTouchStart = _this.handleTouchStart.bind(_this);
		_this.handleTouchEnd = _this.handleTouchEnd.bind(_this);
		_this.handleTouchMove = _this.handleTouchMove.bind(_this);
		_this.onFocus = _this.onFocus.bind(_this);
		return _this;
	}

	_createClass(Option, [{
		key: 'blockEvent',
		value: function blockEvent(event) {
			event.preventDefault();
			event.stopPropagation();
			if (event.target.tagName !== 'A' || !('href' in event.target)) {
				return;
			}
			if (event.target.target) {
				window.open(event.target.href, event.target.target);
			} else {
				window.location.href = event.target.href;
			}
		}
	}, {
		key: 'handleMouseDown',
		value: function handleMouseDown(event) {
			event.preventDefault();
			event.stopPropagation();
			this.props.onSelect(this.props.option, event);
		}
	}, {
		key: 'handleMouseEnter',
		value: function handleMouseEnter(event) {
			this.onFocus(event);
		}
	}, {
		key: 'handleMouseMove',
		value: function handleMouseMove(event) {
			this.onFocus(event);
		}
	}, {
		key: 'handleTouchEnd',
		value: function handleTouchEnd(event) {
			// Check if the view is being dragged, In this case
			// we don't want to fire the click event (because the user only wants to scroll)
			if (this.dragging) return;

			this.handleMouseDown(event);
		}
	}, {
		key: 'handleTouchMove',
		value: function handleTouchMove(event) {
			// Set a flag that the view is being dragged
			this.dragging = true;
		}
	}, {
		key: 'handleTouchStart',
		value: function handleTouchStart(event) {
			// Set a flag that the view is not being dragged
			this.dragging = false;
		}
	}, {
		key: 'onFocus',
		value: function onFocus(event) {
			if (!this.props.isFocused) {
				this.props.onFocus(this.props.option, event);
			}
		}
	}, {
		key: 'render',
		value: function render() {
			var _props = this.props,
			    option = _props.option,
			    instancePrefix = _props.instancePrefix,
			    optionIndex = _props.optionIndex;

			var className = (0, _classnames2.default)(this.props.className, option.className);

			return option.disabled ? _react2.default.createElement(
				'div',
				{ className: className,
					onMouseDown: this.blockEvent,
					onClick: this.blockEvent },
				this.props.children
			) : _react2.default.createElement(
				'div',
				{ className: className,
					style: option.style,
					role: 'option',
					onMouseDown: this.handleMouseDown,
					onMouseEnter: this.handleMouseEnter,
					onMouseMove: this.handleMouseMove,
					onTouchStart: this.handleTouchStart,
					onTouchMove: this.handleTouchMove,
					onTouchEnd: this.handleTouchEnd,
					id: instancePrefix + '-option-' + optionIndex,
					title: option.title },
				this.props.children
			);
		}
	}]);

	return Option;
}(_react2.default.Component);

;

Option.propTypes = {
	children: _propTypes2.default.node,
	className: _propTypes2.default.string, // className (based on mouse position)
	instancePrefix: _propTypes2.default.string.isRequired, // unique prefix for the ids (used for aria)
	isDisabled: _propTypes2.default.bool, // the option is disabled
	isFocused: _propTypes2.default.bool, // the option is focused
	isSelected: _propTypes2.default.bool, // the option is selected
	onFocus: _propTypes2.default.func, // method to handle mouseEnter on option element
	onSelect: _propTypes2.default.func, // method to handle click on option element
	onUnfocus: _propTypes2.default.func, // method to handle mouseLeave on option element
	option: _propTypes2.default.object.isRequired, // object that is base for that option
	optionIndex: _propTypes2.default.number // index of the option, used to generate unique ids for aria
};

exports.default = Option;

/***/ }),

/***/ 740:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Select = __webpack_require__(710);

var _Select2 = _interopRequireDefault(_Select);

var _Async = __webpack_require__(716);

var _Async2 = _interopRequireDefault(_Async);

var _Creatable = __webpack_require__(717);

var _Creatable2 = _interopRequireDefault(_Creatable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function reduce(obj) {
	var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

	return Object.keys(obj).reduce(function (props, key) {
		var value = obj[key];
		if (value !== undefined) props[key] = value;
		return props;
	}, props);
}

var AsyncCreatableSelect = function (_React$Component) {
	_inherits(AsyncCreatableSelect, _React$Component);

	function AsyncCreatableSelect() {
		_classCallCheck(this, AsyncCreatableSelect);

		return _possibleConstructorReturn(this, (AsyncCreatableSelect.__proto__ || Object.getPrototypeOf(AsyncCreatableSelect)).apply(this, arguments));
	}

	_createClass(AsyncCreatableSelect, [{
		key: 'focus',
		value: function focus() {
			this.select.focus();
		}
	}, {
		key: 'render',
		value: function render() {
			var _this2 = this;

			return _react2.default.createElement(
				_Async2.default,
				this.props,
				function (asyncProps) {
					return _react2.default.createElement(
						_Creatable2.default,
						_this2.props,
						function (creatableProps) {
							return _react2.default.createElement(_Select2.default, _extends({}, reduce(asyncProps, reduce(creatableProps, {})), {
								onInputChange: function onInputChange(input) {
									creatableProps.onInputChange(input);
									return asyncProps.onInputChange(input);
								},
								ref: function ref(_ref) {
									_this2.select = _ref;
									creatableProps.ref(_ref);
									asyncProps.ref(_ref);
								}
							}));
						}
					);
				}
			);
		}
	}]);

	return AsyncCreatableSelect;
}(_react2.default.Component);

;

exports.default = AsyncCreatableSelect;

/***/ }),

/***/ 741:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(742);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(699)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../css-loader/index.js??ref--5-2!../../sass-loader/lib/loader.js!../../postcss-loader/lib/index.js??postcss!./default.scss", function() {
			var newContent = require("!!../../css-loader/index.js??ref--5-2!../../sass-loader/lib/loader.js!../../postcss-loader/lib/index.js??postcss!./default.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 742:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(698)(false);
// imports


// module
exports.push([module.i, ".Select{position:relative}.Select,.Select div,.Select input,.Select span{-webkit-box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box}.Select.is-disabled>.Select-control{background-color:#f9f9f9}.Select.is-disabled>.Select-control:hover{box-shadow:none}.Select.is-disabled .Select-arrow-zone{cursor:default;pointer-events:none}.Select-control{background-color:#fff;border-color:#d9d9d9 #ccc #b3b3b3;border-radius:4px;border:1px solid #ccc;color:#333;cursor:default;display:table;border-spacing:0;border-collapse:separate;height:36px;outline:none;overflow:hidden;position:relative;width:100%}.Select-control:hover{box-shadow:0 1px 0 rgba(0,0,0,.06)}.Select-control .Select-input:focus{outline:none}.is-searchable.is-open>.Select-control{cursor:text}.is-open>.Select-control{border-bottom-right-radius:0;border-bottom-left-radius:0;background:#fff;border-color:#b3b3b3 #ccc #d9d9d9}.is-open>.Select-control .Select-arrow{top:-2px;border-color:transparent transparent #999;border-width:0 5px 5px}.is-searchable.is-focused:not(.is-open)>.Select-control{cursor:text}.is-focused:not(.is-open)>.Select-control{border-color:#08c #0099e6 #0099e6;box-shadow:inset 0 1px 2px rgba(0,0,0,.1),0 0 5px -1px fade(#08c,50%)}.Select--single>.Select-control .Select-value,.Select-placeholder{bottom:0;color:#aaa;left:0;line-height:34px;padding-left:10px;padding-right:10px;position:absolute;right:0;top:0;max-width:100%;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.has-value.is-clearable.Select--single>.Select-control .Select-value{padding-right:42px}.has-value.is-pseudo-focused.Select--single>.Select-control .Select-value .Select-value-label,.has-value.Select--single>.Select-control .Select-value .Select-value-label{color:#333}.has-value.is-pseudo-focused.Select--single>.Select-control .Select-value a.Select-value-label,.has-value.Select--single>.Select-control .Select-value a.Select-value-label{cursor:pointer;text-decoration:none}.has-value.is-pseudo-focused.Select--single>.Select-control .Select-value a.Select-value-label:focus,.has-value.is-pseudo-focused.Select--single>.Select-control .Select-value a.Select-value-label:hover,.has-value.Select--single>.Select-control .Select-value a.Select-value-label:focus,.has-value.Select--single>.Select-control .Select-value a.Select-value-label:hover{color:#08c;outline:none;text-decoration:underline}.Select-input{height:34px;padding-left:10px;padding-right:10px;vertical-align:middle}.Select-input>input{background:none transparent;border:0 none;box-shadow:none;cursor:default;display:inline-block;font-family:inherit;font-size:inherit;margin:0;outline:none;line-height:14px;padding:8px 0 12px;-webkit-appearance:none}.is-focused .Select-input>input{cursor:text}.has-value.is-pseudo-focused .Select-input{opacity:0}.Select-control:not(.is-searchable)>.Select-input{outline:none}.Select-loading-zone{cursor:pointer;display:table-cell;text-align:center}.Select-loading,.Select-loading-zone{position:relative;vertical-align:middle;width:16px}.Select-loading{-webkit-animation:Select-animation-spin .4s infinite linear;-o-animation:Select-animation-spin .4s infinite linear;animation:Select-animation-spin .4s infinite linear;height:16px;box-sizing:border-box;border-radius:50%;border:2px solid #ccc;border-right-color:#333;display:inline-block}.Select-clear-zone{-webkit-animation:Select-animation-fadeIn .2s;-o-animation:Select-animation-fadeIn .2s;animation:Select-animation-fadeIn .2s;color:#999;cursor:pointer;display:table-cell;position:relative;text-align:center;vertical-align:middle;width:17px}.Select-clear-zone:hover{color:#d0021b}.Select-clear{display:inline-block;font-size:18px;line-height:1}.Select--multi .Select-clear-zone{width:17px}.Select--multi .Select-multi-value-wrapper{display:inline-block}.Select .Select-aria-only{display:inline-block;height:1px;width:1px;margin:-1px;clip:rect(0,0,0,0);overflow:hidden;float:left}.Select-arrow-zone{cursor:pointer;display:table-cell;position:relative;text-align:center;vertical-align:middle;width:25px;padding-right:5px}.Select-arrow{border-color:#999 transparent transparent;border-style:solid;border-width:5px 5px 2.5px;display:inline-block;height:0;width:0;position:relative}.is-open .Select-arrow,.Select-arrow-zone:hover>.Select-arrow{border-top-color:#666}@-webkit-keyframes Select-animation-fadeIn{0%{opacity:0}to{opacity:1}}@keyframes Select-animation-fadeIn{0%{opacity:0}to{opacity:1}}.Select-menu-outer{border-bottom-right-radius:4px;border-bottom-left-radius:4px;background-color:#fff;border:1px solid #ccc;border-top-color:#e6e6e6;box-shadow:0 1px 0 rgba(0,0,0,.06);box-sizing:border-box;margin-top:-1px;max-height:200px;position:absolute;top:100%;width:100%;z-index:1000;-webkit-overflow-scrolling:touch}.Select-menu{max-height:198px;overflow-y:auto}.Select-option{box-sizing:border-box;background-color:#fff;color:#666;cursor:pointer;display:block;padding:8px 10px}.Select-option:last-child{border-bottom-right-radius:4px;border-bottom-left-radius:4px}.Select-option.is-selected{background-color:#f5faff;color:#333}.Select-option.is-focused{background-color:#f2f9fc;color:#333}.Select-option.is-disabled{color:#ccc;cursor:default}.Select-noresults{box-sizing:border-box;color:#999;cursor:default;display:block;padding:8px 10px}.Select--multi .Select-input{vertical-align:middle;margin-left:10px;padding:0}.Select--multi.has-value .Select-input{margin-left:5px}.Select--multi .Select-value{background-color:#f2f9fc;border-radius:2px;border:1px solid #c9e6f2;color:#08c;display:inline-block;font-size:.9em;margin-left:5px;margin-top:5px;vertical-align:top}.Select--multi .Select-value-icon,.Select--multi .Select-value-label{display:inline-block;vertical-align:middle}.Select--multi .Select-value-label{border-bottom-right-radius:2px;border-top-right-radius:2px;cursor:default;padding:2px 5px}.Select--multi a.Select-value-label{color:#08c;cursor:pointer;text-decoration:none}.Select--multi a.Select-value-label:hover{text-decoration:underline}.Select--multi .Select-value-icon{cursor:pointer;border-bottom-left-radius:2px;border-top-left-radius:2px;border-right:1px solid #c9e6f2;padding:1px 5px 3px}.Select--multi .Select-value-icon:focus,.Select--multi .Select-value-icon:hover{background-color:#ddeff7;color:#0077b3}.Select--multi .Select-value-icon:active{background-color:#c9e6f2}.Select--multi.is-disabled .Select-value{background-color:#fcfcfc;border:1px solid #e3e3e3;color:#333}.Select--multi.is-disabled .Select-value-icon{cursor:not-allowed;border-right:1px solid #e3e3e3}.Select--multi.is-disabled .Select-value-icon:active,.Select--multi.is-disabled .Select-value-icon:focus,.Select--multi.is-disabled .Select-value-icon:hover{background-color:#fcfcfc}@keyframes Select-animation-spin{to{transform:rotate(1turn)}}@-webkit-keyframes Select-animation-spin{to{-webkit-transform:rotate(1turn)}}", ""]);

// exports


/***/ }),

/***/ 743:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(744);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(699)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--5-2!../../../../node_modules/sass-loader/lib/loader.js!../../../../node_modules/postcss-loader/lib/index.js??postcss!./InputSelect.scss", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js??ref--5-2!../../../../node_modules/sass-loader/lib/loader.js!../../../../node_modules/postcss-loader/lib/index.js??postcss!./InputSelect.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 744:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(698)(false);
// imports


// module
exports.push([module.i, ".Select.is-focused:not(.is-open)>.Select-control{border-color:#bdbdbd}.Select.is-focused~.input-select__label{color:#008ddf}.Select.is-focused .Select-control{border-color:#008ddf!important;border-width:2px;height:41px;margin-bottom:-1px}.Select.has-value~.input-select__label,.Select.is-focused~.input-select__label{font-weight:400;font-size:13px;line-height:1.4;letter-spacing:-.6px;-webkit-transform:translate(0);-ms-transform:translate(0);transform:translate(0)}.Select .Select-value-label{line-height:40px}.Select-control{font-weight:400;font-size:14px;line-height:1.3;letter-spacing:-.24px;background-color:transparent!important;border:none;outline:none;-webkit-box-shadow:none!important;box-shadow:none!important;height:40px;border-bottom:1px solid #bdbdbd;border-radius:0}.Select-control .Select-input,.Select-control .Select-value{padding-left:0!important}.Select-control .Select-arrow-zone{padding-right:0!important}.input-select--is-error .Select~.input-select__label{color:rgba(255,46,30,.26)}.input-select--is-error .Select.has-value~.input-select__label,.input-select--is-error .Select.is-focused~.input-select__label{color:#ff2e1e}.input-select--is-error .Select .Select-control{border-bottom-color:#ff2e1e!important}.input-select__container{display:block;position:relative;padding-top:15px}.input-select__footnote{font-weight:400;font-size:13px;line-height:1.4;letter-spacing:-.6px;color:#adadad;margin-bottom:0;margin-top:4px;min-height:20px;line-height:20px}.input-select__footnote--is-error{color:#ff2e1e}.input-select__label{color:#bdbdbd;cursor:text;text-overflow:clip;pointer-events:none;position:absolute;top:0;-webkit-transform:translateY(25px);-ms-transform:translateY(25px);transform:translateY(25px);-webkit-transition:all .15s ease-out;-o-transition:all .15s ease-out;transition:all .15s ease-out}", ""]);

// exports


/***/ }),

/***/ 745:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return InputText; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_text_mask__ = __webpack_require__(746);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_text_mask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_text_mask__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_intl__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_redux_form__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__InputText_scss__ = __webpack_require__(747);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__InputText_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__InputText_scss__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};






var InputText = /** @class */ (function (_super) {
    __extends(InputText, _super);
    function InputText(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            isVisibilityActive: false
        };
        _this.resetInputValue = _this.resetInputValue.bind(_this);
        _this.setReference = _this.setReference.bind(_this);
        _this.toggleVisibility = _this.toggleVisibility.bind(_this);
        return _this;
    }
    InputText.prototype.focus = function () {
        return this.input.focus();
    };
    InputText.prototype.render = function () {
        var _a = this.props, className = _a.className, footnote = _a.footnote, label = _a.label, meta = _a.meta, type = _a.type;
        var classNameFootnoteError = meta.touched && meta.error && 'input-text__footnote--is-error';
        var classNameType = type && 'input-text__container--' + type;
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: __WEBPACK_IMPORTED_MODULE_0_classnames__('input-text__container', classNameType, className) },
            this.inputElement,
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("label", { className: "input-text__label", htmlFor: this.inputId }, label),
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("p", { className: "input-text__footnote" },
                meta.touched && meta.error && __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("span", { className: __WEBPACK_IMPORTED_MODULE_0_classnames__(classNameFootnoteError) },
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_react_intl__["c" /* FormattedMessage */], { id: meta.error })),
                !classNameFootnoteError && footnote && __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("span", null, footnote)),
            this.inputAction));
    };
    Object.defineProperty(InputText.prototype, "inputAction", {
        get: function () {
            var _a = this.props, modifier = _a.modifier, type = _a.type;
            if (modifier === 'cancel') {
                return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("i", { className: "input-text__action input-text__cancel ic-cancel o-icon-action", onTouchStart: this.resetInputValue, onMouseDown: this.resetInputValue }));
            }
            else if (type === 'password' && modifier === 'visibility') {
                var classNameActive = this.state.isVisibilityActive && 'input-text__visibility--is-active';
                return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("i", { className: __WEBPACK_IMPORTED_MODULE_0_classnames__('input-text__action input-text__visibility ic-visibility o-icon-action', classNameActive), onClick: this.toggleVisibility }));
            }
            return null;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputText.prototype, "inputElement", {
        get: function () {
            var _a = this.props, disabled = _a.disabled, input = _a.input, mask = _a.mask, meta = _a.meta, type = _a.type;
            var classNameElementError = meta.touched && meta.error && 'input-text__element--is-error';
            var classNameElementStatus = input.value && 'input-text__element--is-filled';
            if (mask) {
                return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_text_mask___default.a, __assign({ autoComplete: "off", className: __WEBPACK_IMPORTED_MODULE_0_classnames__('input-text__element', classNameElementError, classNameElementStatus), disabled: disabled, guide: false, id: this.inputId, mask: mask, ref: this.setReference, spellCheck: false, type: type }, input)));
            }
            return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("input", __assign({ autoComplete: "off", className: __WEBPACK_IMPORTED_MODULE_0_classnames__('input-text__element', classNameElementError, classNameElementStatus), disabled: disabled, id: this.inputId, ref: this.setReference, spellCheck: false, type: type }, input)));
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputText.prototype, "inputId", {
        get: function () {
            return 'input-text__id-' + this.props.input.name;
        },
        enumerable: true,
        configurable: true
    });
    InputText.prototype.toggleVisibility = function () {
        if (this.input && this.input.type === 'text') {
            this.input.type = 'password';
            this.setState({ isVisibilityActive: false });
        }
        else if (this.input && this.input.type === 'password') {
            this.input.type = 'text';
            this.setState({ isVisibilityActive: true });
        }
    };
    InputText.prototype.resetInputValue = function () {
        var _a = this.props, input = _a.input, meta = _a.meta;
        meta.dispatch(Object(__WEBPACK_IMPORTED_MODULE_4_redux_form__["b" /* change */])(meta.form, input.name, ''));
    };
    InputText.prototype.setReference = function (htmlInputElement) {
        this.input = htmlInputElement && htmlInputElement.inputElement
            ? htmlInputElement.inputElement : htmlInputElement;
    };
    return InputText;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));



/***/ }),

/***/ 746:
/***/ (function(module, exports, __webpack_require__) {

!function(e,t){ true?module.exports=t(__webpack_require__(0)):"function"==typeof define&&define.amd?define(["react"],t):"object"==typeof exports?exports.reactTextMask=t(require("react")):e.reactTextMask=t(e.React)}(this,function(e){return function(e){function t(n){if(r[n])return r[n].exports;var o=r[n]={exports:{},id:n,loaded:!1};return e[n].call(o.exports,o,o.exports,t),o.loaded=!0,o.exports}var r={};return t.m=e,t.c=r,t.p="",t(0)}([function(e,t,r){"use strict";function n(e){return e&&e.__esModule?e:{default:e}}function o(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function i(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function a(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0}),t.conformToMask=void 0;var u=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var r=arguments[t];for(var n in r)Object.prototype.hasOwnProperty.call(r,n)&&(e[n]=r[n])}return e},l=function(){function e(e,t){for(var r=0;r<t.length;r++){var n=t[r];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(e,n.key,n)}}return function(t,r,n){return r&&e(t.prototype,r),n&&e(t,n),t}}(),s=r(2);Object.defineProperty(t,"conformToMask",{enumerable:!0,get:function(){return n(s).default}});var f=r(11),c=n(f),d=r(9),p=n(d),h=r(5),v=n(h),y=function(e){function t(){return o(this,t),i(this,(t.__proto__||Object.getPrototypeOf(t)).apply(this,arguments))}return a(t,e),l(t,[{key:"initTextMask",value:function(){var e=this.props,t=this.props.value;this.textMaskInputElement=(0,v.default)(u({inputElement:this.inputElement},e)),this.textMaskInputElement.update(t)}},{key:"componentDidMount",value:function(){this.initTextMask()}},{key:"componentDidUpdate",value:function(){this.initTextMask()}},{key:"render",value:function(){var e=this,t=u({},this.props);return delete t.mask,delete t.guide,delete t.pipe,delete t.placeholderChar,delete t.keepCharPositions,delete t.value,delete t.onChange,delete t.showMask,c.default.createElement("input",u({},t,{onInput:function(t){return e.onChange(t)},defaultValue:this.props.value,ref:function(t){return e.inputElement=t}}))}},{key:"onChange",value:function(e){this.textMaskInputElement.update(),"function"==typeof this.props.onChange&&this.props.onChange(e)}}]),t}(c.default.Component);t.default=y,y.propTypes={mask:p.default.oneOfType([p.default.array,p.default.func,p.default.bool,p.default.shape({mask:p.default.oneOfType([p.default.array,p.default.func]),pipe:p.default.func})]).isRequired,guide:p.default.bool,value:p.default.oneOfType([p.default.string,p.default.number]),pipe:p.default.func,placeholderChar:p.default.string,keepCharPositions:p.default.bool,showMask:p.default.bool}},function(e,t){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.placeholderChar="_"},function(e,t,r){"use strict";function n(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:a,t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:a,r=arguments.length>2&&void 0!==arguments[2]?arguments[2]:{},n=r.guide,u=void 0===n||n,l=r.previousConformedValue,s=void 0===l?a:l,f=r.placeholderChar,c=void 0===f?i.placeholderChar:f,d=r.placeholder,p=void 0===d?(0,o.convertMaskToPlaceholder)(t,c):d,h=r.currentCaretPosition,v=r.keepCharPositions,y=u===!1&&void 0!==s,m=e.length,g=s.length,b=p.length,C=t.length,k=m-g,O=k>0,P=h+(O?-k:0),x=P+Math.abs(k);if(v===!0&&!O){for(var T=a,_=P;_<x;_++)p[_]===c&&(T+=c);e=e.slice(0,P)+T+e.slice(P,m)}for(var w=e.split(a).map(function(e,t){return{char:e,isNew:t>=P&&t<x}}),M=m-1;M>=0;M--){var j=w[M].char;if(j!==c){var S=M>=P&&g===C;j===p[S?M-k:M]&&w.splice(M,1)}}var E=a,R=!1;e:for(var V=0;V<b;V++){var N=p[V];if(N===c){if(w.length>0)for(;w.length>0;){var I=w.shift(),A=I.char,q=I.isNew;if(A===c&&y!==!0){E+=c;continue e}if(t[V].test(A)){if(v===!0&&q!==!1&&s!==a&&u!==!1&&O){for(var D=w.length,F=null,L=0;L<D;L++){var J=w[L];if(J.char!==c&&J.isNew===!1)break;if(J.char===c){F=L;break}}null!==F?(E+=A,w.splice(F,1)):V--}else E+=A;continue e}R=!0}y===!1&&(E+=p.substr(V,b));break}E+=N}if(y&&O===!1){for(var U=null,W=0;W<E.length;W++)p[W]===c&&(U=W);E=null!==U?E.substr(0,U+1):a}return{conformedValue:E,meta:{someCharsRejected:R}}}Object.defineProperty(t,"__esModule",{value:!0}),t.default=n;var o=r(3),i=r(1),a=""},function(e,t,r){"use strict";function n(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:l,t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:u.placeholderChar;if(e.indexOf(t)!==-1)throw new Error("Placeholder character must not be used as part of the mask. Please specify a character that is not present in your mask as your placeholder character.\n\n"+("The placeholder character that was received is: "+JSON.stringify(t)+"\n\n")+("The mask that was received is: "+JSON.stringify(e)));return e.map(function(e){return e instanceof RegExp?t:e}).join("")}function o(e){return"string"==typeof e||e instanceof String}function i(e){return"number"==typeof e&&void 0===e.length&&!isNaN(e)}function a(e){for(var t=[],r=void 0;r=e.indexOf(s),r!==-1;)t.push(r),e.splice(r,1);return{maskWithoutCaretTraps:e,indexes:t}}Object.defineProperty(t,"__esModule",{value:!0}),t.convertMaskToPlaceholder=n,t.isString=o,t.isNumber=i,t.processCaretTraps=a;var u=r(1),l=[],s="[]"},function(e,t){"use strict";function r(e){var t=e.previousConformedValue,r=void 0===t?o:t,i=e.previousPlaceholder,a=void 0===i?o:i,u=e.currentCaretPosition,l=void 0===u?0:u,s=e.conformedValue,f=e.rawValue,c=e.placeholderChar,d=e.placeholder,p=e.indexesOfPipedChars,h=void 0===p?n:p,v=e.caretTrapIndexes,y=void 0===v?n:v;if(0===l)return 0;var m=f.length,g=r.length,b=d.length,C=s.length,k=m-g,O=k>0,P=0===g,x=k>1&&!O&&!P;if(x)return l;var T=O&&(r===s||s===d),_=0,w=void 0,M=void 0;if(T)_=l-k;else{var j=s.toLowerCase(),S=f.toLowerCase(),E=S.substr(0,l).split(o),R=E.filter(function(e){return j.indexOf(e)!==-1});M=R[R.length-1];var V=a.substr(0,R.length).split(o).filter(function(e){return e!==c}).length,N=d.substr(0,R.length).split(o).filter(function(e){return e!==c}).length,I=N!==V,A=void 0!==a[R.length-1]&&void 0!==d[R.length-2]&&a[R.length-1]!==c&&a[R.length-1]!==d[R.length-1]&&a[R.length-1]===d[R.length-2];!O&&(I||A)&&V>0&&d.indexOf(M)>-1&&void 0!==f[l]&&(w=!0,M=f[l]);for(var q=h.map(function(e){return j[e]}),D=q.filter(function(e){return e===M}).length,F=R.filter(function(e){return e===M}).length,L=d.substr(0,d.indexOf(c)).split(o).filter(function(e,t){return e===M&&f[t]!==e}).length,J=L+F+D+(w?1:0),U=0,W=0;W<C;W++){var B=j[W];if(_=W+1,B===M&&U++,U>=J)break}}if(O){for(var H=_,Y=_;Y<=b;Y++)if(d[Y]===c&&(H=Y),d[Y]===c||y.indexOf(Y)!==-1||Y===b)return H}else if(w){for(var z=_-1;z>=0;z--)if(s[z]===M||y.indexOf(z)!==-1||0===z)return z}else for(var G=_;G>=0;G--)if(d[G-1]===c||y.indexOf(G)!==-1||0===G)return G}Object.defineProperty(t,"__esModule",{value:!0}),t.default=r;var n=[],o=""},function(e,t,r){"use strict";function n(e){return e&&e.__esModule?e:{default:e}}function o(e){var t={previousConformedValue:void 0,previousPlaceholder:void 0};return{state:t,update:function(r){var n=arguments.length>1&&void 0!==arguments[1]?arguments[1]:e,o=n.inputElement,s=n.mask,c=n.guide,m=n.pipe,b=n.placeholderChar,C=void 0===b?h.placeholderChar:b,k=n.keepCharPositions,O=void 0!==k&&k,P=n.showMask,x=void 0!==P&&P;if("undefined"==typeof r&&(r=o.value),r!==t.previousConformedValue){("undefined"==typeof s?"undefined":l(s))===g&&void 0!==s.pipe&&void 0!==s.mask&&(m=s.pipe,s=s.mask);var T=void 0,_=void 0;if(s instanceof Array&&(T=(0,p.convertMaskToPlaceholder)(s,C)),s!==!1){var w=a(r),M=o.selectionEnd,j=t.previousConformedValue,S=t.previousPlaceholder,E=void 0;if(("undefined"==typeof s?"undefined":l(s))===v){if(_=s(w,{currentCaretPosition:M,previousConformedValue:j,placeholderChar:C}),_===!1)return;var R=(0,p.processCaretTraps)(_),V=R.maskWithoutCaretTraps,N=R.indexes;_=V,E=N,T=(0,p.convertMaskToPlaceholder)(_,C)}else _=s;var I={previousConformedValue:j,guide:c,placeholderChar:C,pipe:m,placeholder:T,currentCaretPosition:M,keepCharPositions:O},A=(0,d.default)(w,_,I),q=A.conformedValue,D=("undefined"==typeof m?"undefined":l(m))===v,F={};D&&(F=m(q,u({rawValue:w},I)),F===!1?F={value:j,rejected:!0}:(0,p.isString)(F)&&(F={value:F}));var L=D?F.value:q,J=(0,f.default)({previousConformedValue:j,previousPlaceholder:S,conformedValue:L,placeholder:T,rawValue:w,currentCaretPosition:M,placeholderChar:C,indexesOfPipedChars:F.indexesOfPipedChars,caretTrapIndexes:E}),U=L===T&&0===J,W=x?T:y,B=U?W:L;t.previousConformedValue=B,t.previousPlaceholder=T,o.value!==B&&(o.value=B,i(o,J))}}}}}function i(e,t){document.activeElement===e&&(b?C(function(){return e.setSelectionRange(t,t,m)},0):e.setSelectionRange(t,t,m))}function a(e){if((0,p.isString)(e))return e;if((0,p.isNumber)(e))return String(e);if(void 0===e||null===e)return y;throw new Error("The 'value' provided to Text Mask needs to be a string or a number. The value received was:\n\n "+JSON.stringify(e))}Object.defineProperty(t,"__esModule",{value:!0});var u=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var r=arguments[t];for(var n in r)Object.prototype.hasOwnProperty.call(r,n)&&(e[n]=r[n])}return e},l="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e};t.default=o;var s=r(4),f=n(s),c=r(2),d=n(c),p=r(3),h=r(1),v="function",y="",m="none",g="object",b="undefined"!=typeof navigator&&/Android/i.test(navigator.userAgent),C="undefined"!=typeof requestAnimationFrame?requestAnimationFrame:setTimeout},function(e,t){"use strict";function r(e){return function(){return e}}var n=function(){};n.thatReturns=r,n.thatReturnsFalse=r(!1),n.thatReturnsTrue=r(!0),n.thatReturnsNull=r(null),n.thatReturnsThis=function(){return this},n.thatReturnsArgument=function(e){return e},e.exports=n},function(e,t,r){"use strict";function n(e,t,r,n,i,a,u,l){if(o(t),!e){var s;if(void 0===t)s=new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");else{var f=[r,n,i,a,u,l],c=0;s=new Error(t.replace(/%s/g,function(){return f[c++]})),s.name="Invariant Violation"}throw s.framesToPop=1,s}}var o=function(e){};e.exports=n},function(e,t,r){"use strict";var n=r(6),o=r(7),i=r(10);e.exports=function(){function e(e,t,r,n,a,u){u!==i&&o(!1,"Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types")}function t(){return e}e.isRequired=e;var r={array:e,bool:e,func:e,number:e,object:e,string:e,symbol:e,any:e,arrayOf:t,element:e,instanceOf:t,node:e,objectOf:t,oneOf:t,oneOfType:t,shape:t};return r.checkPropTypes=n,r.PropTypes=r,r}},function(e,t,r){"use strict";"function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e},e.exports=r(8)()},function(e,t){"use strict";var r="SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";e.exports=r},function(t,r){t.exports=e}])});

/***/ }),

/***/ 747:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(748);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(699)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--5-2!../../../../node_modules/sass-loader/lib/loader.js!../../../../node_modules/postcss-loader/lib/index.js??postcss!./InputText.scss", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js??ref--5-2!../../../../node_modules/sass-loader/lib/loader.js!../../../../node_modules/postcss-loader/lib/index.js??postcss!./InputText.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 748:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(698)(false);
// imports


// module
exports.push([module.i, ".input-text__container{display:block;position:relative;padding-top:16px}.input-text__element{-webkit-box-sizing:border-box;box-sizing:border-box;display:block;border:none;outline:none;-webkit-box-shadow:none;box-shadow:none;border-radius:0;border-bottom:1px solid #bdbdbd;width:100%;height:40px;margin:0;padding:0;background-image:none;background-color:transparent;color:#292929}.input-text__element:focus{border-color:#008ddf;border-width:2px;height:41px;margin-bottom:-1px}.input-text__element:focus~.input-text__label{color:#008ddf}.input-text__element.input-text__element--is-filled~.input-text__label,.input-text__element:focus~.input-text__label{font-weight:400;font-size:13px;line-height:1.4;letter-spacing:-.6px;-webkit-transform:translate(0);-ms-transform:translate(0);transform:translate(0)}.input-text__element:-moz-read-only,.input-text__element:disabled{background-color:transparent;cursor:not-allowed;opacity:1}.input-text__element:disabled,.input-text__element:read-only{background-color:transparent;cursor:not-allowed;opacity:1}.input-text__label{color:#bdbdbd;cursor:text;pointer-events:none;position:absolute;-o-text-overflow:clip;text-overflow:clip;top:0;-webkit-transform:translateY(25px);-ms-transform:translateY(25px);transform:translateY(25px);-webkit-transition:all .15s ease-out;-o-transition:all .15s ease-out;transition:all .15s ease-out}.input-text__footnote{font-weight:400;font-size:13px;line-height:1.4;letter-spacing:-.6px;margin-top:4px;margin-bottom:0;min-height:20px;line-height:20px;color:#adadad}.input-text__footnote--is-error{color:#ff2e1e}.input-text__container--hidden{display:none}.input-text__action{cursor:pointer;display:none;position:absolute;top:20px;right:0;color:#bdbdbd}.input-text__action:hover,.input-text__visibility--is-active{color:#292929}.input-text__container .input-text__visibility,.input-text__element:focus~.input-text__cancel{display:inline-block}.input-text__element--is-error,.input-text__element--is-error:focus{border-bottom-color:#ff2e1e}.input-text__element--is-error~.input-text__label{color:rgba(255,46,30,.26)}.input-text__element--is-error.input-text__element--is-filled~.input-text__label,.input-text__element--is-error:focus~.input-text__label{color:#ff2e1e}", ""]);

// exports


/***/ }),

/***/ 749:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export InputTextarea */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_intl__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux_form__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__InputTextarea_scss__ = __webpack_require__(750);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__InputTextarea_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__InputTextarea_scss__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};





var InputTextarea = /** @class */ (function (_super) {
    __extends(InputTextarea, _super);
    function InputTextarea(props) {
        var _this = _super.call(this, props) || this;
        _this.resetInputValue = _this.resetInputValue.bind(_this);
        _this.setReference = _this.setReference.bind(_this);
        return _this;
    }
    InputTextarea.prototype.focus = function () {
        return this.input.focus();
    };
    InputTextarea.prototype.render = function () {
        var _a = this.props, className = _a.className, disabled = _a.disabled, input = _a.input, label = _a.label, meta = _a.meta, rows = _a.rows;
        var classNameElementError = meta.touched && meta.error && 'input-textarea__element--is-error';
        var classNameFootnoteError = meta.touched && meta.error && 'input-textarea__footnote--is-error';
        var classNameStatus = input.value && 'input-textarea__element--is-filled';
        var defaultRows = 5;
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: __WEBPACK_IMPORTED_MODULE_0_classnames__('input-textarea__container', className) },
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("textarea", __assign({ autoComplete: "off", className: __WEBPACK_IMPORTED_MODULE_0_classnames__('input-textarea__element', classNameElementError, classNameStatus), disabled: disabled, id: this.inputId, ref: this.setReference, rows: rows || defaultRows, spellCheck: false }, input)),
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("label", { className: "input-textarea__label", htmlFor: this.inputId }, label),
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("p", { className: __WEBPACK_IMPORTED_MODULE_0_classnames__('input-textarea__footnote', classNameFootnoteError) }, meta.touched && meta.error && __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("span", null,
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_intl__["c" /* FormattedMessage */], { id: meta.error })))));
    };
    Object.defineProperty(InputTextarea.prototype, "inputId", {
        get: function () {
            return 'input-textarea__id-' + this.props.input.name;
        },
        enumerable: true,
        configurable: true
    });
    InputTextarea.prototype.resetInputValue = function () {
        var _a = this.props, input = _a.input, meta = _a.meta;
        meta.dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_redux_form__["b" /* change */])(meta.form, input.name, ''));
    };
    InputTextarea.prototype.setReference = function (htmlTextAreaElement) {
        this.input = htmlTextAreaElement;
    };
    return InputTextarea;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));



/***/ }),

/***/ 750:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(751);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(699)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--5-2!../../../../node_modules/sass-loader/lib/loader.js!../../../../node_modules/postcss-loader/lib/index.js??postcss!./InputTextarea.scss", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js??ref--5-2!../../../../node_modules/sass-loader/lib/loader.js!../../../../node_modules/postcss-loader/lib/index.js??postcss!./InputTextarea.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 751:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(698)(false);
// imports


// module
exports.push([module.i, ".input-textarea__container{display:block;position:relative;padding-top:24px}.input-textarea__label{color:#bdbdbd;cursor:text;pointer-events:none;position:absolute;-o-text-overflow:clip;text-overflow:clip;top:0;-webkit-transform:translateY(25px);-ms-transform:translateY(25px);transform:translateY(25px);-webkit-transition:all .15s ease-out;-o-transition:all .15s ease-out;transition:all .15s ease-out}.input-textarea__footnote{font-weight:400;font-size:13px;line-height:1.4;letter-spacing:-.6px;margin-top:4px;margin-bottom:0;min-height:20px;line-height:20px;color:#adadad}.input-textarea__footnote--is-error{color:#ff2e1e}.input-textarea__element{-webkit-box-shadow:none;box-shadow:none;-webkit-box-sizing:border-box;box-sizing:border-box;border:none;display:block;outline:none;border-bottom:1px solid #bdbdbd;border-radius:0;height:auto;width:100%;margin:0;padding:0;background-image:none;color:#292929;background-color:transparent}.input-textarea__element:focus{height:auto;border-color:#008ddf;border-width:2px;margin-bottom:-1px}.input-textarea__element:focus~.input-textarea__label{color:#008ddf}.input-textarea__element.input-textarea__element--is-filled~.input-textarea__label,.input-textarea__element:focus~.input-textarea__label{font-weight:400;font-size:13px;line-height:1.4;letter-spacing:-.6px;-webkit-transform:translate(0);-ms-transform:translate(0);transform:translate(0)}.input-textarea__element:-moz-read-only,.input-textarea__element:disabled{cursor:not-allowed;background-color:transparent;opacity:1}.input-textarea__element:disabled,.input-textarea__element:read-only{cursor:not-allowed;background-color:transparent;opacity:1}.input-textarea__element--is-error,.input-textarea__element--is-error:focus{border-bottom-color:#ff2e1e}.input-textarea__element--is-error~.input-textarea__label{color:rgba(255,46,30,.26)}.input-textarea__element--is-error.input-textarea__element--is-filled~.input-textarea__label,.input-textarea__element--is-error:focus~.input-textarea__label{color:#ff2e1e}", ""]);

// exports


/***/ }),

/***/ 752:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Footer__ = __webpack_require__(763);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Footer__["a"]; });



/***/ }),

/***/ 756:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__OtpPage__ = __webpack_require__(783);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__OtpPage__["a"]; });



/***/ }),

/***/ 763:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Footer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_intl__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_constants_app__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Footer_scss__ = __webpack_require__(764);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Footer_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__Footer_scss__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();





var Footer = /** @class */ (function (_super) {
    __extends(Footer, _super);
    function Footer() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Footer.prototype.render = function () {
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("footer", { className: "footer o-container" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "footer__copyright" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_intl__["b" /* FormattedHTMLMessage */], { id: "footer.copyright" })),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("ul", { className: "footer__navigation-ul" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", { className: "footer__navigation-li" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["a" /* Link */], { to: __WEBPACK_IMPORTED_MODULE_3_constants_app__["I" /* ROUTE_STATIC_FAQ */] },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_intl__["c" /* FormattedMessage */], { id: "footer.faq" }))),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", { className: "footer__navigation-li" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["a" /* Link */], { to: __WEBPACK_IMPORTED_MODULE_3_constants_app__["J" /* ROUTE_STATIC_TERM */] },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_intl__["c" /* FormattedMessage */], { id: "footer.term" }))))));
    };
    return Footer;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));



/***/ }),

/***/ 764:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(765);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(699)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--5-2!../../../node_modules/sass-loader/lib/loader.js!../../../node_modules/postcss-loader/lib/index.js??postcss!./Footer.scss", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js??ref--5-2!../../../node_modules/sass-loader/lib/loader.js!../../../node_modules/postcss-loader/lib/index.js??postcss!./Footer.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 765:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(698)(false);
// imports


// module
exports.push([module.i, ".footer{-ms-flex-align:center;align-items:center;-webkit-box-sizing:border-box;box-sizing:border-box;display:-ms-flexbox;display:flex;-ms-flex-pack:justify;justify-content:space-between;height:64px}.footer__navigation-ul{list-style-type:none;margin:0;padding:0}.footer__navigation-li{display:inline;margin-left:12px;margin-right:12px}@media (max-width:767px){.footer{-ms-flex-direction:column;flex-direction:column;-ms-flex-pack:center;justify-content:center;text-align:center;height:128px;padding-left:12px;padding-right:12px}.footer__copyright{margin-bottom:12px}}", ""]);

// exports


/***/ }),

/***/ 766:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = validate;
function validate(formValue) {
    var errors = {};
    if (!formValue.otp) {
        errors.otp = 'form.error.required';
    }
    return errors;
}


/***/ }),

/***/ 767:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Initial__ = __webpack_require__(768);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Initial__["a"]; });



/***/ }),

/***/ 768:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Initial; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Initial_scss__ = __webpack_require__(769);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Initial_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Initial_scss__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};



var Initial = /** @class */ (function (_super) {
    __extends(Initial, _super);
    function Initial() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.defaultName = '-';
        return _this;
    }
    Initial.prototype.shouldComponentUpdate = function (props) {
        if (this.props.name !== props.name)
            return true;
        return false;
    };
    Initial.prototype.render = function () {
        var _a = this.props, className = _a.className, maxLetter = _a.maxLetter, name = _a.name, rest = __rest(_a, ["className", "maxLetter", "name"]);
        var backgroundColor = this.intToRGB(this.hashCode(name));
        var computedStyle = {
            backgroundColor: '#' + backgroundColor,
            color: '#' + this.luminate(backgroundColor)
        };
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", __assign({ className: __WEBPACK_IMPORTED_MODULE_0_classnames__('initial', className), style: computedStyle }, rest), this.getInitial(name, maxLetter)));
    };
    Initial.prototype.getInitial = function (name, maxLetter) {
        if (maxLetter === void 0) { maxLetter = 2; }
        return this.split(name).substring(0, maxLetter);
    };
    Initial.prototype.split = function (name) {
        var initials = name.match(/\b\w/g) || [this.defaultName];
        return ((initials.shift() || '') + (initials.pop() || '')).toUpperCase();
    };
    Initial.prototype.hashCode = function (name) {
        var hash = 0;
        for (var i = 0; i < name.length; i++) {
            hash = name.charCodeAt(i) + ((hash << 5) - hash);
        }
        return hash;
    };
    Initial.prototype.intToRGB = function (numeric) {
        var c = (numeric & 0x00FFFFFF)
            .toString(16)
            .toUpperCase();
        return '00000'.substring(0, 6 - c.length) + c;
    };
    Initial.prototype.luminate = function (color) {
        var rgb = parseInt(color, 16);
        var r = (rgb >> 16) & 0xff;
        var g = (rgb >> 8) & 0xff;
        var b = (rgb >> 0) & 0xff;
        var luma = 0.2126 * r + 0.7152 * g + 0.0722 * b;
        if (luma < 200) {
            return 'ffffff';
        }
        return undefined;
    };
    return Initial;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));



/***/ }),

/***/ 769:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(770);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(699)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--5-2!../../../node_modules/sass-loader/lib/loader.js!../../../node_modules/postcss-loader/lib/index.js??postcss!./Initial.scss", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js??ref--5-2!../../../node_modules/sass-loader/lib/loader.js!../../../node_modules/postcss-loader/lib/index.js??postcss!./Initial.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 770:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(698)(false);
// imports


// module
exports.push([module.i, ".initial{display:inline-block;border-radius:50%;line-height:52px;height:52px;width:52px;text-align:center}", ""]);

// exports


/***/ }),

/***/ 783:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return OtpPage; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_intl__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_form__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_Button__ = __webpack_require__(230);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_Confirmation__ = __webpack_require__(784);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_Form__ = __webpack_require__(709);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_Input__ = __webpack_require__(708);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_Layout__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_helper_form__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__OtpPage_scss__ = __webpack_require__(792);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__OtpPage_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__OtpPage_scss__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();










var OtpPage = /** @class */ (function (_super) {
    __extends(OtpPage, _super);
    function OtpPage(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            isConfirmationOpen: false
        };
        _this.closeConfirmation = _this.closeConfirmation.bind(_this);
        _this.handleResendOtp = _this.handleResendOtp.bind(_this);
        _this.showConfirmation = _this.showConfirmation.bind(_this);
        _this.setFieldOtpReference = _this.setFieldOtpReference.bind(_this);
        return _this;
    }
    OtpPage.prototype.componentDidMount = function () {
        this.fieldOtp.getRenderedComponent().focus();
    };
    OtpPage.prototype.componentWillUnmount = function () {
        var _a = this.props, history = _a.history, location = _a.location;
        var isConfirmationOpen = this.state.isConfirmationOpen;
        if (history.action === 'POP' && !isConfirmationOpen) {
            history.push(location.pathname);
        }
    };
    OtpPage.prototype.render = function () {
        var _a = this.props, children = _a.children, form = _a.form, onClose = _a.onClose, onSubmit = _a.onSubmit, phone = _a.phone, validate = _a.validate;
        var isConfirmationOpen = this.state.isConfirmationOpen;
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5_components_Form__["a" /* Form */], { className: "o-container o-container--fluid", form: form, onSubmit: onSubmit, validate: validate },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7_components_Layout__["b" /* LayoutHeader */], { actionIcon: "ic-close", actionHandler: this.showConfirmation, modifier: "without-border" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h1", { className: "o-layout-header-title" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_intl__["c" /* FormattedMessage */], { id: "otp.page.title" }))),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_components_Confirmation__["a" /* Confirmation */], { actionNoHandler: this.closeConfirmation, actionNoText: __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_intl__["c" /* FormattedMessage */], { id: "otp.page.confirmation.no" }), actionYesHandler: onClose, actionYesText: __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_intl__["c" /* FormattedMessage */], { id: "otp.page.confirmation.yes" }), onOverlayClick: this.closeConfirmation, title: __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_intl__["c" /* FormattedMessage */], { id: "otp.page.confirmation.title" }), isOpen: isConfirmationOpen },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_intl__["c" /* FormattedMessage */], { id: "otp.page.confirmation.info" })),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { className: "otp-page__info" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_intl__["c" /* FormattedMessage */], { id: "otp.page.info" })),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { className: "otp-page__phone-text" }, Object(__WEBPACK_IMPORTED_MODULE_8_helper_form__["e" /* formatInternationalPhone */])(phone)),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_redux_form__["a" /* Field */], { name: "otp", className: "o-form-field", ref: this.setFieldOtpReference, withRef: true, component: __WEBPACK_IMPORTED_MODULE_6_components_Input__["g" /* InputOtp */] }),
            children,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_components_Button__["a" /* Button */], { type: "submit", className: "o-form-button button--full button--primary" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_intl__["c" /* FormattedMessage */], { id: "otp.page.continue" })),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_components_Button__["a" /* Button */], { type: "button", onClick: this.handleResendOtp(phone), className: "o-form-button button--full button--white" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_intl__["c" /* FormattedMessage */], { id: "otp.page.resend" }))));
    };
    OtpPage.prototype.handleResendOtp = function (phone) {
        var onResendOtp = this.props.onResendOtp;
        return function () { return onResendOtp(phone); };
    };
    OtpPage.prototype.setFieldOtpReference = function (field) {
        this.fieldOtp = field;
    };
    OtpPage.prototype.closeConfirmation = function () {
        this.setState({
            isConfirmationOpen: false
        });
    };
    OtpPage.prototype.showConfirmation = function () {
        this.setState({
            isConfirmationOpen: true
        });
    };
    return OtpPage;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));



/***/ }),

/***/ 784:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Confirmation__ = __webpack_require__(785);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Confirmation__["a"]; });



/***/ }),

/***/ 785:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Confirmation; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_Button__ = __webpack_require__(230);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_Dialog__ = __webpack_require__(786);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Confirmation_scss__ = __webpack_require__(790);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Confirmation_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Confirmation_scss__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();




var Confirmation = /** @class */ (function (_super) {
    __extends(Confirmation, _super);
    function Confirmation() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Confirmation.prototype.render = function () {
        var _a = this.props, actionNoHandler = _a.actionNoHandler, actionNoText = _a.actionNoText, actionYesHandler = _a.actionYesHandler, actionYesText = _a.actionYesText, children = _a.children, isOpen = _a.isOpen, onOverlayClick = _a.onOverlayClick, title = _a.title;
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_components_Dialog__["a" /* Dialog */], { className: "confirmation__dialog", onOverlayClick: onOverlayClick, isOpen: isOpen },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h3", { className: "confirmation__title u-heavy" }, title),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "o-footnote-1" }, children),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "confirmation__action" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_components_Button__["a" /* Button */], { type: "button", className: "button--white confirmation__action-button--yes", onClick: actionYesHandler }, actionYesText),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_components_Button__["a" /* Button */], { type: "button", className: "button--white confirmation__action-button--no", onClick: actionNoHandler }, actionNoText))));
    };
    return Confirmation;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));



/***/ }),

/***/ 786:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Dialog__ = __webpack_require__(787);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Dialog__["a"]; });



/***/ }),

/***/ 787:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Dialog; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_Overlay__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Dialog_scss__ = __webpack_require__(788);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Dialog_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Dialog_scss__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();




var Dialog = /** @class */ (function (_super) {
    __extends(Dialog, _super);
    function Dialog() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Dialog.prototype.render = function () {
        var _a = this.props, children = _a.children, className = _a.className, isOpen = _a.isOpen, onOverlayClick = _a.onOverlayClick;
        var classNameOpen = isOpen ? 'dialog--is-open' : 'dialog--is-close';
        var classNameClickable = onOverlayClick && 'clickable';
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: __WEBPACK_IMPORTED_MODULE_0_classnames__('dialog', classNameOpen) },
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_components_Overlay__["a" /* Overlay */], { className: "dialog__overlay", modifier: classNameClickable, onClick: onOverlayClick }),
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: __WEBPACK_IMPORTED_MODULE_0_classnames__('dialog__container', className) }, children)));
    };
    return Dialog;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));



/***/ }),

/***/ 788:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(789);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(699)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--5-2!../../../node_modules/sass-loader/lib/loader.js!../../../node_modules/postcss-loader/lib/index.js??postcss!./Dialog.scss", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js??ref--5-2!../../../node_modules/sass-loader/lib/loader.js!../../../node_modules/postcss-loader/lib/index.js??postcss!./Dialog.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 789:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(698)(false);
// imports


// module
exports.push([module.i, ".dialog{-webkit-box-sizing:border-box;box-sizing:border-box;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;position:fixed;z-index:4;bottom:0;left:0;right:0;top:0}.dialog--is-open{-ms-flex-align:center;align-items:center;-ms-flex-line-pack:center;align-content:center;display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center}.dialog--is-close{display:none}.dialog__container{box-shadow:0 24px 26px 0 rgba(64,64,65,.5);max-width:80%;background-color:#fff;border-radius:4px;z-index:1}", ""]);

// exports


/***/ }),

/***/ 790:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(791);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(699)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--5-2!../../../node_modules/sass-loader/lib/loader.js!../../../node_modules/postcss-loader/lib/index.js??postcss!./Confirmation.scss", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js??ref--5-2!../../../node_modules/sass-loader/lib/loader.js!../../../node_modules/postcss-loader/lib/index.js??postcss!./Confirmation.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 791:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(698)(false);
// imports


// module
exports.push([module.i, ".confirmation__dialog{padding:24px}.confirmation__action{margin-top:16px;text-align:right}.confirmation__title{margin-bottom:16px;margin-top:0}.confirmation__action-button--yes,.confirmation__action-button--yes:hover{color:#ff2e1e}.confirmation__action-button--no{margin-left:12px}.confirmation__action-button--no,.confirmation__action-button--no:hover{color:#000}", ""]);

// exports


/***/ }),

/***/ 792:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(793);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(699)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--5-2!../../../node_modules/sass-loader/lib/loader.js!../../../node_modules/postcss-loader/lib/index.js??postcss!./OtpPage.scss", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js??ref--5-2!../../../node_modules/sass-loader/lib/loader.js!../../../node_modules/postcss-loader/lib/index.js??postcss!./OtpPage.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 793:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(698)(false);
// imports


// module
exports.push([module.i, ".otp-page__info{text-align:center;color:#adadad;margin-top:28px}.otp-page__phone-text{margin-top:36px;text-align:center}", ""]);

// exports


/***/ }),

/***/ 821:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AccountStoreForm__ = __webpack_require__(894);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__AccountStoreForm__["a"]; });



/***/ }),

/***/ 839:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AccountEmailUpdate; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_intl__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_actions_account__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_Button__ = __webpack_require__(230);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_Form__ = __webpack_require__(709);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_Input__ = __webpack_require__(708);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_Layout__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_constants_analytics__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_constants_app__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_helper_analytics__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_helper_redux__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_helper_validation_account_accountEmailUpdateForm__ = __webpack_require__(840);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__AccountEmailUpdate_scss__ = __webpack_require__(841);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__AccountEmailUpdate_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__AccountEmailUpdate_scss__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};














var AccountEmailUpdateContainer = /** @class */ (function (_super) {
    __extends(AccountEmailUpdateContainer, _super);
    function AccountEmailUpdateContainer(props) {
        var _this = _super.call(this, props) || this;
        _this.onSubmit = _this.onSubmit.bind(_this);
        return _this;
    }
    AccountEmailUpdateContainer.prototype.render = function () {
        var _a = this.props, history = _a.history, initialValues = _a.initialValues, intl = _a.intl;
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5_components_Form__["a" /* Form */], { className: "o-container o-container--fluid o-container--fluid-vertical", form: __WEBPACK_IMPORTED_MODULE_9_constants_app__["b" /* APPLICATION_FORM_NAME */], initialValues: initialValues, onSubmit: this.onSubmit, validate: __WEBPACK_IMPORTED_MODULE_12_helper_validation_account_accountEmailUpdateForm__["a" /* validate */] },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7_components_Layout__["b" /* LayoutHeader */], { actionIcon: "ic-arrow-left", actionHandler: history.goBack },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h1", { className: "o-layout-header-title" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_intl__["c" /* FormattedMessage */], { id: "account.email.update.title" }))),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_components_Input__["d" /* FieldText */], { className: "o-form-field", component: __WEBPACK_IMPORTED_MODULE_6_components_Input__["i" /* InputText */], label: intl.formatMessage({ id: 'account.email.update.email' }), modifier: "cancel", name: "email", type: "text" }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_components_Button__["a" /* Button */], { type: "submit", className: "o-form-button button--full button--primary" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_intl__["c" /* FormattedMessage */], { id: "account.email.update.continue" }))));
    };
    AccountEmailUpdateContainer.prototype.onSubmit = function (formValue) {
        Object(__WEBPACK_IMPORTED_MODULE_10_helper_analytics__["b" /* sendEvent */])({
            action: __WEBPACK_IMPORTED_MODULE_8_constants_analytics__["a" /* AnalyticsEventAction */].ACCOUNT_CHANGE_EMAIL,
            category: __WEBPACK_IMPORTED_MODULE_8_constants_analytics__["b" /* AnalyticsEventCategory */].ACCOUNT_CHANGE_EMAIL
        });
        this.props.updateEmail(formValue);
    };
    AccountEmailUpdateContainer = __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_11_helper_redux__["b" /* injectIntl */])()
    ], AccountEmailUpdateContainer);
    return AccountEmailUpdateContainer;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
var AccountEmailUpdate = Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(function (state) { return ({
    initialValues: {
        email: state.accountState.account.email || ''
    }
}); }, { updateEmail: __WEBPACK_IMPORTED_MODULE_3_actions_account__["o" /* updateEmail */] })(AccountEmailUpdateContainer);


/***/ }),

/***/ 840:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = validate;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_helper_form__ = __webpack_require__(19);

function validate(formValue) {
    var errors = {};
    if (!formValue.email) {
        errors.email = 'form.error.required';
    }
    else if (!Object(__WEBPACK_IMPORTED_MODULE_0_helper_form__["g" /* isValidEmail */])(formValue.email)) {
        errors.email = 'form.error.invalid.email.format';
    }
    return errors;
}


/***/ }),

/***/ 841:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(842);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(699)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--5-2!../../../../../node_modules/sass-loader/lib/loader.js!../../../../../node_modules/postcss-loader/lib/index.js??postcss!./AccountEmailUpdate.scss", function() {
			var newContent = require("!!../../../../../node_modules/css-loader/index.js??ref--5-2!../../../../../node_modules/sass-loader/lib/loader.js!../../../../../node_modules/postcss-loader/lib/index.js??postcss!./AccountEmailUpdate.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 842:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(698)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),

/***/ 843:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AccountEmailUnverified; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_intl__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_actions_account__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_Button__ = __webpack_require__(230);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_Layout__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_constants_app__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__AccountEmailUnverified_scss__ = __webpack_require__(844);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__AccountEmailUnverified_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__AccountEmailUnverified_scss__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();









var AccountEmailUnverifiedContainer = /** @class */ (function (_super) {
    __extends(AccountEmailUnverifiedContainer, _super);
    function AccountEmailUnverifiedContainer(props) {
        var _this = _super.call(this, props) || this;
        _this.redirectTo = _this.redirectTo.bind(_this);
        _this.resendVerificationEmail = _this.resendVerificationEmail.bind(_this);
        return _this;
    }
    AccountEmailUnverifiedContainer.prototype.componentWillMount = function () {
        this.props.getUnverifiedEmail();
    };
    AccountEmailUnverifiedContainer.prototype.render = function () {
        var _a = this.props, account = _a.account, history = _a.history, isRenderValid = _a.isRenderValid;
        if (!isRenderValid) {
            return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_react_router__["a" /* Redirect */], { to: "/" });
        }
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "account-email-unverified__container o-container o-container--fluid o-container--fluid-vertical" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_components_Layout__["b" /* LayoutHeader */], { actionIcon: "ic-close", actionHandler: history.goBack },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h1", { className: "o-layout-header-title" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_intl__["c" /* FormattedMessage */], { id: "account.email.unverified.title" }))),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "account-email-unverified__message" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_intl__["c" /* FormattedMessage */], { id: "account.email.unverified.message" })),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "account-email-unverified__email" }, account.unverifiedEmail),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5_components_Button__["a" /* Button */], { type: "button", className: "button--outline-blue button--full", onClick: this.redirectTo(__WEBPACK_IMPORTED_MODULE_7_constants_app__["d" /* ROUTE_ACCOUNT_EMAIL_UPDATE */]) },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_intl__["c" /* FormattedMessage */], { id: "account.email.unverified.update.email.button" })),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5_components_Button__["a" /* Button */], { type: "button", className: "account-email-unverified__resend-verification-button button--primary button--full", onClick: this.resendVerificationEmail() },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_intl__["c" /* FormattedMessage */], { id: "account.email.unverified.resend.verification.button" }))));
    };
    AccountEmailUnverifiedContainer.prototype.redirectTo = function (redirectPath) {
        var _this = this;
        return function () {
            var history = _this.props.history;
            history.push(redirectPath);
        };
    };
    AccountEmailUnverifiedContainer.prototype.resendVerificationEmail = function () {
        var _this = this;
        return function () {
            var unverifiedEmail = _this.props.account.unverifiedEmail;
            if (unverifiedEmail) {
                var form = {
                    email: unverifiedEmail
                };
                _this.props.updateEmail(form);
            }
        };
    };
    return AccountEmailUnverifiedContainer;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
var AccountEmailUnverified = Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(function (state) { return ({
    account: state.accountState.account,
    isRenderValid: !!state.accountState.account.unverifiedEmail && !state.accountState.account.email
}); }, { getUnverifiedEmail: __WEBPACK_IMPORTED_MODULE_4_actions_account__["g" /* getUnverifiedEmail */], updateEmail: __WEBPACK_IMPORTED_MODULE_4_actions_account__["o" /* updateEmail */] })(AccountEmailUnverifiedContainer);


/***/ }),

/***/ 844:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(845);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(699)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--5-2!../../../../../node_modules/sass-loader/lib/loader.js!../../../../../node_modules/postcss-loader/lib/index.js??postcss!./AccountEmailUnverified.scss", function() {
			var newContent = require("!!../../../../../node_modules/css-loader/index.js??ref--5-2!../../../../../node_modules/sass-loader/lib/loader.js!../../../../../node_modules/postcss-loader/lib/index.js??postcss!./AccountEmailUnverified.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 845:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(698)(false);
// imports


// module
exports.push([module.i, ".account-email-unverified__container{text-align:center}.account-email-unverified__message{color:#adadad}.account-email-unverified__email{margin:20px 0}.account-email-unverified__resend-verification-button{margin-top:12px}", ""]);

// exports


/***/ }),

/***/ 846:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AccountForgotPassword; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_intl__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_actions_account__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_Button__ = __webpack_require__(230);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_Footer__ = __webpack_require__(752);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_Form__ = __webpack_require__(709);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_Input__ = __webpack_require__(708);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_Layout__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_LinkWithAnalytics__ = __webpack_require__(232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_constants_analytics__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_constants_app__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_helper_analytics__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_helper_redux__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_helper_validation_account_accountForgotPasswordForm__ = __webpack_require__(847);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__AccountForgotPassword_scss__ = __webpack_require__(848);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__AccountForgotPassword_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__AccountForgotPassword_scss__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
















var AccountForgotPasswordContainer = /** @class */ (function (_super) {
    __extends(AccountForgotPasswordContainer, _super);
    function AccountForgotPasswordContainer(props) {
        var _this = _super.call(this, props) || this;
        _this.onSubmit = _this.onSubmit.bind(_this);
        _this.setFieldUsernameReference = _this.setFieldUsernameReference.bind(_this);
        return _this;
    }
    AccountForgotPasswordContainer.prototype.componentDidMount = function () {
        this.fieldUsername.getRenderedComponent().focus();
    };
    AccountForgotPasswordContainer.prototype.render = function () {
        var _a = this.props, initialValues = _a.initialValues, intl = _a.intl;
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_components_Form__["a" /* Form */], { className: "o-container o-container--fluid o-container--fluid-vertical", form: __WEBPACK_IMPORTED_MODULE_11_constants_app__["b" /* APPLICATION_FORM_NAME */], initialValues: initialValues, onSubmit: this.onSubmit, validate: __WEBPACK_IMPORTED_MODULE_14_helper_validation_account_accountForgotPasswordForm__["a" /* validate */] },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8_components_Layout__["e" /* LayoutTitle */], { modifier: "with-logo", title: intl.formatMessage({ id: 'account.forgot.password.title' }) }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8_components_Layout__["a" /* LayoutFooter */], null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5_components_Footer__["a" /* Footer */], null)),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7_components_Input__["d" /* FieldText */], { className: "o-form-field", component: __WEBPACK_IMPORTED_MODULE_7_components_Input__["i" /* InputText */], label: intl.formatMessage({ id: 'account.forgot.password.username' }), modifier: "cancel", name: "username", ref: this.setFieldUsernameReference, type: "text", withRef: true }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_components_Button__["a" /* Button */], { type: "submit", className: "o-form-button button--full button--primary" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_intl__["c" /* FormattedMessage */], { id: "account.forgot.password.continue" })),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "account-forgot-password__login" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_intl__["c" /* FormattedMessage */], { id: "account.register.login.pre" }),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9_components_LinkWithAnalytics__["a" /* LinkWithAnalytics */], { className: "account-forgot-password__login-link", to: __WEBPACK_IMPORTED_MODULE_11_constants_app__["E" /* ROUTE_LOGIN */], category: __WEBPACK_IMPORTED_MODULE_10_constants_analytics__["b" /* AnalyticsEventCategory */].ACCOUNT_FORGOT_PASSWORD, action: __WEBPACK_IMPORTED_MODULE_10_constants_analytics__["a" /* AnalyticsEventAction */].OPEN_ACCOUNT_LOG_IN_PAGE },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_intl__["c" /* FormattedMessage */], { id: "account.register.login" })))));
    };
    AccountForgotPasswordContainer.prototype.onSubmit = function (formValue) {
        Object(__WEBPACK_IMPORTED_MODULE_12_helper_analytics__["b" /* sendEvent */])({
            action: __WEBPACK_IMPORTED_MODULE_10_constants_analytics__["a" /* AnalyticsEventAction */].ACCOUNT_FORGOT_PASSWORD,
            category: __WEBPACK_IMPORTED_MODULE_10_constants_analytics__["b" /* AnalyticsEventCategory */].ACCOUNT_FORGOT_PASSWORD
        });
        this.props.forgotPassword(formValue);
    };
    AccountForgotPasswordContainer.prototype.setFieldUsernameReference = function (field) {
        this.fieldUsername = field;
    };
    AccountForgotPasswordContainer = __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_13_helper_redux__["b" /* injectIntl */])()
    ], AccountForgotPasswordContainer);
    return AccountForgotPasswordContainer;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
var AccountForgotPassword = Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(function (state) { return ({
    initialValues: {
        username: state.accountState.tempAccount.email || state.accountState.tempAccount.phone
    }
}); }, { forgotPassword: __WEBPACK_IMPORTED_MODULE_3_actions_account__["f" /* forgotPassword */] })(AccountForgotPasswordContainer);


/***/ }),

/***/ 847:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = validate;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_helper_form__ = __webpack_require__(19);

function validate(formValue) {
    var errors = {};
    if (!formValue.username) {
        errors.username = 'form.error.required';
    }
    else if (!Object(__WEBPACK_IMPORTED_MODULE_0_helper_form__["k" /* isValidUsername */])(formValue.username)) {
        errors.username = 'form.error.invalid.username.format';
    }
    return errors;
}


/***/ }),

/***/ 848:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(849);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(699)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--5-2!../../../../../node_modules/sass-loader/lib/loader.js!../../../../../node_modules/postcss-loader/lib/index.js??postcss!./AccountForgotPassword.scss", function() {
			var newContent = require("!!../../../../../node_modules/css-loader/index.js??ref--5-2!../../../../../node_modules/sass-loader/lib/loader.js!../../../../../node_modules/postcss-loader/lib/index.js??postcss!./AccountForgotPassword.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 849:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(698)(false);
// imports


// module
exports.push([module.i, ".account-forgot-password__login{margin-top:36px;text-align:center}.account-forgot-password__login-link{margin-left:8px}", ""]);

// exports


/***/ }),

/***/ 850:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AccountForgotPasswordOtp; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_actions_account__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_actions_otp__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_Input__ = __webpack_require__(708);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_OtpPage__ = __webpack_require__(756);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_constants_analytics__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_constants_app__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_helper_analytics__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_helper_redux__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_helper_validation_otp_otpForgotPasswordForm__ = __webpack_require__(851);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__AccountForgotPasswordOtp_scss__ = __webpack_require__(852);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__AccountForgotPasswordOtp_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__AccountForgotPasswordOtp_scss__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};













var AccountForgotPasswordOtpContainer = /** @class */ (function (_super) {
    __extends(AccountForgotPasswordOtpContainer, _super);
    function AccountForgotPasswordOtpContainer(props) {
        var _this = _super.call(this, props) || this;
        _this.onSubmit = _this.onSubmit.bind(_this);
        _this.onResendOtp = _this.onResendOtp.bind(_this);
        return _this;
    }
    AccountForgotPasswordOtpContainer.prototype.render = function () {
        var _a = this.props, history = _a.history, intl = _a.intl, location = _a.location, phone = _a.phone;
        if (!phone) {
            return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_router__["a" /* Redirect */], { to: "/" });
        }
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_components_OtpPage__["a" /* OtpPage */], { form: __WEBPACK_IMPORTED_MODULE_8_constants_app__["b" /* APPLICATION_FORM_NAME */], history: history, location: location, onResendOtp: this.onResendOtp, onClose: history.goBack, onSubmit: this.onSubmit, phone: phone, validate: __WEBPACK_IMPORTED_MODULE_11_helper_validation_otp_otpForgotPasswordForm__["a" /* validate */] },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5_components_Input__["d" /* FieldText */], { name: "newPassword", component: __WEBPACK_IMPORTED_MODULE_5_components_Input__["i" /* InputText */], type: "password", label: intl.formatMessage({ id: 'otp.forgot.password.new.password' }), footnote: intl.formatMessage({ id: 'form.footnote.valid.password.format' }), modifier: "visibility", className: "o-form-field" })));
    };
    AccountForgotPasswordOtpContainer.prototype.onResendOtp = function () {
        var phone = this.props.phone;
        Object(__WEBPACK_IMPORTED_MODULE_9_helper_analytics__["b" /* sendEvent */])({
            action: __WEBPACK_IMPORTED_MODULE_7_constants_analytics__["a" /* AnalyticsEventAction */].OTP_RESEND,
            category: __WEBPACK_IMPORTED_MODULE_7_constants_analytics__["b" /* AnalyticsEventCategory */].ACCOUNT_FORGOT_PASSWORD_OTP
        });
        this.props.requestResend(phone);
    };
    AccountForgotPasswordOtpContainer.prototype.onSubmit = function (formValue) {
        var phone = this.props.phone;
        var fullFormValue = __assign({}, formValue, { phone: phone });
        Object(__WEBPACK_IMPORTED_MODULE_9_helper_analytics__["b" /* sendEvent */])({
            action: __WEBPACK_IMPORTED_MODULE_7_constants_analytics__["a" /* AnalyticsEventAction */].OTP_CONFIRM,
            category: __WEBPACK_IMPORTED_MODULE_7_constants_analytics__["b" /* AnalyticsEventCategory */].ACCOUNT_FORGOT_PASSWORD_OTP
        });
        this.props.confirmForgotPassword(fullFormValue);
    };
    AccountForgotPasswordOtpContainer = __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_10_helper_redux__["b" /* injectIntl */])()
    ], AccountForgotPasswordOtpContainer);
    return AccountForgotPasswordOtpContainer;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
var AccountForgotPasswordOtp = Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function (state) { return ({
    phone: state.accountState.tempAccount.phone
}); }, { confirmForgotPassword: __WEBPACK_IMPORTED_MODULE_3_actions_account__["c" /* confirmForgotPassword */], requestResend: __WEBPACK_IMPORTED_MODULE_4_actions_otp__["b" /* requestResend */] })(AccountForgotPasswordOtpContainer);


/***/ }),

/***/ 851:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = validate;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_helper_form__ = __webpack_require__(19);

function validate(formValue) {
    var errors = {};
    if (!formValue.otp) {
        errors.otp = 'form.error.required';
    }
    if (!formValue.newPassword) {
        errors.newPassword = 'form.error.required';
    }
    else if (!Object(__WEBPACK_IMPORTED_MODULE_0_helper_form__["h" /* isValidPasswordFormat */])(formValue.newPassword)) {
        errors.newPassword = 'form.error.invalid.password.format';
    }
    return errors;
}


/***/ }),

/***/ 852:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(853);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(699)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--5-2!../../../../../node_modules/sass-loader/lib/loader.js!../../../../../node_modules/postcss-loader/lib/index.js??postcss!./AccountForgotPasswordOtp.scss", function() {
			var newContent = require("!!../../../../../node_modules/css-loader/index.js??ref--5-2!../../../../../node_modules/sass-loader/lib/loader.js!../../../../../node_modules/postcss-loader/lib/index.js??postcss!./AccountForgotPasswordOtp.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 853:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(698)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),

/***/ 854:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AccountKycOverview; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_intl__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_router__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_actions_wallet__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_Button__ = __webpack_require__(230);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_Layout__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_Loader__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_constants_account__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_constants_app__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_images_index__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__AccountKycOverview_scss__ = __webpack_require__(855);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__AccountKycOverview_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__AccountKycOverview_scss__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();













var AccountKycOverviewContainer = /** @class */ (function (_super) {
    __extends(AccountKycOverviewContainer, _super);
    function AccountKycOverviewContainer(props) {
        var _this = _super.call(this, props) || this;
        _this.features = [{
                icon: 'ic-invoice',
                text: 'account.kyc.overview.feature.invoice.text'
            }, {
                icon: 'ic-rupiah',
                text: 'account.kyc.overview.feature.max.balance.text',
                textValues: {
                    amount: __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("b", null,
                        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_intl__["c" /* FormattedMessage */], { id: "account.kyc.overview.feature.max.balance" }))
                }
            }, {
                icon: 'ic-transaction',
                text: 'account.kyc.overview.feature.max.money.in.text',
                textValues: {
                    amount: __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("b", null,
                        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_intl__["c" /* FormattedMessage */], { id: "account.kyc.overview.feature.max.money.in" }))
                }
            }, {
                icon: 'ic-money-out',
                text: 'account.kyc.overview.feature.transfer.text'
            }];
        _this.goToKycRegister = _this.goToKycRegister.bind(_this);
        return _this;
    }
    AccountKycOverviewContainer.prototype.componentWillMount = function () {
        var walletAccountState = this.props.walletAccountState;
        if (walletAccountState.walletAccount.type.id === '') {
            this.props.getWalletAccount();
        }
    };
    AccountKycOverviewContainer.prototype.render = function () {
        var _a = this.props, account = _a.account, history = _a.history, walletAccountState = _a.walletAccountState;
        if (walletAccountState.walletAccount.type.id !== '' && account.profile && account.profile.status === __WEBPACK_IMPORTED_MODULE_9_constants_account__["a" /* AccountProfileStatus */].PENDING) {
            return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_react_router__["a" /* Redirect */], { to: __WEBPACK_IMPORTED_MODULE_10_constants_app__["k" /* ROUTE_ACCOUNT_KYC_WAITING */] });
        }
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8_components_Loader__["a" /* LoaderBlock */], { className: "o-container o-container--fluid o-container--fluid-vertical o-container__flex-column u-full-height", blocking: walletAccountState.isLoading },
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "o-container__flex--full o-container__flex-column o-container__flex--center" },
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7_components_Layout__["b" /* LayoutHeader */], { actionIcon: "ic-close", actionHandler: history.goBack },
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("h1", { className: "o-layout-header-title" },
                        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_intl__["c" /* FormattedMessage */], { id: "account.kyc.overview.title" }))),
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("img", { alt: "kyc sample ktp", src: __WEBPACK_IMPORTED_MODULE_11_images_index__["l" /* ImageKycSampleKtp */] }),
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("span", { className: "account-kyc-overview__notice" },
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_intl__["c" /* FormattedMessage */], { id: "account.kyc.overview.notice" })),
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("p", { className: "account-kyc-overview__message o-subhead u-medium" },
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_intl__["c" /* FormattedMessage */], { id: "account.kyc.overview.message" })),
                this.renderFeatures),
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_components_Button__["a" /* Button */], { onClick: this.goToKycRegister, className: "button--green button--full", type: "button" },
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_intl__["c" /* FormattedMessage */], { id: "account.kyc.overview.upgrade.button" }))));
    };
    Object.defineProperty(AccountKycOverviewContainer.prototype, "renderFeatures", {
        get: function () {
            return this.features.map(function (feature, index) {
                var content = feature.textValues ?
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_intl__["c" /* FormattedMessage */], { id: feature.text, values: feature.textValues }) :
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_intl__["c" /* FormattedMessage */], { id: feature.text });
                return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("p", { key: index, className: "account-kyc-overview__feature" },
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("i", { className: __WEBPACK_IMPORTED_MODULE_0_classnames__(feature.icon, 'account-kyc-overview__feature-icon o-icon-action') }),
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("span", { className: "account-kyc-overview__feature-text" }, content)));
            });
        },
        enumerable: true,
        configurable: true
    });
    AccountKycOverviewContainer.prototype.goToKycRegister = function () {
        var history = this.props.history;
        history.push(__WEBPACK_IMPORTED_MODULE_10_constants_app__["h" /* ROUTE_ACCOUNT_KYC_REGISTER */]);
    };
    return AccountKycOverviewContainer;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));
var AccountKycOverview = Object(__WEBPACK_IMPORTED_MODULE_3_react_redux__["b" /* connect */])(function (state) { return ({
    account: state.accountState.account,
    walletAccountState: state.walletState.accountState
}); }, { getWalletAccount: __WEBPACK_IMPORTED_MODULE_5_actions_wallet__["e" /* getWalletAccount */] })(AccountKycOverviewContainer);


/***/ }),

/***/ 855:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(856);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(699)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--5-2!../../../../../node_modules/sass-loader/lib/loader.js!../../../../../node_modules/postcss-loader/lib/index.js??postcss!./AccountKycOverview.scss", function() {
			var newContent = require("!!../../../../../node_modules/css-loader/index.js??ref--5-2!../../../../../node_modules/sass-loader/lib/loader.js!../../../../../node_modules/postcss-loader/lib/index.js??postcss!./AccountKycOverview.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 856:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(698)(false);
// imports


// module
exports.push([module.i, ".account-kyc-overview__notice{color:#adadad}.account-kyc-overview__message{margin:28px 0 20px}.account-kyc-overview__feature{-ms-flex-item-align:left;align-self:left;margin-bottom:20px}.account-kyc-overview__feature-text{margin-left:16px;color:#777}.account-kyc-overview__feature-icon{vertical-align:middle}", ""]);

// exports


/***/ }),

/***/ 857:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AccountKycRegister; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_intl__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_actions_account__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_Button__ = __webpack_require__(230);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_Form__ = __webpack_require__(709);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_Input__ = __webpack_require__(708);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_Layout__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_constants_account__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_constants_app__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_helper_form__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_helper_redux__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_helper_validation_account_accountProfileForm__ = __webpack_require__(858);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__AccountKycRegister_scss__ = __webpack_require__(859);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__AccountKycRegister_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__AccountKycRegister_scss__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};














var AccountKycRegisterContainer = /** @class */ (function (_super) {
    __extends(AccountKycRegisterContainer, _super);
    function AccountKycRegisterContainer(props) {
        var _this = _super.call(this, props) || this;
        _this.onSubmit = _this.onSubmit.bind(_this);
        _this.setFieldNameReference = _this.setFieldNameReference.bind(_this);
        return _this;
    }
    AccountKycRegisterContainer.prototype.componentDidMount = function () {
        this.fieldName.getRenderedComponent().focus();
    };
    AccountKycRegisterContainer.prototype.render = function () {
        var _a = this.props, history = _a.history, intl = _a.intl, tempAccountProfile = _a.tempAccountProfile;
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5_components_Form__["a" /* Form */], { className: "o-container o-container--fluid o-container--fluid-vertical", form: __WEBPACK_IMPORTED_MODULE_9_constants_app__["b" /* APPLICATION_FORM_NAME */], initialValues: tempAccountProfile, onSubmit: this.onSubmit, validate: __WEBPACK_IMPORTED_MODULE_12_helper_validation_account_accountProfileForm__["a" /* validate */] },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7_components_Layout__["b" /* LayoutHeader */], { actionIcon: "ic-arrow-left", actionHandler: history.goBack },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h1", { className: "o-layout-header-title" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_intl__["c" /* FormattedMessage */], { id: "account.kyc.register.title" }))),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_components_Input__["d" /* FieldText */], { className: "o-form-field", component: __WEBPACK_IMPORTED_MODULE_6_components_Input__["i" /* InputText */], label: intl.formatMessage({ id: 'account.kyc.form.name' }), modifier: "cancel", name: "name", ref: this.setFieldNameReference, type: "text", withRef: true }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_components_Input__["d" /* FieldText */], { className: "o-form-field", component: __WEBPACK_IMPORTED_MODULE_6_components_Input__["i" /* InputText */], label: intl.formatMessage({ id: 'account.kyc.form.nationalCardNumber' }), modifier: "cancel", name: "nationalCardNumber", type: "tel" }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_components_Input__["d" /* FieldText */], { className: "o-form-field", component: __WEBPACK_IMPORTED_MODULE_6_components_Input__["i" /* InputText */], label: intl.formatMessage({ id: 'account.kyc.form.birthPlace' }), modifier: "cancel", name: "birthPlace", type: "text" }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_components_Input__["d" /* FieldText */], { className: "o-form-field", component: __WEBPACK_IMPORTED_MODULE_6_components_Input__["i" /* InputText */], label: intl.formatMessage({ id: 'account.kyc.form.birthDate' }), footnote: __WEBPACK_IMPORTED_MODULE_8_constants_account__["c" /* BIRTH_DATE_FORMAT */], mask: __WEBPACK_IMPORTED_MODULE_10_helper_form__["l" /* maskBirthDate */], modifier: "cancel", name: "birthDate", type: "tel" }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_components_Input__["d" /* FieldText */], { className: "o-form-field", component: __WEBPACK_IMPORTED_MODULE_6_components_Input__["i" /* InputText */], label: intl.formatMessage({ id: 'account.kyc.form.address' }), modifier: "cancel", name: "address", type: "text" }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_components_Input__["d" /* FieldText */], { className: "o-form-field", component: __WEBPACK_IMPORTED_MODULE_6_components_Input__["i" /* InputText */], label: intl.formatMessage({ id: 'account.kyc.form.motherName' }), modifier: "cancel", name: "motherName", type: "text" }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_components_Button__["a" /* Button */], { type: "submit", className: "o-form-button button--full button--primary" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_intl__["c" /* FormattedMessage */], { id: "account.kyc.form.button" }))));
    };
    AccountKycRegisterContainer.prototype.onSubmit = function (formValue) {
        var _a = this.props, history = _a.history, updateTempAccountProfileForm = _a.updateTempAccountProfileForm;
        updateTempAccountProfileForm(formValue);
        history.push(__WEBPACK_IMPORTED_MODULE_9_constants_app__["i" /* ROUTE_ACCOUNT_KYC_UPLOAD_DOCUMENT */]);
    };
    AccountKycRegisterContainer.prototype.setFieldNameReference = function (field) {
        this.fieldName = field;
    };
    AccountKycRegisterContainer = __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_11_helper_redux__["b" /* injectIntl */])()
    ], AccountKycRegisterContainer);
    return AccountKycRegisterContainer;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
var AccountKycRegister = Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(function (state) { return ({
    tempAccountProfile: state.accountState.tempAccountProfileForm
}); }, {
    updateTempAccountProfileForm: __WEBPACK_IMPORTED_MODULE_3_actions_account__["a" /* AccountActionCreators */].updateTempAccountProfileForm.create
})(AccountKycRegisterContainer);


/***/ }),

/***/ 858:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = validate;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_constants_account__ = __webpack_require__(49);


function validate(formValue) {
    var errors = {};
    if (!formValue.name) {
        errors.name = 'form.error.required';
    }
    if (!formValue.nationalCardNumber) {
        errors.nationalCardNumber = 'form.error.required';
    }
    if (!formValue.birthPlace) {
        errors.birthPlace = 'form.error.required';
    }
    if (!formValue.birthDate) {
        errors.birthDate = 'form.error.required';
    }
    else if (!__WEBPACK_IMPORTED_MODULE_0_moment__["utc"](formValue.birthDate, __WEBPACK_IMPORTED_MODULE_1_constants_account__["c" /* BIRTH_DATE_FORMAT */]).isValid()) {
        errors.birthDate = 'form.error.invalid.birthDate.format';
    }
    if (!formValue.address) {
        errors.address = 'form.error.required';
    }
    if (!formValue.motherName) {
        errors.motherName = 'form.error.required';
    }
    return errors;
}


/***/ }),

/***/ 859:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(860);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(699)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--5-2!../../../../../node_modules/sass-loader/lib/loader.js!../../../../../node_modules/postcss-loader/lib/index.js??postcss!./AccountKycRegister.scss", function() {
			var newContent = require("!!../../../../../node_modules/css-loader/index.js??ref--5-2!../../../../../node_modules/sass-loader/lib/loader.js!../../../../../node_modules/postcss-loader/lib/index.js??postcss!./AccountKycRegister.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 860:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(698)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),

/***/ 861:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AccountKycUploadDocument; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_intl__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_redux_form__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_actions_account__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_Button__ = __webpack_require__(230);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_Form__ = __webpack_require__(709);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_Input__ = __webpack_require__(708);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_Layout__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_constants_app__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_helper_redux__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_helper_validation_account_accountKycUploadDocumentForm__ = __webpack_require__(862);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_images_index__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__AccountKycUploadDocument_scss__ = __webpack_require__(863);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__AccountKycUploadDocument_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__AccountKycUploadDocument_scss__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};















var selector = Object(__WEBPACK_IMPORTED_MODULE_4_redux_form__["c" /* formValueSelector */])(__WEBPACK_IMPORTED_MODULE_10_constants_app__["b" /* APPLICATION_FORM_NAME */]);
var AccountKycUploadDocumentContainer = /** @class */ (function (_super) {
    __extends(AccountKycUploadDocumentContainer, _super);
    function AccountKycUploadDocumentContainer(props) {
        var _this = _super.call(this, props) || this;
        _this.onSubmit = _this.onSubmit.bind(_this);
        return _this;
    }
    AccountKycUploadDocumentContainer.prototype.render = function () {
        var _a = this.props, history = _a.history, intl = _a.intl, tempAccountProfile = _a.tempAccountProfile;
        if (!tempAccountProfile || !tempAccountProfile.name) {
            return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_react_router__["a" /* Redirect */], { to: __WEBPACK_IMPORTED_MODULE_10_constants_app__["h" /* ROUTE_ACCOUNT_KYC_REGISTER */] });
        }
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7_components_Form__["a" /* Form */], { className: "o-container o-container--fluid o-container--fluid-vertical", form: __WEBPACK_IMPORTED_MODULE_10_constants_app__["b" /* APPLICATION_FORM_NAME */], onSubmit: this.onSubmit, validate: __WEBPACK_IMPORTED_MODULE_12_helper_validation_account_accountKycUploadDocumentForm__["a" /* validate */] },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9_components_Layout__["b" /* LayoutHeader */], { actionIcon: "ic-arrow-left", actionHandler: history.goBack },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h1", { className: "o-layout-header-title" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_intl__["c" /* FormattedMessage */], { id: "account.kyc.uploadDocument.title" }))),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_intl__["c" /* FormattedMessage */], { id: "account.kyc.uploadDocument.subtitle" })),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8_components_Input__["b" /* FieldFileCard */], { className: "account-kyc-upload-document__upload-card", component: __WEBPACK_IMPORTED_MODULE_8_components_Input__["f" /* InputFileCard */], imageSrc: __WEBPACK_IMPORTED_MODULE_13_images_index__["q" /* ImageNationalCardScan */], label: intl.formatMessage({ id: 'account.kyc.uploadDocument.nationalCardScan' }), name: "nationalCardScan" }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8_components_Input__["b" /* FieldFileCard */], { className: "account-kyc-upload-document__upload-card", component: __WEBPACK_IMPORTED_MODULE_8_components_Input__["f" /* InputFileCard */], imageSrc: __WEBPACK_IMPORTED_MODULE_13_images_index__["r" /* ImageNationalCardSelfie */], label: intl.formatMessage({ id: 'account.kyc.uploadDocument.nationalCardSelfie' }), name: "nationalCardSelfie" }),
            this.actionButton));
    };
    Object.defineProperty(AccountKycUploadDocumentContainer.prototype, "actionButton", {
        get: function () {
            var _a = this.props, nationalCardScanFormValue = _a.nationalCardScanFormValue, nationalCardSelfieFormValue = _a.nationalCardSelfieFormValue;
            var isShowActionButton = nationalCardScanFormValue && nationalCardScanFormValue.preview
                && nationalCardSelfieFormValue && nationalCardSelfieFormValue.preview;
            if (isShowActionButton) {
                return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_components_Button__["a" /* Button */], { type: "submit", className: "o-form-button button--full button--primary" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_intl__["c" /* FormattedMessage */], { id: "account.kyc.uploadDocument.button" })));
            }
            return null;
        },
        enumerable: true,
        configurable: true
    });
    AccountKycUploadDocumentContainer.prototype.onSubmit = function (formValue) {
        this.props.registerProfile(formValue);
    };
    AccountKycUploadDocumentContainer = __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_11_helper_redux__["b" /* injectIntl */])()
    ], AccountKycUploadDocumentContainer);
    return AccountKycUploadDocumentContainer;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
var AccountKycUploadDocument = Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(function (state) { return ({
    nationalCardScanFormValue: selector(state, 'nationalCardScan'),
    nationalCardSelfieFormValue: selector(state, 'nationalCardSelfie'),
    tempAccountProfile: state.accountState.tempAccountProfileForm
}); }, { registerProfile: __WEBPACK_IMPORTED_MODULE_5_actions_account__["l" /* registerProfile */] })(AccountKycUploadDocumentContainer);


/***/ }),

/***/ 862:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = validate;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_constants_image__ = __webpack_require__(231);

function validate(formValue) {
    var errors = {};
    if (formValue.nationalCardScan && formValue.nationalCardScan.size > __WEBPACK_IMPORTED_MODULE_0_constants_image__["c" /* MAX_IMAGE_FILE_SIZE_IN_BYTES */]) {
        errors.nationalCardScan = 'form.error.image.size.limit.exceeded';
    }
    if (formValue.nationalCardSelfie && formValue.nationalCardSelfie.size > __WEBPACK_IMPORTED_MODULE_0_constants_image__["c" /* MAX_IMAGE_FILE_SIZE_IN_BYTES */]) {
        errors.nationalCardSelfie = 'form.error.image.size.limit.exceeded';
    }
    return errors;
}


/***/ }),

/***/ 863:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(864);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(699)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--5-2!../../../../../node_modules/sass-loader/lib/loader.js!../../../../../node_modules/postcss-loader/lib/index.js??postcss!./AccountKycUploadDocument.scss", function() {
			var newContent = require("!!../../../../../node_modules/css-loader/index.js??ref--5-2!../../../../../node_modules/sass-loader/lib/loader.js!../../../../../node_modules/postcss-loader/lib/index.js??postcss!./AccountKycUploadDocument.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 864:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(698)(false);
// imports


// module
exports.push([module.i, ".account-kyc-upload-document__upload-card{margin-top:24px}", ""]);

// exports


/***/ }),

/***/ 865:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AccountLogin; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_qs__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_qs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_qs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_intl__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_actions_account__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_Button__ = __webpack_require__(230);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_Footer__ = __webpack_require__(752);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_Form__ = __webpack_require__(709);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_Input__ = __webpack_require__(708);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_Layout__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_LinkWithAnalytics__ = __webpack_require__(232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_constants_analytics__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_constants_app__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_helper_analytics__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_helper_redux__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_helper_validation_account_accountLoginForm__ = __webpack_require__(866);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__AccountLogin_scss__ = __webpack_require__(867);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__AccountLogin_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__AccountLogin_scss__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};

















var AccountLoginContainer = /** @class */ (function (_super) {
    __extends(AccountLoginContainer, _super);
    function AccountLoginContainer(props) {
        var _this = _super.call(this, props) || this;
        _this.isValidSignInRedirectUrl = _this.isValidSignInRedirectUrl.bind(_this);
        _this.onSubmit = _this.onSubmit.bind(_this);
        _this.setFieldUsernameReference = _this.setFieldUsernameReference.bind(_this);
        return _this;
    }
    AccountLoginContainer.prototype.componentDidMount = function () {
        this.fieldUsername.getRenderedComponent().focus();
    };
    AccountLoginContainer.prototype.render = function () {
        var intl = this.props.intl;
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7_components_Form__["a" /* Form */], { className: "o-container o-container--fluid o-container--fluid-vertical", form: __WEBPACK_IMPORTED_MODULE_12_constants_app__["b" /* APPLICATION_FORM_NAME */], onSubmit: this.onSubmit, validate: __WEBPACK_IMPORTED_MODULE_15_helper_validation_account_accountLoginForm__["a" /* validate */] },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9_components_Layout__["e" /* LayoutTitle */], { modifier: "with-logo", title: intl.formatMessage({ id: 'account.login.title' }) }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9_components_Layout__["a" /* LayoutFooter */], null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_components_Footer__["a" /* Footer */], null)),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8_components_Input__["d" /* FieldText */], { className: "o-form-field", component: __WEBPACK_IMPORTED_MODULE_8_components_Input__["i" /* InputText */], label: intl.formatMessage({ id: 'account.login.username' }), modifier: "cancel", name: "username", ref: this.setFieldUsernameReference, type: "text", withRef: true }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8_components_Input__["d" /* FieldText */], { name: "password", label: intl.formatMessage({ id: 'account.login.password' }), component: __WEBPACK_IMPORTED_MODULE_8_components_Input__["i" /* InputText */], type: "password", modifier: "visibility", className: "o-form-field" }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "account-login__box" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10_components_LinkWithAnalytics__["a" /* LinkWithAnalytics */], { to: __WEBPACK_IMPORTED_MODULE_12_constants_app__["w" /* ROUTE_FORGOT_PASSWORD */], className: "account-login__link", category: __WEBPACK_IMPORTED_MODULE_11_constants_analytics__["b" /* AnalyticsEventCategory */].ACCOUNT_LOG_IN, action: __WEBPACK_IMPORTED_MODULE_11_constants_analytics__["a" /* AnalyticsEventAction */].OPEN_ACCOUNT_FORGOT_PASSWORD_PAGE },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_intl__["c" /* FormattedMessage */], { id: "account.login.forgot.password" })),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5_components_Button__["a" /* Button */], { type: "submit", className: "account-login__button button--primary" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_intl__["c" /* FormattedMessage */], { id: "account.login.continue" })))));
    };
    AccountLoginContainer.prototype.onSubmit = function (formValue) {
        var location = this.props.location;
        var redirectUrl = Object(__WEBPACK_IMPORTED_MODULE_1_qs__["parse"])(location.search.replace(/\?/g, '')).redirect_url;
        Object(__WEBPACK_IMPORTED_MODULE_13_helper_analytics__["b" /* sendEvent */])({
            action: __WEBPACK_IMPORTED_MODULE_11_constants_analytics__["a" /* AnalyticsEventAction */].ACCOUNT_LOG_IN,
            category: __WEBPACK_IMPORTED_MODULE_11_constants_analytics__["b" /* AnalyticsEventCategory */].ACCOUNT_LOG_IN
        });
        if (redirectUrl && this.isValidSignInRedirectUrl(redirectUrl)) {
            this.props.loginWithRedirect(formValue, redirectUrl);
        }
        else {
            this.props.login(formValue);
        }
    };
    AccountLoginContainer.prototype.isValidSignInRedirectUrl = function (redirectUrl) {
        var signInAllowedRedirectUrls = "https://checkout.kaskus.co.id" || '';
        return signInAllowedRedirectUrls
            .split(',')
            .some(function (allowedUrl) {
            return allowedUrl === redirectUrl || redirectUrl.startsWith(allowedUrl + "/");
        });
    };
    AccountLoginContainer.prototype.setFieldUsernameReference = function (field) {
        this.fieldUsername = field;
    };
    AccountLoginContainer = __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_14_helper_redux__["b" /* injectIntl */])()
    ], AccountLoginContainer);
    return AccountLoginContainer;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
var AccountLogin = Object(__WEBPACK_IMPORTED_MODULE_3_react_redux__["b" /* connect */])(null, { login: __WEBPACK_IMPORTED_MODULE_4_actions_account__["h" /* login */], loginWithRedirect: __WEBPACK_IMPORTED_MODULE_4_actions_account__["i" /* loginWithRedirect */] })(AccountLoginContainer);


/***/ }),

/***/ 866:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = validate;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_helper_form__ = __webpack_require__(19);

function validate(formValue) {
    var errors = {};
    if (!formValue.username) {
        errors.username = 'form.error.required';
    }
    else if (!Object(__WEBPACK_IMPORTED_MODULE_0_helper_form__["k" /* isValidUsername */])(formValue.username)) {
        errors.username = 'form.error.invalid.username.format';
    }
    if (!formValue.password) {
        errors.password = 'form.error.required';
    }
    return errors;
}


/***/ }),

/***/ 867:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(868);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(699)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--5-2!../../../../../node_modules/sass-loader/lib/loader.js!../../../../../node_modules/postcss-loader/lib/index.js??postcss!./AccountLogin.scss", function() {
			var newContent = require("!!../../../../../node_modules/css-loader/index.js??ref--5-2!../../../../../node_modules/sass-loader/lib/loader.js!../../../../../node_modules/postcss-loader/lib/index.js??postcss!./AccountLogin.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 868:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(698)(false);
// imports


// module
exports.push([module.i, ".account-login__box{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;margin-top:20px}.account-login__button{width:120px}.account-login__link{-ms-flex:1 1;flex:1 1}.account-login__register{margin-top:36px;text-align:center}.account-login__register-link{margin-left:8px}", ""]);

// exports


/***/ }),

/***/ 869:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AccountPasswordUpdate; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_intl__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_actions_account__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_Button__ = __webpack_require__(230);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_Form__ = __webpack_require__(709);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_Input__ = __webpack_require__(708);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_Layout__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_constants_analytics__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_constants_app__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_helper_analytics__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_helper_redux__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_helper_validation_account_accountPasswordUpdateForm__ = __webpack_require__(870);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__AccountPasswordUpdate_scss__ = __webpack_require__(871);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__AccountPasswordUpdate_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__AccountPasswordUpdate_scss__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};














var AccountPasswordUpdateContainer = /** @class */ (function (_super) {
    __extends(AccountPasswordUpdateContainer, _super);
    function AccountPasswordUpdateContainer(props) {
        var _this = _super.call(this, props) || this;
        _this.onSubmit = _this.onSubmit.bind(_this);
        _this.setFieldPasswordReference = _this.setFieldPasswordReference.bind(_this);
        return _this;
    }
    AccountPasswordUpdateContainer.prototype.componentDidMount = function () {
        this.fieldPassword.getRenderedComponent().focus();
    };
    AccountPasswordUpdateContainer.prototype.render = function () {
        var _a = this.props, history = _a.history, intl = _a.intl;
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5_components_Form__["a" /* Form */], { className: "o-container o-container--fluid o-container--fluid-vertical", form: __WEBPACK_IMPORTED_MODULE_9_constants_app__["b" /* APPLICATION_FORM_NAME */], onSubmit: this.onSubmit, validate: __WEBPACK_IMPORTED_MODULE_12_helper_validation_account_accountPasswordUpdateForm__["a" /* validate */] },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7_components_Layout__["b" /* LayoutHeader */], { actionIcon: "ic-arrow-left", actionHandler: history.goBack },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h1", { className: "o-layout-header-title" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_intl__["c" /* FormattedMessage */], { id: "account.password.update.title" }))),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_components_Input__["d" /* FieldText */], { className: "o-form-field", component: __WEBPACK_IMPORTED_MODULE_6_components_Input__["i" /* InputText */], label: intl.formatMessage({ id: 'account.password.update.oldPassword' }), modifier: "visibility", name: "password", ref: this.setFieldPasswordReference, type: "password", withRef: true }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_components_Input__["d" /* FieldText */], { name: "newPassword", component: __WEBPACK_IMPORTED_MODULE_6_components_Input__["i" /* InputText */], label: intl.formatMessage({ id: 'account.password.update.newPassword' }), footnote: intl.formatMessage({ id: 'form.footnote.valid.password.format' }), type: "password", modifier: "visibility", className: "o-form-field" }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_components_Button__["a" /* Button */], { type: "submit", className: "o-form-button button--full button--primary" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_intl__["c" /* FormattedMessage */], { id: "account.password.update.continue" }))));
    };
    AccountPasswordUpdateContainer.prototype.onSubmit = function (formValue) {
        Object(__WEBPACK_IMPORTED_MODULE_10_helper_analytics__["b" /* sendEvent */])({
            action: __WEBPACK_IMPORTED_MODULE_8_constants_analytics__["a" /* AnalyticsEventAction */].ACCOUNT_CHANGE_PASSWORD,
            category: __WEBPACK_IMPORTED_MODULE_8_constants_analytics__["b" /* AnalyticsEventCategory */].ACCOUNT_CHANGE_PASSWORD
        });
        this.props.updatePassword(formValue);
    };
    AccountPasswordUpdateContainer.prototype.setFieldPasswordReference = function (field) {
        this.fieldPassword = field;
    };
    AccountPasswordUpdateContainer = __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_11_helper_redux__["b" /* injectIntl */])()
    ], AccountPasswordUpdateContainer);
    return AccountPasswordUpdateContainer;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
var AccountPasswordUpdate = Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(null, { updatePassword: __WEBPACK_IMPORTED_MODULE_3_actions_account__["p" /* updatePassword */] })(AccountPasswordUpdateContainer);


/***/ }),

/***/ 870:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = validate;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_helper_form__ = __webpack_require__(19);

function validate(formValue) {
    var errors = {};
    if (!formValue.password) {
        errors.password = 'form.error.required';
    }
    if (!formValue.newPassword) {
        errors.newPassword = 'form.error.required';
    }
    else if (!Object(__WEBPACK_IMPORTED_MODULE_0_helper_form__["h" /* isValidPasswordFormat */])(formValue.newPassword)) {
        errors.newPassword = 'form.error.invalid.password.format';
    }
    return errors;
}


/***/ }),

/***/ 871:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(872);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(699)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--5-2!../../../../../node_modules/sass-loader/lib/loader.js!../../../../../node_modules/postcss-loader/lib/index.js??postcss!./AccountPasswordUpdate.scss", function() {
			var newContent = require("!!../../../../../node_modules/css-loader/index.js??ref--5-2!../../../../../node_modules/sass-loader/lib/loader.js!../../../../../node_modules/postcss-loader/lib/index.js??postcss!./AccountPasswordUpdate.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 872:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(698)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),

/***/ 873:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AccountPhoneDetail; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_intl__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_Layout__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_constants_app__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__AccountPhoneDetail_scss__ = __webpack_require__(874);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__AccountPhoneDetail_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__AccountPhoneDetail_scss__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();







var AccountPhoneDetailContainer = /** @class */ (function (_super) {
    __extends(AccountPhoneDetailContainer, _super);
    function AccountPhoneDetailContainer() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AccountPhoneDetailContainer.prototype.render = function () {
        var _a = this.props, history = _a.history, phone = _a.phone;
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "o-container o-container--fluid o-container--fluid-vertical" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_components_Layout__["b" /* LayoutHeader */], { actionIcon: "ic-arrow-left", actionHandler: history.goBack },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h1", { className: "o-layout-header-title" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_intl__["c" /* FormattedMessage */], { id: "account.profile.phonenumber" }))),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "account-phone-detail__phone-container" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "account-phone-detail__phone-label o-footnote-1" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_intl__["c" /* FormattedMessage */], { id: "account.profile.phonenumber" })),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "account-phone-detail__phone-value" }, phone)),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "account-phone-detail__message" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_intl__["c" /* FormattedMessage */], { id: "account.profile.phonenumber.change.message" }),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["a" /* Link */], { to: __WEBPACK_IMPORTED_MODULE_5_constants_app__["H" /* ROUTE_STATIC_CONTACT_US */] },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_intl__["c" /* FormattedMessage */], { id: "account.profile.phonenumber.change.contact.us" })))));
    };
    return AccountPhoneDetailContainer;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
var AccountPhoneDetail = Object(__WEBPACK_IMPORTED_MODULE_3_react_redux__["b" /* connect */])(function (state) { return ({
    phone: state.accountState.account.phone
}); }, {})(AccountPhoneDetailContainer);


/***/ }),

/***/ 874:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(875);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(699)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--5-2!../../../../../node_modules/sass-loader/lib/loader.js!../../../../../node_modules/postcss-loader/lib/index.js??postcss!./AccountPhoneDetail.scss", function() {
			var newContent = require("!!../../../../../node_modules/css-loader/index.js??ref--5-2!../../../../../node_modules/sass-loader/lib/loader.js!../../../../../node_modules/postcss-loader/lib/index.js??postcss!./AccountPhoneDetail.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 875:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(698)(false);
// imports


// module
exports.push([module.i, ".account-phone-detail__phone-container{margin-bottom:24px}.account-phone-detail__phone-label{color:#c2c2c2}.account-phone-detail__phone-value{padding:8px 0 12px;border-radius:0;border-bottom:1px solid #bdbdbd;color:#adadad}.account-phone-detail__message{padding:12px 20px;border-radius:4px;background-color:#e8e8e8;color:#404041;font-size:13px}", ""]);

// exports


/***/ }),

/***/ 876:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AccountPhoneSet; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_intl__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_actions_account__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_Button__ = __webpack_require__(230);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_Form__ = __webpack_require__(709);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_Input__ = __webpack_require__(708);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_Layout__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_constants_app__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_helper_form__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_helper_redux__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_helper_validation_account_accountPhoneForm__ = __webpack_require__(877);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__AccountPhoneSet_scss__ = __webpack_require__(878);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__AccountPhoneSet_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__AccountPhoneSet_scss__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};














var AccountPhoneSetContainer = /** @class */ (function (_super) {
    __extends(AccountPhoneSetContainer, _super);
    function AccountPhoneSetContainer(props) {
        var _this = _super.call(this, props) || this;
        _this.onSubmit = _this.onSubmit.bind(_this);
        _this.setFieldPhoneReference = _this.setFieldPhoneReference.bind(_this);
        return _this;
    }
    AccountPhoneSetContainer.prototype.componentDidMount = function () {
        if (this.fieldPhone) {
            this.fieldPhone.getRenderedComponent().focus();
        }
    };
    AccountPhoneSetContainer.prototype.render = function () {
        var _a = this.props, initialValues = _a.initialValues, intl = _a.intl, phone = _a.phone;
        if (phone) {
            return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_react_router__["a" /* Redirect */], { to: __WEBPACK_IMPORTED_MODULE_9_constants_app__["O" /* ROUTE_WALLET_DASHBOARD */] });
        }
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_components_Form__["a" /* Form */], { className: "o-container o-container--fluid o-container--fluid-vertical", form: __WEBPACK_IMPORTED_MODULE_9_constants_app__["b" /* APPLICATION_FORM_NAME */], initialValues: initialValues, onSubmit: this.onSubmit, validate: __WEBPACK_IMPORTED_MODULE_12_helper_validation_account_accountPhoneForm__["a" /* validate */] },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8_components_Layout__["b" /* LayoutHeader */], { actionIcon: "ic-arrow-left", actionHandler: this.props.logout },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h1", { className: "o-layout-header-title" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_intl__["c" /* FormattedMessage */], { id: "account.phone.set.title" }))),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { className: "account-phone-set__info" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_intl__["c" /* FormattedMessage */], { id: "account.phone.set.info" })),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7_components_Input__["d" /* FieldText */], { className: "o-form-field", component: __WEBPACK_IMPORTED_MODULE_7_components_Input__["i" /* InputText */], footnote: intl.formatMessage({ id: 'form.footnote.otp.info' }), label: intl.formatMessage({ id: 'account.phone.set.phonenumber' }), modifier: "cancel", name: "phone", normalize: __WEBPACK_IMPORTED_MODULE_10_helper_form__["o" /* normalizePhone */], ref: this.setFieldPhoneReference, type: "tel", withRef: true }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5_components_Button__["a" /* Button */], { type: "submit", className: "o-form-button button--full button--primary" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_intl__["c" /* FormattedMessage */], { id: "account.phone.set.continue" }))));
    };
    AccountPhoneSetContainer.prototype.onSubmit = function (formValue) {
        this.props.validatePhone(formValue);
    };
    AccountPhoneSetContainer.prototype.setFieldPhoneReference = function (field) {
        this.fieldPhone = field;
    };
    AccountPhoneSetContainer = __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_11_helper_redux__["b" /* injectIntl */])()
    ], AccountPhoneSetContainer);
    return AccountPhoneSetContainer;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
var AccountPhoneSet = Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(function (state) { return ({
    initialValues: {
        phone: state.accountState.tempAccount.phone
    },
    phone: state.accountState.account.phone
}); }, { logout: __WEBPACK_IMPORTED_MODULE_4_actions_account__["j" /* logout */], validatePhone: __WEBPACK_IMPORTED_MODULE_4_actions_account__["r" /* validatePhone */] })(AccountPhoneSetContainer);


/***/ }),

/***/ 877:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = validate;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_helper_form__ = __webpack_require__(19);

function validate(formValue) {
    var errors = {};
    if (!formValue.phone) {
        errors.phone = 'form.error.required';
    }
    else if (!Object(__WEBPACK_IMPORTED_MODULE_0_helper_form__["i" /* isValidPhone */])(formValue.phone)) {
        errors.phone = 'form.error.invalid.phone.format';
    }
    return errors;
}


/***/ }),

/***/ 878:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(879);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(699)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--5-2!../../../../../node_modules/sass-loader/lib/loader.js!../../../../../node_modules/postcss-loader/lib/index.js??postcss!./AccountPhoneSet.scss", function() {
			var newContent = require("!!../../../../../node_modules/css-loader/index.js??ref--5-2!../../../../../node_modules/sass-loader/lib/loader.js!../../../../../node_modules/postcss-loader/lib/index.js??postcss!./AccountPhoneSet.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 879:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(698)(false);
// imports


// module
exports.push([module.i, ".account-phone-set__info{color:#adadad;text-align:center}", ""]);

// exports


/***/ }),

/***/ 880:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AccountPhoneSetOtp; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_actions_account__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_actions_otp__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_OtpPage__ = __webpack_require__(756);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_constants_app__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_helper_validation_otp_otpForm__ = __webpack_require__(766);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__AccountPhoneSetOtp_scss__ = __webpack_require__(881);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__AccountPhoneSetOtp_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__AccountPhoneSetOtp_scss__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};









var AccountPhoneSetOtpContainer = /** @class */ (function (_super) {
    __extends(AccountPhoneSetOtpContainer, _super);
    function AccountPhoneSetOtpContainer(props) {
        var _this = _super.call(this, props) || this;
        _this.onSubmit = _this.onSubmit.bind(_this);
        return _this;
    }
    AccountPhoneSetOtpContainer.prototype.render = function () {
        var _a = this.props, history = _a.history, location = _a.location, phone = _a.phone;
        if (!phone) {
            return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_router__["a" /* Redirect */], { to: "/" });
        }
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5_components_OtpPage__["a" /* OtpPage */], { form: __WEBPACK_IMPORTED_MODULE_6_constants_app__["b" /* APPLICATION_FORM_NAME */], history: history, location: location, onResendOtp: this.props.requestResend, onClose: history.goBack, onSubmit: this.onSubmit, phone: phone, validate: __WEBPACK_IMPORTED_MODULE_7_helper_validation_otp_otpForm__["a" /* validate */] }));
    };
    AccountPhoneSetOtpContainer.prototype.onSubmit = function (formValue) {
        var phone = this.props.phone;
        var fullFormValue = __assign({}, formValue, { phone: phone });
        this.props.confirmPhone(fullFormValue);
    };
    return AccountPhoneSetOtpContainer;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
var AccountPhoneSetOtp = Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function (state) { return ({
    phone: state.accountState.tempAccount.phone
}); }, { confirmPhone: __WEBPACK_IMPORTED_MODULE_3_actions_account__["d" /* confirmPhone */], requestResend: __WEBPACK_IMPORTED_MODULE_4_actions_otp__["b" /* requestResend */] })(AccountPhoneSetOtpContainer);


/***/ }),

/***/ 881:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(882);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(699)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--5-2!../../../../../node_modules/sass-loader/lib/loader.js!../../../../../node_modules/postcss-loader/lib/index.js??postcss!./AccountPhoneSetOtp.scss", function() {
			var newContent = require("!!../../../../../node_modules/css-loader/index.js??ref--5-2!../../../../../node_modules/sass-loader/lib/loader.js!../../../../../node_modules/postcss-loader/lib/index.js??postcss!./AccountPhoneSetOtp.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 882:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(698)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),

/***/ 883:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AccountProfile; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_intl__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_actions_account__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_Button__ = __webpack_require__(230);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_Initial__ = __webpack_require__(767);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_Layout__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_Wallet__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_constants_app__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_constants_wallet__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_images_index__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__AccountProfile_scss__ = __webpack_require__(884);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__AccountProfile_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__AccountProfile_scss__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();













var AccountProfileContainer = /** @class */ (function (_super) {
    __extends(AccountProfileContainer, _super);
    function AccountProfileContainer(props) {
        var _this = _super.call(this, props) || this;
        _this.profileMenu = _this.profileMenu.bind(_this);
        _this.redirectTo = _this.redirectTo.bind(_this);
        return _this;
    }
    AccountProfileContainer.prototype.componentWillMount = function () {
        var account = this.props.account;
        if (!account.email) {
            this.props.getUnverifiedEmail();
        }
    };
    AccountProfileContainer.prototype.render = function () {
        var history = this.props.history;
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "o-container" },
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7_components_Layout__["b" /* LayoutHeader */], { actionIcon: "ic-arrow-left", actionHandler: history.goBack },
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("h1", { className: "o-layout-header-title" },
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_intl__["c" /* FormattedMessage */], { id: "account.profile.title" }))),
            this.profileDetails,
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "account-profile__menus" },
                this.phoneDetailMenu,
                this.emailUpdateMenu,
                this.passwordUpdateMenu,
                this.storeUpdateMenu)));
    };
    Object.defineProperty(AccountProfileContainer.prototype, "profileDetails", {
        get: function () {
            var _a = this.props, account = _a.account, walletAccount = _a.walletAccount;
            if (walletAccount.type.id === __WEBPACK_IMPORTED_MODULE_10_constants_wallet__["d" /* WalletAccountTypeId */].PRO && account.profile) {
                var initialMaxLetter = 1;
                return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "account-profile__top-container o-container__flex-row" },
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_components_Initial__["a" /* Initial */], { className: "account-profile__initial", maxLetter: initialMaxLetter, name: account.profile.name }),
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "account-profile__name-and-city-container o-container__flex-column o-container__flex-vertical--center o-container__flex--full" },
                        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "u-medium" }, account.profile.name),
                        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8_components_Wallet__["a" /* WalletAccountTypeCard */], { className: "account-profile__wallet-account-type", walletAccountType: walletAccount.type }))));
            }
            if (walletAccount.type.id === __WEBPACK_IMPORTED_MODULE_10_constants_wallet__["d" /* WalletAccountTypeId */].LITE) {
                return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "account-profile__get-kaspay-pro-container o-container o-container--fluid o-container--fluid-vertical o-container__flex-column" },
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("img", { className: "account-profile__get-kaspay-pro-image", alt: "profile sample ktp", src: __WEBPACK_IMPORTED_MODULE_11_images_index__["s" /* ImageProfileSampleKtp */] }),
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("span", { className: "o-subhead u-medium" },
                        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_intl__["c" /* FormattedMessage */], { id: "account.profile.kaspay.pro" })),
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("p", { className: "account-profile__get-kaspay-pro-text" },
                        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_intl__["c" /* FormattedMessage */], { id: "account.profile.get.kaspay.pro" })),
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5_components_Button__["a" /* Button */], { className: "button--primary button--full", type: "button", onClick: this.redirectTo(__WEBPACK_IMPORTED_MODULE_9_constants_app__["g" /* ROUTE_ACCOUNT_KYC_OVERVIEW */]) },
                        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_intl__["c" /* FormattedMessage */], { id: "account.profile.see.more.button" }))));
            }
            return null;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AccountProfileContainer.prototype, "phoneDetailMenu", {
        get: function () {
            var props = {
                label: 'account.profile.phonenumber',
                redirectTo: __WEBPACK_IMPORTED_MODULE_9_constants_app__["m" /* ROUTE_ACCOUNT_PHONE_DETAIL */],
                value: this.props.account.phone
            };
            return this.profileMenu(props);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AccountProfileContainer.prototype, "emailUpdateMenu", {
        get: function () {
            var _a = this.props.account, email = _a.email, unverifiedEmail = _a.unverifiedEmail;
            if (!email && unverifiedEmail) {
                var unverifiedProps = {
                    footnote: 'account.profile.email.verify.footnote',
                    info: 'account.profile.email.verify',
                    isError: true,
                    label: 'account.profile.email',
                    redirectTo: __WEBPACK_IMPORTED_MODULE_9_constants_app__["c" /* ROUTE_ACCOUNT_EMAIL_UNVERIFIED */],
                    value: unverifiedEmail
                };
                return this.profileMenu(unverifiedProps);
            }
            var props = {
                iconClassName: 'ic-edit',
                label: 'account.profile.email',
                redirectTo: __WEBPACK_IMPORTED_MODULE_9_constants_app__["d" /* ROUTE_ACCOUNT_EMAIL_UPDATE */],
                value: email
            };
            return this.profileMenu(props);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AccountProfileContainer.prototype, "passwordUpdateMenu", {
        get: function () {
            var props = {
                iconClassName: 'ic-edit',
                label: 'account.profile.password',
                redirectTo: __WEBPACK_IMPORTED_MODULE_9_constants_app__["l" /* ROUTE_ACCOUNT_PASSWORD_UPDATE */]
            };
            return this.profileMenu(props);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AccountProfileContainer.prototype, "storeUpdateMenu", {
        get: function () {
            var store = this.props.account.store;
            if (store) {
                var editProps = {
                    iconClassName: 'ic-edit',
                    label: 'account.profile.store',
                    redirectTo: __WEBPACK_IMPORTED_MODULE_9_constants_app__["s" /* ROUTE_ACCOUNT_STORE_UPDATE */],
                    value: store.storeName
                };
                return this.profileMenu(editProps);
            }
            var props = {
                iconClassName: 'account-profile__menu-action-icon--blue ic-plus-circle',
                label: 'account.profile.store',
                redirectTo: __WEBPACK_IMPORTED_MODULE_9_constants_app__["s" /* ROUTE_ACCOUNT_STORE_UPDATE */]
            };
            return this.profileMenu(props);
        },
        enumerable: true,
        configurable: true
    });
    AccountProfileContainer.prototype.profileMenu = function (props) {
        var footnote = props.footnote, iconClassName = props.iconClassName, info = props.info, isError = props.isError, label = props.label, redirectTo = props.redirectTo, value = props.value;
        var labelClassNameModifier = !value && 'account-profile__menu-label--large';
        var footnoteModifier = isError && 'account-profile__menu-footnote--error';
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "account-profile__menu-container o-container__flex-row", onClick: this.redirectTo(redirectTo) },
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "o-container__flex--full" },
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: __WEBPACK_IMPORTED_MODULE_0_classnames__('account-profile__menu-label o-footnote-1', labelClassNameModifier) },
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_intl__["c" /* FormattedMessage */], { id: label })),
                value && __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "account-profile__menu-value" }, value),
                footnote && __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("span", { className: __WEBPACK_IMPORTED_MODULE_0_classnames__(footnoteModifier, 'o-footnote-1') },
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_intl__["c" /* FormattedMessage */], { id: footnote }))),
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "o-container__flex-row o-container__flex--center" },
                iconClassName && __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("i", { className: __WEBPACK_IMPORTED_MODULE_0_classnames__(iconClassName, 'account-profile__menu-action-icon o-icon-action') }),
                info && __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("span", { className: "account-profile__menu-info o-caption-2" },
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_intl__["c" /* FormattedMessage */], { id: info })))));
    };
    AccountProfileContainer.prototype.redirectTo = function (redirectPath) {
        var _this = this;
        return function () {
            var history = _this.props.history;
            history.push(redirectPath);
        };
    };
    return AccountProfileContainer;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));
var AccountProfile = Object(__WEBPACK_IMPORTED_MODULE_3_react_redux__["b" /* connect */])(function (state) { return ({
    account: state.accountState.account,
    walletAccount: state.walletState.accountState.walletAccount
}); }, { getUnverifiedEmail: __WEBPACK_IMPORTED_MODULE_4_actions_account__["g" /* getUnverifiedEmail */] })(AccountProfileContainer);


/***/ }),

/***/ 884:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(885);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(699)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--5-2!../../../../../node_modules/sass-loader/lib/loader.js!../../../../../node_modules/postcss-loader/lib/index.js??postcss!./AccountProfile.scss", function() {
			var newContent = require("!!../../../../../node_modules/css-loader/index.js??ref--5-2!../../../../../node_modules/sass-loader/lib/loader.js!../../../../../node_modules/postcss-loader/lib/index.js??postcss!./AccountProfile.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 885:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(698)(false);
// imports


// module
exports.push([module.i, ".account-profile__complete-profile-container{background-color:#008ddf;color:#fff;text-align:center;cursor:pointer;padding:32px 0}.account-profile__complete-profile-icon{margin-right:4px}.account-profile__top-container{background-color:#fff;padding:24px 20px}.account-profile__get-kaspay-pro-container{-ms-flex-align:center;align-items:center;text-align:center}.account-profile__get-kaspay-pro-image{margin-bottom:8px}.account-profile__get-kaspay-pro-text{margin:4px 0 12px}.account-profile__location-icon{margin-right:8px}.account-profile__update-button{height:32px;font-size:12px}.account-profile__initial{height:48px;width:48px;min-width:48px;line-height:48px;font-size:20px}.account-profile__name-and-city-container{margin-left:20px;-ms-flex-align:start;align-items:flex-start}.account-profile__wallet-account-type{margin-top:4px}.account-profile__menus{background-color:#fff}.account-profile__menu-container{padding:8px 20px;border-bottom:1px solid #e8e8e8;position:relative;cursor:pointer}.account-profile__menu-label{color:#adadad}.account-profile__menu-value{margin-top:4px;-o-text-overflow:ellipsis;text-overflow:ellipsis;overflow:hidden}.account-profile__menu-label--large{padding:12px 0;font-size:inherit}.account-profile__menu-action-icon{color:#adadad}.account-profile__menu-info{color:#fff;background-color:#008ddf;padding:2px 8px;border-radius:100px}.account-profile__menu-action-icon--blue{color:#008ddf}.account-profile__menu-footnote--error{color:#ff2e1e}", ""]);

// exports


/***/ }),

/***/ 886:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AccountRegister; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_intl__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_actions_account__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_Button__ = __webpack_require__(230);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_Footer__ = __webpack_require__(752);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_Form__ = __webpack_require__(709);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_Input__ = __webpack_require__(708);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_Layout__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_LinkWithAnalytics__ = __webpack_require__(232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_constants_analytics__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_constants_app__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_helper_analytics__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_helper_form__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_helper_redux__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_helper_validation_account_accountRegisterForm__ = __webpack_require__(887);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__AccountRegister_scss__ = __webpack_require__(888);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__AccountRegister_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__AccountRegister_scss__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};

















var AccountRegisterContainer = /** @class */ (function (_super) {
    __extends(AccountRegisterContainer, _super);
    function AccountRegisterContainer(props) {
        var _this = _super.call(this, props) || this;
        _this.onSubmit = _this.onSubmit.bind(_this);
        _this.setFieldPhoneReference = _this.setFieldPhoneReference.bind(_this);
        return _this;
    }
    AccountRegisterContainer.prototype.componentDidMount = function () {
        this.fieldPhone.getRenderedComponent().focus();
    };
    AccountRegisterContainer.prototype.render = function () {
        var _a = this.props, initialValues = _a.initialValues, intl = _a.intl;
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_components_Form__["a" /* Form */], { className: "o-container o-container--fluid o-container--fluid-vertical", form: __WEBPACK_IMPORTED_MODULE_11_constants_app__["b" /* APPLICATION_FORM_NAME */], initialValues: initialValues, onSubmit: this.onSubmit, validate: __WEBPACK_IMPORTED_MODULE_15_helper_validation_account_accountRegisterForm__["a" /* validate */] },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8_components_Layout__["e" /* LayoutTitle */], { modifier: "with-logo", title: intl.formatMessage({ id: 'account.register.title' }) }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8_components_Layout__["a" /* LayoutFooter */], null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5_components_Footer__["a" /* Footer */], null)),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7_components_Input__["d" /* FieldText */], { className: "o-form-field", component: __WEBPACK_IMPORTED_MODULE_7_components_Input__["i" /* InputText */], footnote: intl.formatMessage({ id: 'form.footnote.otp.info' }), label: intl.formatMessage({ id: 'account.register.phone' }), modifier: "cancel", name: "phone", normalize: __WEBPACK_IMPORTED_MODULE_13_helper_form__["o" /* normalizePhone */], ref: this.setFieldPhoneReference, type: "tel", withRef: true }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7_components_Input__["d" /* FieldText */], { className: "o-form-field", component: __WEBPACK_IMPORTED_MODULE_7_components_Input__["i" /* InputText */], label: intl.formatMessage({ id: 'account.register.email' }), modifier: "cancel", name: "email", type: "email" }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7_components_Input__["d" /* FieldText */], { className: "o-form-field", component: __WEBPACK_IMPORTED_MODULE_7_components_Input__["i" /* InputText */], footnote: intl.formatMessage({ id: 'form.footnote.valid.password.format' }), label: intl.formatMessage({ id: 'account.register.password' }), modifier: "visibility", name: "password", type: "password" }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_components_Button__["a" /* Button */], { type: "submit", className: "o-form-button button--full button--primary" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_intl__["c" /* FormattedMessage */], { id: "account.register.continue" })),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { className: "account-register__agreement o-footnote-1" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_intl__["c" /* FormattedMessage */], { id: "account.register.agreement.info" }),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9_components_LinkWithAnalytics__["a" /* LinkWithAnalytics */], { className: "account-register__agreement-link", to: __WEBPACK_IMPORTED_MODULE_11_constants_app__["J" /* ROUTE_STATIC_TERM */], category: __WEBPACK_IMPORTED_MODULE_10_constants_analytics__["b" /* AnalyticsEventCategory */].ACCOUNT_REGISTER, action: __WEBPACK_IMPORTED_MODULE_10_constants_analytics__["a" /* AnalyticsEventAction */].OPEN_TERMS_AND_CONDITION_PAGE },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_intl__["c" /* FormattedMessage */], { id: "account.register.agreement.link" })),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_intl__["c" /* FormattedMessage */], { id: "account.register.agreement.final" })),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "account-register__login" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_intl__["c" /* FormattedMessage */], { id: "account.register.login.pre" }),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9_components_LinkWithAnalytics__["a" /* LinkWithAnalytics */], { className: "account-register__login-link", to: __WEBPACK_IMPORTED_MODULE_11_constants_app__["E" /* ROUTE_LOGIN */], category: __WEBPACK_IMPORTED_MODULE_10_constants_analytics__["b" /* AnalyticsEventCategory */].ACCOUNT_REGISTER, action: __WEBPACK_IMPORTED_MODULE_10_constants_analytics__["a" /* AnalyticsEventAction */].OPEN_ACCOUNT_LOG_IN_PAGE },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_intl__["c" /* FormattedMessage */], { id: "account.register.login" })))));
    };
    AccountRegisterContainer.prototype.onSubmit = function (formValue) {
        Object(__WEBPACK_IMPORTED_MODULE_12_helper_analytics__["b" /* sendEvent */])({
            action: __WEBPACK_IMPORTED_MODULE_10_constants_analytics__["a" /* AnalyticsEventAction */].ACCOUNT_REGISTER,
            category: __WEBPACK_IMPORTED_MODULE_10_constants_analytics__["b" /* AnalyticsEventCategory */].ACCOUNT_REGISTER
        });
        this.props.register(formValue);
    };
    AccountRegisterContainer.prototype.setFieldPhoneReference = function (field) {
        this.fieldPhone = field;
    };
    AccountRegisterContainer = __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_14_helper_redux__["b" /* injectIntl */])()
    ], AccountRegisterContainer);
    return AccountRegisterContainer;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
var AccountRegister = Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(function (state) { return ({
    initialValues: {
        email: state.accountState.tempAccount.email,
        password: '',
        phone: state.accountState.tempAccount.phone
    }
}); }, { register: __WEBPACK_IMPORTED_MODULE_3_actions_account__["k" /* register */] })(AccountRegisterContainer);


/***/ }),

/***/ 887:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = validate;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_helper_form__ = __webpack_require__(19);

function validate(formValue) {
    var errors = {};
    if (!formValue.email) {
        errors.email = 'form.error.required';
    }
    else if (!Object(__WEBPACK_IMPORTED_MODULE_0_helper_form__["g" /* isValidEmail */])(formValue.email)) {
        errors.email = 'form.error.invalid.email.format';
    }
    if (!formValue.phone) {
        errors.phone = 'form.error.required';
    }
    else if (!Object(__WEBPACK_IMPORTED_MODULE_0_helper_form__["i" /* isValidPhone */])(formValue.phone)) {
        errors.phone = 'form.error.invalid.phone.format';
    }
    if (!formValue.password) {
        errors.password = 'form.error.required';
    }
    else if (!Object(__WEBPACK_IMPORTED_MODULE_0_helper_form__["h" /* isValidPasswordFormat */])(formValue.password)) {
        errors.password = 'form.error.invalid.password.format';
    }
    return errors;
}


/***/ }),

/***/ 888:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(889);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(699)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--5-2!../../../../../node_modules/sass-loader/lib/loader.js!../../../../../node_modules/postcss-loader/lib/index.js??postcss!./AccountRegister.scss", function() {
			var newContent = require("!!../../../../../node_modules/css-loader/index.js??ref--5-2!../../../../../node_modules/sass-loader/lib/loader.js!../../../../../node_modules/postcss-loader/lib/index.js??postcss!./AccountRegister.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 889:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(698)(false);
// imports


// module
exports.push([module.i, ".account-register__agreement{margin-top:16px}.account-register__agreement-link{margin-left:8px;margin-right:8px}.account-register__login{margin-top:36px;text-align:center}.account-register__login-link{margin-left:8px}", ""]);

// exports


/***/ }),

/***/ 890:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AccountRegisterOtp; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_actions_account__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_actions_otp__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_OtpPage__ = __webpack_require__(756);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_constants_analytics__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_constants_app__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_helper_analytics__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_helper_validation_otp_otpForm__ = __webpack_require__(766);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__AccountRegisterOtp_scss__ = __webpack_require__(891);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__AccountRegisterOtp_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__AccountRegisterOtp_scss__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};











var AccountRegisterOtpContainer = /** @class */ (function (_super) {
    __extends(AccountRegisterOtpContainer, _super);
    function AccountRegisterOtpContainer(props) {
        var _this = _super.call(this, props) || this;
        _this.onSubmit = _this.onSubmit.bind(_this);
        _this.onResendOtp = _this.onResendOtp.bind(_this);
        return _this;
    }
    AccountRegisterOtpContainer.prototype.render = function () {
        var _a = this.props, history = _a.history, location = _a.location, tempAccount = _a.tempAccount;
        if (!tempAccount.phone) {
            return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_router__["a" /* Redirect */], { to: "/" });
        }
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5_components_OtpPage__["a" /* OtpPage */], { form: __WEBPACK_IMPORTED_MODULE_7_constants_app__["b" /* APPLICATION_FORM_NAME */], history: history, location: location, onResendOtp: this.onResendOtp, onClose: history.goBack, onSubmit: this.onSubmit, phone: tempAccount.phone, validate: __WEBPACK_IMPORTED_MODULE_9_helper_validation_otp_otpForm__["a" /* validate */] }));
    };
    AccountRegisterOtpContainer.prototype.onResendOtp = function () {
        var tempAccount = this.props.tempAccount;
        Object(__WEBPACK_IMPORTED_MODULE_8_helper_analytics__["b" /* sendEvent */])({
            action: __WEBPACK_IMPORTED_MODULE_6_constants_analytics__["a" /* AnalyticsEventAction */].OTP_RESEND,
            category: __WEBPACK_IMPORTED_MODULE_6_constants_analytics__["b" /* AnalyticsEventCategory */].ACCOUNT_REGISTER_OTP
        });
        this.props.requestResend(tempAccount.phone);
    };
    AccountRegisterOtpContainer.prototype.onSubmit = function (formValue) {
        var tempAccount = this.props.tempAccount;
        var fullFormValue = __assign({}, formValue, tempAccount);
        this.props.confirmRegister(fullFormValue);
    };
    return AccountRegisterOtpContainer;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
var AccountRegisterOtp = Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function (state) { return ({
    tempAccount: state.accountState.tempAccount
}); }, { confirmRegister: __WEBPACK_IMPORTED_MODULE_3_actions_account__["e" /* confirmRegister */], requestResend: __WEBPACK_IMPORTED_MODULE_4_actions_otp__["b" /* requestResend */] })(AccountRegisterOtpContainer);


/***/ }),

/***/ 891:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(892);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(699)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--5-2!../../../../../node_modules/sass-loader/lib/loader.js!../../../../../node_modules/postcss-loader/lib/index.js??postcss!./AccountRegisterOtp.scss", function() {
			var newContent = require("!!../../../../../node_modules/css-loader/index.js??ref--5-2!../../../../../node_modules/sass-loader/lib/loader.js!../../../../../node_modules/postcss-loader/lib/index.js??postcss!./AccountRegisterOtp.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 892:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(698)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),

/***/ 893:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AccountStoreRegister; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_intl__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_actions_account__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_actions_invoice__ = __webpack_require__(234);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_AccountStoreForm__ = __webpack_require__(821);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_Layout__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_constants_analytics__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_constants_app__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_helper_analytics__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_helper_redux__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__AccountStoreRegister_scss__ = __webpack_require__(898);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__AccountStoreRegister_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__AccountStoreRegister_scss__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};












var AccountStoreRegisterContainer = /** @class */ (function (_super) {
    __extends(AccountStoreRegisterContainer, _super);
    function AccountStoreRegisterContainer(props) {
        var _this = _super.call(this, props) || this;
        _this.onSubmit = _this.onSubmit.bind(_this);
        _this.onCloseButtonClick = _this.onCloseButtonClick.bind(_this);
        return _this;
    }
    AccountStoreRegisterContainer.prototype.render = function () {
        var intl = this.props.intl;
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "o-container o-container--fluid o-container--fluid-vertical" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_components_Layout__["b" /* LayoutHeader */], { actionIcon: "ic-close", actionHandler: this.onCloseButtonClick },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h1", { className: "o-layout-header-title" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_intl__["c" /* FormattedMessage */], { id: "account.store.form.title" }))),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { className: "o-footnote-1" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_intl__["c" /* FormattedMessage */], { id: "account.store.register.message" })),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5_components_AccountStoreForm__["a" /* AccountStoreForm */], { intl: intl, onSubmit: this.onSubmit })));
    };
    AccountStoreRegisterContainer.prototype.onSubmit = function (formValue) {
        Object(__WEBPACK_IMPORTED_MODULE_9_helper_analytics__["b" /* sendEvent */])({
            action: __WEBPACK_IMPORTED_MODULE_7_constants_analytics__["a" /* AnalyticsEventAction */].ACCOUNT_REGISTER_STORE,
            category: __WEBPACK_IMPORTED_MODULE_7_constants_analytics__["b" /* AnalyticsEventCategory */].ACCOUNT_REGISTER_STORE
        });
        this.props.registerStore(formValue);
    };
    AccountStoreRegisterContainer.prototype.onCloseButtonClick = function () {
        var history = this.props.history;
        this.props.setHasNotPassedOnboarding();
        history.push(__WEBPACK_IMPORTED_MODULE_8_constants_app__["O" /* ROUTE_WALLET_DASHBOARD */]);
    };
    AccountStoreRegisterContainer = __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_10_helper_redux__["b" /* injectIntl */])()
    ], AccountStoreRegisterContainer);
    return AccountStoreRegisterContainer;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
var AccountStoreRegister = Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(null, {
    registerStore: __WEBPACK_IMPORTED_MODULE_3_actions_account__["m" /* registerStore */],
    setHasNotPassedOnboarding: __WEBPACK_IMPORTED_MODULE_4_actions_invoice__["a" /* InvoiceActionCreators */].setHasNotPassedOnboarding.create
})(AccountStoreRegisterContainer);


/***/ }),

/***/ 894:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AccountStoreForm; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_intl__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_Button__ = __webpack_require__(230);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_Form__ = __webpack_require__(709);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_Input__ = __webpack_require__(708);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_constants_app__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_helper_validation_account_accountStoreForm__ = __webpack_require__(895);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__AccountStoreForm_scss__ = __webpack_require__(896);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__AccountStoreForm_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__AccountStoreForm_scss__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();








var AccountStoreForm = /** @class */ (function (_super) {
    __extends(AccountStoreForm, _super);
    function AccountStoreForm(props) {
        var _this = _super.call(this, props) || this;
        _this.setFieldNameReference = _this.setFieldNameReference.bind(_this);
        return _this;
    }
    AccountStoreForm.prototype.componentDidMount = function () {
        if (!this.props.initialValues || (this.props.initialValues && !this.props.initialValues.name)) {
            this.fieldName.getRenderedComponent().focus();
        }
    };
    AccountStoreForm.prototype.render = function () {
        var _a = this.props, initialValues = _a.initialValues, onSubmit = _a.onSubmit;
        var formatMessage = this.props.intl.formatMessage;
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_components_Form__["a" /* Form */], { form: __WEBPACK_IMPORTED_MODULE_5_constants_app__["b" /* APPLICATION_FORM_NAME */], initialValues: initialValues, onSubmit: onSubmit, validate: __WEBPACK_IMPORTED_MODULE_6_helper_validation_account_accountStoreForm__["a" /* validate */] },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_components_Input__["a" /* FieldFile */], { className: "o-form-field", component: __WEBPACK_IMPORTED_MODULE_4_components_Input__["e" /* InputFile */], icon: "ic-camera", label: formatMessage({ id: 'account.store.form.upload.image.button' }), name: "avatar" }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_components_Input__["d" /* FieldText */], { className: "o-form-field", component: __WEBPACK_IMPORTED_MODULE_4_components_Input__["i" /* InputText */], label: formatMessage({ id: 'account.store.form.name' }), modifier: "cancel", name: "name", ref: this.setFieldNameReference, type: "text", withRef: true }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_components_Input__["d" /* FieldText */], { className: "o-form-field", component: __WEBPACK_IMPORTED_MODULE_4_components_Input__["i" /* InputText */], label: formatMessage({ id: 'account.store.form.url' }), footnote: formatMessage({ id: 'account.store.form.url.format' }), modifier: "cancel", name: "url", type: "text" }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_components_Input__["d" /* FieldText */], { className: "o-form-field", component: __WEBPACK_IMPORTED_MODULE_4_components_Input__["i" /* InputText */], label: formatMessage({ id: 'account.store.form.address' }), footnote: formatMessage({ id: 'account.store.form.address.format' }), modifier: "cancel", name: "address", type: "text" }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_components_Button__["a" /* Button */], { type: "submit", className: "o-form-button button--full button--primary" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_intl__["c" /* FormattedMessage */], { id: "account.store.form.button" }))));
    };
    AccountStoreForm.prototype.setFieldNameReference = function (field) {
        this.fieldName = field;
    };
    return AccountStoreForm;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));



/***/ }),

/***/ 895:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = validate;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_constants_image__ = __webpack_require__(231);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_helper_form__ = __webpack_require__(19);


function validate(formValue) {
    var errors = {};
    if (!formValue.name) {
        errors.name = 'form.error.required';
    }
    if (formValue.avatar && formValue.avatar.size > __WEBPACK_IMPORTED_MODULE_0_constants_image__["c" /* MAX_IMAGE_FILE_SIZE_IN_BYTES */]) {
        errors.avatar = 'form.error.image.size.limit.exceeded';
    }
    if (formValue.url && !Object(__WEBPACK_IMPORTED_MODULE_1_helper_form__["j" /* isValidUrl */])(formValue.url)) {
        errors.url = 'form.error.invalid.url.format';
    }
    if (!formValue.address) {
        errors.address = 'form.error.required';
    }
    return errors;
}


/***/ }),

/***/ 896:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(897);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(699)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--5-2!../../../node_modules/sass-loader/lib/loader.js!../../../node_modules/postcss-loader/lib/index.js??postcss!./AccountStoreForm.scss", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js??ref--5-2!../../../node_modules/sass-loader/lib/loader.js!../../../node_modules/postcss-loader/lib/index.js??postcss!./AccountStoreForm.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 897:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(698)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),

/***/ 898:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(899);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(699)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--5-2!../../../../../node_modules/sass-loader/lib/loader.js!../../../../../node_modules/postcss-loader/lib/index.js??postcss!./AccountStoreRegister.scss", function() {
			var newContent = require("!!../../../../../node_modules/css-loader/index.js??ref--5-2!../../../../../node_modules/sass-loader/lib/loader.js!../../../../../node_modules/postcss-loader/lib/index.js??postcss!./AccountStoreRegister.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 899:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(698)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),

/***/ 900:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AccountStoreUpdate; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_intl__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_actions_account__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_AccountStoreForm__ = __webpack_require__(821);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_Layout__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_helper_redux__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__AccountStoreUpdate_scss__ = __webpack_require__(901);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__AccountStoreUpdate_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__AccountStoreUpdate_scss__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};








var AccountStoreUpdateContainer = /** @class */ (function (_super) {
    __extends(AccountStoreUpdateContainer, _super);
    function AccountStoreUpdateContainer() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AccountStoreUpdateContainer.prototype.render = function () {
        var _a = this.props, history = _a.history, initialValues = _a.initialValues, intl = _a.intl;
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "o-container o-container--fluid o-container--fluid-vertical" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5_components_Layout__["b" /* LayoutHeader */], { actionIcon: "ic-close", actionHandler: history.goBack },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h1", { className: "o-layout-header-title" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_intl__["c" /* FormattedMessage */], { id: "account.store.form.title" }))),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_components_AccountStoreForm__["a" /* AccountStoreForm */], { intl: intl, onSubmit: this.props.updateStore, initialValues: initialValues })));
    };
    AccountStoreUpdateContainer = __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_6_helper_redux__["b" /* injectIntl */])()
    ], AccountStoreUpdateContainer);
    return AccountStoreUpdateContainer;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
var AccountStoreUpdate = Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(function (state) { return ({
    initialValues: {
        address: state.accountState.account.store && state.accountState.account.store.storeAddress,
        avatar: state.accountState.account.store && { preview: state.accountState.account.store.avatar },
        name: state.accountState.account.store && state.accountState.account.store.storeName,
        url: state.accountState.account.store && state.accountState.account.store.storeUrl
    }
}); }, { updateStore: __WEBPACK_IMPORTED_MODULE_3_actions_account__["q" /* updateStore */] })(AccountStoreUpdateContainer);


/***/ }),

/***/ 901:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(902);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(699)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--5-2!../../../../../node_modules/sass-loader/lib/loader.js!../../../../../node_modules/postcss-loader/lib/index.js??postcss!./AccountStoreUpdate.scss", function() {
			var newContent = require("!!../../../../../node_modules/css-loader/index.js??ref--5-2!../../../../../node_modules/sass-loader/lib/loader.js!../../../../../node_modules/postcss-loader/lib/index.js??postcss!./AccountStoreUpdate.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 902:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(698)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ })

});


// WEBPACK FOOTER //
// static/js/bundle.1.e4fcf1e6.chunk.js